/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as SysadminRouteImport } from './routes/sysadmin'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as RolesRouteImport } from './routes/roles'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as OrganizationsRouteImport } from './routes/organizations'
import { Route as OrganizationProfilesRouteImport } from './routes/organization-profiles'
import { Route as ModelsRouteImport } from './routes/models'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as HelpRouteImport } from './routes/help'
import { Route as EvaluationRouteImport } from './routes/evaluation'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as BrandingRouteImport } from './routes/branding'
import { Route as AutomateRouteImport } from './routes/automate'
import { Route as AskArgusRouteImport } from './routes/ask-argus'
import { Route as ApprovalsRouteImport } from './routes/approvals'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as TrustIndexRouteImport } from './routes/trust/index'
import { Route as SysadminIndexRouteImport } from './routes/sysadmin/index'
import { Route as StudioIndexRouteImport } from './routes/studio/index'
import { Route as SetupIndexRouteImport } from './routes/setup.index'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as InsightsIndexRouteImport } from './routes/insights/index'
import { Route as ConnectionsIndexRouteImport } from './routes/connections/index'
import { Route as AutomateIndexRouteImport } from './routes/automate/index'
import { Route as AskArgusIndexRouteImport } from './routes/ask-argus/index'
import { Route as ArgusLiveIndexRouteImport } from './routes/argus-live/index'
import { Route as ApprovalsIndexRouteImport } from './routes/approvals/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as UsersSsoRouteImport } from './routes/users/sso'
import { Route as UsersRolesRouteImport } from './routes/users/roles'
import { Route as UsersInvitationsRouteImport } from './routes/users/invitations'
import { Route as UsersGroupsRouteImport } from './routes/users/groups'
import { Route as UsersDepartmentsRouteImport } from './routes/users/departments'
import { Route as UsersActivityRouteImport } from './routes/users/activity'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as TrustViolationsRouteImport } from './routes/trust/violations'
import { Route as TrustEvidenceRouteImport } from './routes/trust/evidence'
import { Route as TrustDataFlowsRouteImport } from './routes/trust/data-flows'
import { Route as TrustAuditRouteImport } from './routes/trust/audit'
import { Route as TrustAiSystemsRouteImport } from './routes/trust/ai-systems'
import { Route as TrustActivityRouteImport } from './routes/trust/activity'
import { Route as SysadminTenantsRouteImport } from './routes/sysadmin/tenants'
import { Route as SysadminStudioRouteImport } from './routes/sysadmin/studio'
import { Route as SysadminSettingsRouteImport } from './routes/sysadmin/settings'
import { Route as SysadminRuntimeRouteImport } from './routes/sysadmin/runtime'
import { Route as SysadminPlatformRouteImport } from './routes/sysadmin/platform'
import { Route as SysadminModelsRouteImport } from './routes/sysadmin/models'
import { Route as SysadminLibraryRouteImport } from './routes/sysadmin/library'
import { Route as SysadminGovernanceRouteImport } from './routes/sysadmin/governance'
import { Route as SysadminFineTuningRouteImport } from './routes/sysadmin/fine-tuning'
import { Route as SysadminCatalogRouteImport } from './routes/sysadmin/catalog'
import { Route as SysadminBrandingRouteImport } from './routes/sysadmin/branding'
import { Route as SysadminAuditChainRouteImport } from './routes/sysadmin/audit-chain'
import { Route as SysadminAuditRouteImport } from './routes/sysadmin/audit'
import { Route as SysadminAdminsRouteImport } from './routes/sysadmin/admins'
import { Route as SysadminAdministratorsRouteImport } from './routes/sysadmin/administrators'
import { Route as StudioToolsRouteImport } from './routes/studio/tools'
import { Route as StudioTemplatesRouteImport } from './routes/studio/templates'
import { Route as StudioSkillsRouteImport } from './routes/studio/skills'
import { Route as StudioPromptsRouteImport } from './routes/studio/prompts'
import { Route as StudioFunctionsRouteImport } from './routes/studio/functions'
import { Route as StudioBundlesRouteImport } from './routes/studio/bundles'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'
import { Route as SetupTokenRouteImport } from './routes/setup.$token'
import { Route as OrganizationsOrgIdRouteImport } from './routes/organizations/$orgId'
import { Route as LibraryWikiRouteImport } from './routes/library/wiki'
import { Route as LibrarySystemRouteImport } from './routes/library/system'
import { Route as LibrarySharedRouteImport } from './routes/library/shared'
import { Route as LibrarySearchRouteImport } from './routes/library/search'
import { Route as LibraryQualityRouteImport } from './routes/library/quality'
import { Route as LibraryFoldersRouteImport } from './routes/library/folders'
import { Route as LibraryDocumentsRouteImport } from './routes/library/documents'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as InsightsValueRouteImport } from './routes/insights/value'
import { Route as InsightsRiskRouteImport } from './routes/insights/risk'
import { Route as InsightsQualityRouteImport } from './routes/insights/quality'
import { Route as InsightsCostRouteImport } from './routes/insights/cost'
import { Route as InsightsAgentsKnowledgeRouteImport } from './routes/insights/agents-knowledge'
import { Route as InsightsAdoptionRouteImport } from './routes/insights/adoption'
import { Route as ConnectionsNewMcpRouteImport } from './routes/connections/new-mcp'
import { Route as ConnectionsNewFunctionRouteImport } from './routes/connections/new-function'
import { Route as ConnectionsNewApiRouteImport } from './routes/connections/new-api'
import { Route as ConnectionsMcpRouteImport } from './routes/connections/mcp'
import { Route as ConnectionsMarketplaceRouteImport } from './routes/connections/marketplace'
import { Route as ConnectionsHealthRouteImport } from './routes/connections/health'
import { Route as ConnectionsFunctionsRouteImport } from './routes/connections/functions'
import { Route as ConnectionsApiRouteImport } from './routes/connections/api'
import { Route as ConnectionsConnectionIdRouteImport } from './routes/connections/$connectionId'
import { Route as AutomatePlaybooksRouteImport } from './routes/automate/playbooks'
import { Route as AutomateNodesRouteImport } from './routes/automate/nodes'
import { Route as AutomateNewRouteImport } from './routes/automate/new'
import { Route as AutomateHistoryRouteImport } from './routes/automate/history'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AskArgusProjectsRouteImport } from './routes/ask-argus/projects'
import { Route as AskArgusMemoriesRouteImport } from './routes/ask-argus/memories'
import { Route as ApprovalsSettingsRouteImport } from './routes/approvals/settings'
import { Route as ApprovalsHistoryRouteImport } from './routes/approvals/history'
import { Route as ApprovalsApprovalIdRouteImport } from './routes/approvals/$approvalId'
import { Route as AgentsNewRouteImport } from './routes/agents/new'
import { Route as AgentsGalleryRouteImport } from './routes/agents/gallery'
import { Route as AgentsBuilderRouteImport } from './routes/agents/builder'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminSecurityRouteImport } from './routes/admin/security'
import { Route as AdminPlaygroundRouteImport } from './routes/admin/playground'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminHelperBudgetsRouteImport } from './routes/admin/helper-budgets'
import { Route as AdminHealthRouteImport } from './routes/admin/health'
import { Route as AdminBrandingRouteImport } from './routes/admin/branding'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as TrustFrameworksIndexRouteImport } from './routes/trust/frameworks/index'
import { Route as SysadminTenantsIndexRouteImport } from './routes/sysadmin/tenants/index'
import { Route as SysadminStudioIndexRouteImport } from './routes/sysadmin/studio/index'
import { Route as SysadminSettingsIndexRouteImport } from './routes/sysadmin/settings.index'
import { Route as SysadminRuntimeIndexRouteImport } from './routes/sysadmin/runtime.index'
import { Route as SysadminPlatformIndexRouteImport } from './routes/sysadmin/platform.index'
import { Route as SysadminModelsIndexRouteImport } from './routes/sysadmin/models/index'
import { Route as SysadminLibraryIndexRouteImport } from './routes/sysadmin/library.index'
import { Route as SysadminGovernanceIndexRouteImport } from './routes/sysadmin/governance.index'
import { Route as SysadminFineTuningIndexRouteImport } from './routes/sysadmin/fine-tuning.index'
import { Route as SysadminCatalogIndexRouteImport } from './routes/sysadmin/catalog.index'
import { Route as SysadminAuditIndexRouteImport } from './routes/sysadmin/audit.index'
import { Route as SysadminAdministratorsIndexRouteImport } from './routes/sysadmin/administrators.index'
import { Route as StudioToolsIndexRouteImport } from './routes/studio/tools.index'
import { Route as StudioSkillsIndexRouteImport } from './routes/studio/skills.index'
import { Route as StudioPromptsIndexRouteImport } from './routes/studio/prompts.index'
import { Route as StudioBundlesIndexRouteImport } from './routes/studio/bundles.index'
import { Route as LibrarySourcesIndexRouteImport } from './routes/library/sources/index'
import { Route as AgentsAgentIdIndexRouteImport } from './routes/agents/$agentId/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminSecurityIndexRouteImport } from './routes/admin/security/index'
import { Route as AdminNotificationsIndexRouteImport } from './routes/admin/notifications/index'
import { Route as AdminHealthIndexRouteImport } from './routes/admin/health/index'
import { Route as AdminDiscoverIndexRouteImport } from './routes/admin/discover/index'
import { Route as AdminAuditIndexRouteImport } from './routes/admin/audit/index'
import { Route as UsersGroupsGroupIdRouteImport } from './routes/users/groups.$groupId'
import { Route as TrustFrameworksFrameworkIdRouteImport } from './routes/trust/frameworks/$frameworkId'
import { Route as SysadminTenantsTenantIdRouteImport } from './routes/sysadmin/tenants.$tenantId'
import { Route as SysadminStudioToolsRouteImport } from './routes/sysadmin/studio/tools'
import { Route as SysadminStudioSkillsRouteImport } from './routes/sysadmin/studio/skills'
import { Route as SysadminStudioPromptsRouteImport } from './routes/sysadmin/studio/prompts'
import { Route as SysadminStudioCategoriesRouteImport } from './routes/sysadmin/studio/categories'
import { Route as SysadminStudioAgentsRouteImport } from './routes/sysadmin/studio/agents'
import { Route as SysadminSettingsNotificationsRouteImport } from './routes/sysadmin/settings.notifications'
import { Route as SysadminSettingsIdpRouteImport } from './routes/sysadmin/settings.idp'
import { Route as SysadminSettingsEmailRouteImport } from './routes/sysadmin/settings.email'
import { Route as SysadminSettingsApiRouteImport } from './routes/sysadmin/settings.api'
import { Route as SysadminRuntimeStorageRouteImport } from './routes/sysadmin/runtime.storage'
import { Route as SysadminRuntimeQueuesRouteImport } from './routes/sysadmin/runtime.queues'
import { Route as SysadminRuntimeMcpRouteImport } from './routes/sysadmin/runtime.mcp'
import { Route as SysadminRuntimeInferenceRouteImport } from './routes/sysadmin/runtime.inference'
import { Route as SysadminRuntimeHealthRouteImport } from './routes/sysadmin/runtime.health'
import { Route as SysadminRuntimeHardwareRouteImport } from './routes/sysadmin/runtime.hardware'
import { Route as SysadminPlatformUpdatesRouteImport } from './routes/sysadmin/platform.updates'
import { Route as SysadminPlatformLicenseRouteImport } from './routes/sysadmin/platform.license'
import { Route as SysadminPlatformKeysRouteImport } from './routes/sysadmin/platform.keys'
import { Route as SysadminPlatformHelperBudgetsRouteImport } from './routes/sysadmin/platform.helper-budgets'
import { Route as SysadminPlatformHardwareProfilesRouteImport } from './routes/sysadmin/platform.hardware-profiles'
import { Route as SysadminPlatformDeploymentRouteImport } from './routes/sysadmin/platform.deployment'
import { Route as SysadminPlatformBuilderAnalyticsRouteImport } from './routes/sysadmin/platform.builder-analytics'
import { Route as SysadminPlatformBackupsRouteImport } from './routes/sysadmin/platform.backups'
import { Route as SysadminPlatformAirgapRouteImport } from './routes/sysadmin/platform.airgap'
import { Route as SysadminModelsTrustTogglesRouteImport } from './routes/sysadmin/models.trust-toggles'
import { Route as SysadminModelsRuntimeRouteImport } from './routes/sysadmin/models.runtime'
import { Route as SysadminModelsNewRouteImport } from './routes/sysadmin/models.new'
import { Route as SysadminModelsHistoryRouteImport } from './routes/sysadmin/models.history'
import { Route as SysadminModelsFunctionsRouteImport } from './routes/sysadmin/models.functions'
import { Route as SysadminModelsAssignmentsRouteImport } from './routes/sysadmin/models.assignments'
import { Route as SysadminModelsIdRouteImport } from './routes/sysadmin/models/$id'
import { Route as SysadminLibraryTagsRouteImport } from './routes/sysadmin/library.tags'
import { Route as SysadminLibrarySourcesRouteImport } from './routes/sysadmin/library.sources'
import { Route as SysadminLibraryFoldersRouteImport } from './routes/sysadmin/library.folders'
import { Route as SysadminLibraryDocumentsRouteImport } from './routes/sysadmin/library.documents'
import { Route as SysadminLibraryDocumentFoldersRouteImport } from './routes/sysadmin/library.document-folders'
import { Route as SysadminLibraryArticlesRouteImport } from './routes/sysadmin/library.articles'
import { Route as SysadminGovernancePiiRouteImport } from './routes/sysadmin/governance.pii'
import { Route as SysadminGovernanceGuardrailsRouteImport } from './routes/sysadmin/governance.guardrails'
import { Route as SysadminGovernanceComplianceRouteImport } from './routes/sysadmin/governance.compliance'
import { Route as SysadminGovernanceClassificationRouteImport } from './routes/sysadmin/governance.classification'
import { Route as SysadminGovernanceApprovalsRouteImport } from './routes/sysadmin/governance.approvals'
import { Route as SysadminFineTuningTrainingDataRouteImport } from './routes/sysadmin/fine-tuning.training-data'
import { Route as SysadminFineTuningGoldenSetRouteImport } from './routes/sysadmin/fine-tuning.golden-set'
import { Route as SysadminFineTuningEvaluationRouteImport } from './routes/sysadmin/fine-tuning.evaluation'
import { Route as SysadminFineTuningAdaptersRouteImport } from './routes/sysadmin/fine-tuning.adapters'
import { Route as SysadminCatalogWorkflowsRouteImport } from './routes/sysadmin/catalog.workflows'
import { Route as SysadminCatalogToolsRouteImport } from './routes/sysadmin/catalog.tools'
import { Route as SysadminCatalogSkillsRouteImport } from './routes/sysadmin/catalog.skills'
import { Route as SysadminCatalogPromptsRouteImport } from './routes/sysadmin/catalog.prompts'
import { Route as SysadminCatalogModelsRouteImport } from './routes/sysadmin/catalog.models'
import { Route as SysadminCatalogMcpRouteImport } from './routes/sysadmin/catalog.mcp'
import { Route as SysadminCatalogKnowledgeRouteImport } from './routes/sysadmin/catalog.knowledge'
import { Route as SysadminCatalogFunctionsRouteImport } from './routes/sysadmin/catalog.functions'
import { Route as SysadminCatalogAssignmentsRouteImport } from './routes/sysadmin/catalog.assignments'
import { Route as SysadminCatalogArgusLiveRouteImport } from './routes/sysadmin/catalog.argus-live'
import { Route as SysadminCatalogAgentsRouteImport } from './routes/sysadmin/catalog.agents'
import { Route as SysadminAuditWitnessRouteImport } from './routes/sysadmin/audit.witness'
import { Route as SysadminAuditSysadminRouteImport } from './routes/sysadmin/audit.sysadmin'
import { Route as SysadminAuditStreamRouteImport } from './routes/sysadmin/audit.stream'
import { Route as SysadminAuditIntegrityRouteImport } from './routes/sysadmin/audit.integrity'
import { Route as SysadminAuditExportsRouteImport } from './routes/sysadmin/audit.exports'
import { Route as SysadminAdministratorsSessionsRouteImport } from './routes/sysadmin/administrators.sessions'
import { Route as SysadminAdministratorsActivityRouteImport } from './routes/sysadmin/administrators.activity'
import { Route as StudioToolsNewRouteImport } from './routes/studio/tools.new'
import { Route as StudioToolsToolIdRouteImport } from './routes/studio/tools.$toolId'
import { Route as StudioSkillsSkillIdRouteImport } from './routes/studio/skills.$skillId'
import { Route as StudioPromptsPromptIdRouteImport } from './routes/studio/prompts.$promptId'
import { Route as StudioBundlesNewRouteImport } from './routes/studio/bundles.new'
import { Route as StudioBundlesIdRouteImport } from './routes/studio/bundles.$id'
import { Route as LibraryWikiNewRouteImport } from './routes/library/wiki.new'
import { Route as LibraryWikiArticleIdRouteImport } from './routes/library/wiki.$articleId'
import { Route as LibrarySourcesConnectRouteImport } from './routes/library/sources/connect'
import { Route as LibrarySourcesSourceIdRouteImport } from './routes/library/sources/$sourceId'
import { Route as LibraryDocDocIdRouteImport } from './routes/library/doc.$docId'
import { Route as LibraryArticleArticleIdRouteImport } from './routes/library/article.$articleId'
import { Route as ConnectionsMcpMarketplaceRouteImport } from './routes/connections/mcp.marketplace'
import { Route as ConnectionsMcpConnectionIdRouteImport } from './routes/connections/mcp.$connectionId'
import { Route as ConnectionsFunctionsNewRouteImport } from './routes/connections/functions.new'
import { Route as ConnectionsFunctionsFunctionIdRouteImport } from './routes/connections/functions.$functionId'
import { Route as ConnectionsApiNewRouteImport } from './routes/connections/api.new'
import { Route as ConnectionsApiConnectionIdRouteImport } from './routes/connections/api.$connectionId'
import { Route as AutomateWorkflowsIdRouteImport } from './routes/automate/workflows.$id'
import { Route as AutomatePlaybooksPlaybookIdRouteImport } from './routes/automate/playbooks.$playbookId'
import { Route as AutomateHistoryExecutionIdRouteImport } from './routes/automate/history.$executionId'
import { Route as AskArgusProjectProjectIdRouteImport } from './routes/ask-argus/project.$projectId'
import { Route as ArgusLiveDashboardsNewRouteImport } from './routes/argus-live/dashboards.new'
import { Route as ArgusLiveDashboardsIdRouteImport } from './routes/argus-live/dashboards.$id'
import { Route as AgentsAgentIdEditRouteImport } from './routes/agents/$agentId/edit'
import { Route as AdminSettingsIntegrationsRouteImport } from './routes/admin/settings/integrations'
import { Route as AdminSettingsDataRouteImport } from './routes/admin/settings/data'
import { Route as AdminSettingsComplianceRouteImport } from './routes/admin/settings/compliance'
import { Route as AdminSettingsApiRouteImport } from './routes/admin/settings/api'
import { Route as AdminSecurityThreatRouteImport } from './routes/admin/security/threat'
import { Route as AdminSecuritySessionRouteImport } from './routes/admin/security/session'
import { Route as AdminSecurityPrivilegedRouteImport } from './routes/admin/security/privileged'
import { Route as AdminSecurityKeysRouteImport } from './routes/admin/security/keys'
import { Route as AdminNotificationsLogRouteImport } from './routes/admin/notifications/log'
import { Route as AdminNotificationsEscalationRouteImport } from './routes/admin/notifications/escalation'
import { Route as AdminNotificationsChannelsRouteImport } from './routes/admin/notifications/channels'
import { Route as AdminHealthServicesRouteImport } from './routes/admin/health/services'
import { Route as AdminHealthPipelineRouteImport } from './routes/admin/health/pipeline'
import { Route as AdminHealthInfraRouteImport } from './routes/admin/health/infra'
import { Route as AdminDiscoverToolsRouteImport } from './routes/admin/discover/tools'
import { Route as AdminDiscoverSkillsRouteImport } from './routes/admin/discover/skills'
import { Route as AdminDiscoverPromptsRouteImport } from './routes/admin/discover/prompts'
import { Route as AdminDiscoverFunctionsRouteImport } from './routes/admin/discover/functions'
import { Route as AdminDiscoverConnectionsRouteImport } from './routes/admin/discover/connections'
import { Route as AdminDiscoverAgentsRouteImport } from './routes/admin/discover/agents'
import { Route as AdminAuditIntegrityRouteImport } from './routes/admin/audit/integrity'
import { Route as AdminAuditChangesRouteImport } from './routes/admin/audit/changes'
import { Route as SysadminTenantsTenantIdIndexRouteImport } from './routes/sysadmin/tenants.$tenantId.index'
import { Route as SysadminCatalogWorkflowsIndexRouteImport } from './routes/sysadmin/catalog.workflows.index'
import { Route as SysadminCatalogToolsIndexRouteImport } from './routes/sysadmin/catalog.tools.index'
import { Route as SysadminCatalogSkillsIndexRouteImport } from './routes/sysadmin/catalog.skills.index'
import { Route as SysadminCatalogMcpIndexRouteImport } from './routes/sysadmin/catalog.mcp.index'
import { Route as SysadminCatalogFunctionsIndexRouteImport } from './routes/sysadmin/catalog.functions.index'
import { Route as SysadminCatalogArgusLiveIndexRouteImport } from './routes/sysadmin/catalog.argus-live.index'
import { Route as SysadminCatalogAgentsIndexRouteImport } from './routes/sysadmin/catalog.agents.index'
import { Route as ArgusLiveDashboardsIdIndexRouteImport } from './routes/argus-live/dashboards.$id.index'
import { Route as SysadminTenantsTenantIdUsersRouteImport } from './routes/sysadmin/tenants.$tenantId.users'
import { Route as SysadminTenantsTenantIdSettingsRouteImport } from './routes/sysadmin/tenants.$tenantId.settings'
import { Route as SysadminTenantsTenantIdMemoryRouteImport } from './routes/sysadmin/tenants.$tenantId.memory'
import { Route as SysadminTenantsTenantIdLimitsRouteImport } from './routes/sysadmin/tenants.$tenantId.limits'
import { Route as SysadminTenantsTenantIdHardwareRouteImport } from './routes/sysadmin/tenants.$tenantId.hardware'
import { Route as SysadminTenantsTenantIdComplianceRouteImport } from './routes/sysadmin/tenants.$tenantId.compliance'
import { Route as SysadminTenantsTenantIdBrandingRouteImport } from './routes/sysadmin/tenants.$tenantId.branding'
import { Route as SysadminTenantsTenantIdAuditRouteImport } from './routes/sysadmin/tenants.$tenantId.audit'
import { Route as SysadminTenantsTenantIdAssignmentsRouteImport } from './routes/sysadmin/tenants.$tenantId.assignments'
import { Route as SysadminCatalogWorkflowsIdRouteImport } from './routes/sysadmin/catalog.workflows.$id'
import { Route as SysadminCatalogToolsNewRouteImport } from './routes/sysadmin/catalog.tools.new'
import { Route as SysadminCatalogToolsIdRouteImport } from './routes/sysadmin/catalog.tools.$id'
import { Route as SysadminCatalogSkillsIdRouteImport } from './routes/sysadmin/catalog.skills.$id'
import { Route as SysadminCatalogMcpNewRouteImport } from './routes/sysadmin/catalog.mcp.new'
import { Route as SysadminCatalogMcpIdRouteImport } from './routes/sysadmin/catalog.mcp.$id'
import { Route as SysadminCatalogFunctionsNewRouteImport } from './routes/sysadmin/catalog.functions.new'
import { Route as SysadminCatalogArgusLiveIdRouteImport } from './routes/sysadmin/catalog.argus-live.$id'
import { Route as SysadminCatalogAgentsNewRouteImport } from './routes/sysadmin/catalog.agents.new'
import { Route as SysadminCatalogAgentsBuilderRouteImport } from './routes/sysadmin/catalog.agents.builder'
import { Route as SysadminCatalogAgentsIdRouteImport } from './routes/sysadmin/catalog.agents.$id'
import { Route as LibraryWikiArticleIdEditRouteImport } from './routes/library/wiki.$articleId.edit'
import { Route as ArgusLiveDashboardsIdEditRouteImport } from './routes/argus-live/dashboards.$id.edit'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustRoute = TrustRouteImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => rootRouteImport,
} as any)
const SysadminRoute = SysadminRouteImport.update({
  id: '/sysadmin',
  path: '/sysadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesRoute = RolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationProfilesRoute = OrganizationProfilesRouteImport.update({
  id: '/organization-profiles',
  path: '/organization-profiles',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelsRoute = ModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => rootRouteImport,
} as any)
const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsRoute = InsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationRoute = EvaluationRouteImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsRoute = ConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandingRoute = BrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomateRoute = AutomateRouteImport.update({
  id: '/automate',
  path: '/automate',
  getParentRoute: () => rootRouteImport,
} as any)
const AskArgusRoute = AskArgusRouteImport.update({
  id: '/ask-argus',
  path: '/ask-argus',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRoute,
} as any)
const TrustIndexRoute = TrustIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TrustRoute,
} as any)
const SysadminIndexRoute = SysadminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminRoute,
} as any)
const StudioIndexRoute = StudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioRoute,
} as any)
const SetupIndexRoute = SetupIndexRouteImport.update({
  id: '/setup/',
  path: '/setup/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationsRoute,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraryRoute,
} as any)
const InsightsIndexRoute = InsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InsightsRoute,
} as any)
const ConnectionsIndexRoute = ConnectionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConnectionsRoute,
} as any)
const AutomateIndexRoute = AutomateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AutomateRoute,
} as any)
const AskArgusIndexRoute = AskArgusIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AskArgusRoute,
} as any)
const ArgusLiveIndexRoute = ArgusLiveIndexRouteImport.update({
  id: '/argus-live/',
  path: '/argus-live/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsIndexRoute = ApprovalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApprovalsRoute,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRoute,
} as any)
const UsersSsoRoute = UsersSsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => UsersRoute,
} as any)
const UsersRolesRoute = UsersRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => UsersRoute,
} as any)
const UsersInvitationsRoute = UsersInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => UsersRoute,
} as any)
const UsersGroupsRoute = UsersGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => UsersRoute,
} as any)
const UsersDepartmentsRoute = UsersDepartmentsRouteImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => UsersRoute,
} as any)
const UsersActivityRoute = UsersActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => UsersRoute,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => UsersRoute,
} as any)
const TrustViolationsRoute = TrustViolationsRouteImport.update({
  id: '/violations',
  path: '/violations',
  getParentRoute: () => TrustRoute,
} as any)
const TrustEvidenceRoute = TrustEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => TrustRoute,
} as any)
const TrustDataFlowsRoute = TrustDataFlowsRouteImport.update({
  id: '/data-flows',
  path: '/data-flows',
  getParentRoute: () => TrustRoute,
} as any)
const TrustAuditRoute = TrustAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => TrustRoute,
} as any)
const TrustAiSystemsRoute = TrustAiSystemsRouteImport.update({
  id: '/ai-systems',
  path: '/ai-systems',
  getParentRoute: () => TrustRoute,
} as any)
const TrustActivityRoute = TrustActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => TrustRoute,
} as any)
const SysadminTenantsRoute = SysadminTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminStudioRoute = SysadminStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminSettingsRoute = SysadminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminRuntimeRoute = SysadminRuntimeRouteImport.update({
  id: '/runtime',
  path: '/runtime',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminPlatformRoute = SysadminPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminModelsRoute = SysadminModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminLibraryRoute = SysadminLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminGovernanceRoute = SysadminGovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminFineTuningRoute = SysadminFineTuningRouteImport.update({
  id: '/fine-tuning',
  path: '/fine-tuning',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminCatalogRoute = SysadminCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminBrandingRoute = SysadminBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminAuditChainRoute = SysadminAuditChainRouteImport.update({
  id: '/audit-chain',
  path: '/audit-chain',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminAuditRoute = SysadminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminAdminsRoute = SysadminAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => SysadminRoute,
} as any)
const SysadminAdministratorsRoute = SysadminAdministratorsRouteImport.update({
  id: '/administrators',
  path: '/administrators',
  getParentRoute: () => SysadminRoute,
} as any)
const StudioToolsRoute = StudioToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => StudioRoute,
} as any)
const StudioTemplatesRoute = StudioTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => StudioRoute,
} as any)
const StudioSkillsRoute = StudioSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => StudioRoute,
} as any)
const StudioPromptsRoute = StudioPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => StudioRoute,
} as any)
const StudioFunctionsRoute = StudioFunctionsRouteImport.update({
  id: '/functions',
  path: '/functions',
  getParentRoute: () => StudioRoute,
} as any)
const StudioBundlesRoute = StudioBundlesRouteImport.update({
  id: '/bundles',
  path: '/bundles',
  getParentRoute: () => StudioRoute,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupTokenRoute = SetupTokenRouteImport.update({
  id: '/setup/$token',
  path: '/setup/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsOrgIdRoute = OrganizationsOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => OrganizationsRoute,
} as any)
const LibraryWikiRoute = LibraryWikiRouteImport.update({
  id: '/wiki',
  path: '/wiki',
  getParentRoute: () => LibraryRoute,
} as any)
const LibrarySystemRoute = LibrarySystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => LibraryRoute,
} as any)
const LibrarySharedRoute = LibrarySharedRouteImport.update({
  id: '/shared',
  path: '/shared',
  getParentRoute: () => LibraryRoute,
} as any)
const LibrarySearchRoute = LibrarySearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => LibraryRoute,
} as any)
const LibraryQualityRoute = LibraryQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => LibraryRoute,
} as any)
const LibraryFoldersRoute = LibraryFoldersRouteImport.update({
  id: '/folders',
  path: '/folders',
  getParentRoute: () => LibraryRoute,
} as any)
const LibraryDocumentsRoute = LibraryDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => LibraryRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsValueRoute = InsightsValueRouteImport.update({
  id: '/value',
  path: '/value',
  getParentRoute: () => InsightsRoute,
} as any)
const InsightsRiskRoute = InsightsRiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => InsightsRoute,
} as any)
const InsightsQualityRoute = InsightsQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => InsightsRoute,
} as any)
const InsightsCostRoute = InsightsCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => InsightsRoute,
} as any)
const InsightsAgentsKnowledgeRoute = InsightsAgentsKnowledgeRouteImport.update({
  id: '/agents-knowledge',
  path: '/agents-knowledge',
  getParentRoute: () => InsightsRoute,
} as any)
const InsightsAdoptionRoute = InsightsAdoptionRouteImport.update({
  id: '/adoption',
  path: '/adoption',
  getParentRoute: () => InsightsRoute,
} as any)
const ConnectionsNewMcpRoute = ConnectionsNewMcpRouteImport.update({
  id: '/new-mcp',
  path: '/new-mcp',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsNewFunctionRoute = ConnectionsNewFunctionRouteImport.update({
  id: '/new-function',
  path: '/new-function',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsNewApiRoute = ConnectionsNewApiRouteImport.update({
  id: '/new-api',
  path: '/new-api',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsMcpRoute = ConnectionsMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsMarketplaceRoute = ConnectionsMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsHealthRoute = ConnectionsHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsFunctionsRoute = ConnectionsFunctionsRouteImport.update({
  id: '/functions',
  path: '/functions',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsApiRoute = ConnectionsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => ConnectionsRoute,
} as any)
const ConnectionsConnectionIdRoute = ConnectionsConnectionIdRouteImport.update({
  id: '/$connectionId',
  path: '/$connectionId',
  getParentRoute: () => ConnectionsRoute,
} as any)
const AutomatePlaybooksRoute = AutomatePlaybooksRouteImport.update({
  id: '/playbooks',
  path: '/playbooks',
  getParentRoute: () => AutomateRoute,
} as any)
const AutomateNodesRoute = AutomateNodesRouteImport.update({
  id: '/nodes',
  path: '/nodes',
  getParentRoute: () => AutomateRoute,
} as any)
const AutomateNewRoute = AutomateNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AutomateRoute,
} as any)
const AutomateHistoryRoute = AutomateHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AutomateRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AskArgusProjectsRoute = AskArgusProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AskArgusRoute,
} as any)
const AskArgusMemoriesRoute = AskArgusMemoriesRouteImport.update({
  id: '/memories',
  path: '/memories',
  getParentRoute: () => AskArgusRoute,
} as any)
const ApprovalsSettingsRoute = ApprovalsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ApprovalsRoute,
} as any)
const ApprovalsHistoryRoute = ApprovalsHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => ApprovalsRoute,
} as any)
const ApprovalsApprovalIdRoute = ApprovalsApprovalIdRouteImport.update({
  id: '/$approvalId',
  path: '/$approvalId',
  getParentRoute: () => ApprovalsRoute,
} as any)
const AgentsNewRoute = AgentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AgentsRoute,
} as any)
const AgentsGalleryRoute = AgentsGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AgentsRoute,
} as any)
const AgentsBuilderRoute = AgentsBuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => AgentsRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSecurityRoute = AdminSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlaygroundRoute = AdminPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHelperBudgetsRoute = AdminHelperBudgetsRouteImport.update({
  id: '/helper-budgets',
  path: '/helper-budgets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHealthRoute = AdminHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBrandingRoute = AdminBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const TrustFrameworksIndexRoute = TrustFrameworksIndexRouteImport.update({
  id: '/frameworks/',
  path: '/frameworks/',
  getParentRoute: () => TrustRoute,
} as any)
const SysadminTenantsIndexRoute = SysadminTenantsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminTenantsRoute,
} as any)
const SysadminStudioIndexRoute = SysadminStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminStudioRoute,
} as any)
const SysadminSettingsIndexRoute = SysadminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminSettingsRoute,
} as any)
const SysadminRuntimeIndexRoute = SysadminRuntimeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminPlatformIndexRoute = SysadminPlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminModelsIndexRoute = SysadminModelsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminLibraryIndexRoute = SysadminLibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminLibraryRoute,
} as any)
const SysadminGovernanceIndexRoute = SysadminGovernanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminGovernanceRoute,
} as any)
const SysadminFineTuningIndexRoute = SysadminFineTuningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminFineTuningRoute,
} as any)
const SysadminCatalogIndexRoute = SysadminCatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminAuditIndexRoute = SysadminAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAdministratorsIndexRoute =
  SysadminAdministratorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminAdministratorsRoute,
  } as any)
const StudioToolsIndexRoute = StudioToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioToolsRoute,
} as any)
const StudioSkillsIndexRoute = StudioSkillsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioSkillsRoute,
} as any)
const StudioPromptsIndexRoute = StudioPromptsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioPromptsRoute,
} as any)
const StudioBundlesIndexRoute = StudioBundlesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudioBundlesRoute,
} as any)
const LibrarySourcesIndexRoute = LibrarySourcesIndexRouteImport.update({
  id: '/sources/',
  path: '/sources/',
  getParentRoute: () => LibraryRoute,
} as any)
const AgentsAgentIdIndexRoute = AgentsAgentIdIndexRouteImport.update({
  id: '/$agentId/',
  path: '/$agentId/',
  getParentRoute: () => AgentsRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSecurityIndexRoute = AdminSecurityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSecurityRoute,
} as any)
const AdminNotificationsIndexRoute = AdminNotificationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminNotificationsRoute,
} as any)
const AdminHealthIndexRoute = AdminHealthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminHealthRoute,
} as any)
const AdminDiscoverIndexRoute = AdminDiscoverIndexRouteImport.update({
  id: '/discover/',
  path: '/discover/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditIndexRoute = AdminAuditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAuditRoute,
} as any)
const UsersGroupsGroupIdRoute = UsersGroupsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => UsersGroupsRoute,
} as any)
const TrustFrameworksFrameworkIdRoute =
  TrustFrameworksFrameworkIdRouteImport.update({
    id: '/frameworks/$frameworkId',
    path: '/frameworks/$frameworkId',
    getParentRoute: () => TrustRoute,
  } as any)
const SysadminTenantsTenantIdRoute = SysadminTenantsTenantIdRouteImport.update({
  id: '/$tenantId',
  path: '/$tenantId',
  getParentRoute: () => SysadminTenantsRoute,
} as any)
const SysadminStudioToolsRoute = SysadminStudioToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => SysadminStudioRoute,
} as any)
const SysadminStudioSkillsRoute = SysadminStudioSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => SysadminStudioRoute,
} as any)
const SysadminStudioPromptsRoute = SysadminStudioPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => SysadminStudioRoute,
} as any)
const SysadminStudioCategoriesRoute =
  SysadminStudioCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => SysadminStudioRoute,
  } as any)
const SysadminStudioAgentsRoute = SysadminStudioAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => SysadminStudioRoute,
} as any)
const SysadminSettingsNotificationsRoute =
  SysadminSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => SysadminSettingsRoute,
  } as any)
const SysadminSettingsIdpRoute = SysadminSettingsIdpRouteImport.update({
  id: '/idp',
  path: '/idp',
  getParentRoute: () => SysadminSettingsRoute,
} as any)
const SysadminSettingsEmailRoute = SysadminSettingsEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => SysadminSettingsRoute,
} as any)
const SysadminSettingsApiRoute = SysadminSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => SysadminSettingsRoute,
} as any)
const SysadminRuntimeStorageRoute = SysadminRuntimeStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminRuntimeQueuesRoute = SysadminRuntimeQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminRuntimeMcpRoute = SysadminRuntimeMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminRuntimeInferenceRoute =
  SysadminRuntimeInferenceRouteImport.update({
    id: '/inference',
    path: '/inference',
    getParentRoute: () => SysadminRuntimeRoute,
  } as any)
const SysadminRuntimeHealthRoute = SysadminRuntimeHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminRuntimeHardwareRoute = SysadminRuntimeHardwareRouteImport.update({
  id: '/hardware',
  path: '/hardware',
  getParentRoute: () => SysadminRuntimeRoute,
} as any)
const SysadminPlatformUpdatesRoute = SysadminPlatformUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminPlatformLicenseRoute = SysadminPlatformLicenseRouteImport.update({
  id: '/license',
  path: '/license',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminPlatformKeysRoute = SysadminPlatformKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminPlatformHelperBudgetsRoute =
  SysadminPlatformHelperBudgetsRouteImport.update({
    id: '/helper-budgets',
    path: '/helper-budgets',
    getParentRoute: () => SysadminPlatformRoute,
  } as any)
const SysadminPlatformHardwareProfilesRoute =
  SysadminPlatformHardwareProfilesRouteImport.update({
    id: '/hardware-profiles',
    path: '/hardware-profiles',
    getParentRoute: () => SysadminPlatformRoute,
  } as any)
const SysadminPlatformDeploymentRoute =
  SysadminPlatformDeploymentRouteImport.update({
    id: '/deployment',
    path: '/deployment',
    getParentRoute: () => SysadminPlatformRoute,
  } as any)
const SysadminPlatformBuilderAnalyticsRoute =
  SysadminPlatformBuilderAnalyticsRouteImport.update({
    id: '/builder-analytics',
    path: '/builder-analytics',
    getParentRoute: () => SysadminPlatformRoute,
  } as any)
const SysadminPlatformBackupsRoute = SysadminPlatformBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminPlatformAirgapRoute = SysadminPlatformAirgapRouteImport.update({
  id: '/airgap',
  path: '/airgap',
  getParentRoute: () => SysadminPlatformRoute,
} as any)
const SysadminModelsTrustTogglesRoute =
  SysadminModelsTrustTogglesRouteImport.update({
    id: '/trust-toggles',
    path: '/trust-toggles',
    getParentRoute: () => SysadminModelsRoute,
  } as any)
const SysadminModelsRuntimeRoute = SysadminModelsRuntimeRouteImport.update({
  id: '/runtime',
  path: '/runtime',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminModelsNewRoute = SysadminModelsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminModelsHistoryRoute = SysadminModelsHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminModelsFunctionsRoute = SysadminModelsFunctionsRouteImport.update({
  id: '/functions',
  path: '/functions',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminModelsAssignmentsRoute =
  SysadminModelsAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => SysadminModelsRoute,
  } as any)
const SysadminModelsIdRoute = SysadminModelsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SysadminModelsRoute,
} as any)
const SysadminLibraryTagsRoute = SysadminLibraryTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SysadminLibraryRoute,
} as any)
const SysadminLibrarySourcesRoute = SysadminLibrarySourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => SysadminLibraryRoute,
} as any)
const SysadminLibraryFoldersRoute = SysadminLibraryFoldersRouteImport.update({
  id: '/folders',
  path: '/folders',
  getParentRoute: () => SysadminLibraryRoute,
} as any)
const SysadminLibraryDocumentsRoute =
  SysadminLibraryDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => SysadminLibraryRoute,
  } as any)
const SysadminLibraryDocumentFoldersRoute =
  SysadminLibraryDocumentFoldersRouteImport.update({
    id: '/document-folders',
    path: '/document-folders',
    getParentRoute: () => SysadminLibraryRoute,
  } as any)
const SysadminLibraryArticlesRoute = SysadminLibraryArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => SysadminLibraryRoute,
} as any)
const SysadminGovernancePiiRoute = SysadminGovernancePiiRouteImport.update({
  id: '/pii',
  path: '/pii',
  getParentRoute: () => SysadminGovernanceRoute,
} as any)
const SysadminGovernanceGuardrailsRoute =
  SysadminGovernanceGuardrailsRouteImport.update({
    id: '/guardrails',
    path: '/guardrails',
    getParentRoute: () => SysadminGovernanceRoute,
  } as any)
const SysadminGovernanceComplianceRoute =
  SysadminGovernanceComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => SysadminGovernanceRoute,
  } as any)
const SysadminGovernanceClassificationRoute =
  SysadminGovernanceClassificationRouteImport.update({
    id: '/classification',
    path: '/classification',
    getParentRoute: () => SysadminGovernanceRoute,
  } as any)
const SysadminGovernanceApprovalsRoute =
  SysadminGovernanceApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => SysadminGovernanceRoute,
  } as any)
const SysadminFineTuningTrainingDataRoute =
  SysadminFineTuningTrainingDataRouteImport.update({
    id: '/training-data',
    path: '/training-data',
    getParentRoute: () => SysadminFineTuningRoute,
  } as any)
const SysadminFineTuningGoldenSetRoute =
  SysadminFineTuningGoldenSetRouteImport.update({
    id: '/golden-set',
    path: '/golden-set',
    getParentRoute: () => SysadminFineTuningRoute,
  } as any)
const SysadminFineTuningEvaluationRoute =
  SysadminFineTuningEvaluationRouteImport.update({
    id: '/evaluation',
    path: '/evaluation',
    getParentRoute: () => SysadminFineTuningRoute,
  } as any)
const SysadminFineTuningAdaptersRoute =
  SysadminFineTuningAdaptersRouteImport.update({
    id: '/adapters',
    path: '/adapters',
    getParentRoute: () => SysadminFineTuningRoute,
  } as any)
const SysadminCatalogWorkflowsRoute =
  SysadminCatalogWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => SysadminCatalogRoute,
  } as any)
const SysadminCatalogToolsRoute = SysadminCatalogToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminCatalogSkillsRoute = SysadminCatalogSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminCatalogPromptsRoute = SysadminCatalogPromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminCatalogModelsRoute = SysadminCatalogModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminCatalogMcpRoute = SysadminCatalogMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminCatalogKnowledgeRoute =
  SysadminCatalogKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => SysadminCatalogRoute,
  } as any)
const SysadminCatalogFunctionsRoute =
  SysadminCatalogFunctionsRouteImport.update({
    id: '/functions',
    path: '/functions',
    getParentRoute: () => SysadminCatalogRoute,
  } as any)
const SysadminCatalogAssignmentsRoute =
  SysadminCatalogAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => SysadminCatalogRoute,
  } as any)
const SysadminCatalogArgusLiveRoute =
  SysadminCatalogArgusLiveRouteImport.update({
    id: '/argus-live',
    path: '/argus-live',
    getParentRoute: () => SysadminCatalogRoute,
  } as any)
const SysadminCatalogAgentsRoute = SysadminCatalogAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => SysadminCatalogRoute,
} as any)
const SysadminAuditWitnessRoute = SysadminAuditWitnessRouteImport.update({
  id: '/witness',
  path: '/witness',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAuditSysadminRoute = SysadminAuditSysadminRouteImport.update({
  id: '/sysadmin',
  path: '/sysadmin',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAuditStreamRoute = SysadminAuditStreamRouteImport.update({
  id: '/stream',
  path: '/stream',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAuditIntegrityRoute = SysadminAuditIntegrityRouteImport.update({
  id: '/integrity',
  path: '/integrity',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAuditExportsRoute = SysadminAuditExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => SysadminAuditRoute,
} as any)
const SysadminAdministratorsSessionsRoute =
  SysadminAdministratorsSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => SysadminAdministratorsRoute,
  } as any)
const SysadminAdministratorsActivityRoute =
  SysadminAdministratorsActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => SysadminAdministratorsRoute,
  } as any)
const StudioToolsNewRoute = StudioToolsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => StudioToolsRoute,
} as any)
const StudioToolsToolIdRoute = StudioToolsToolIdRouteImport.update({
  id: '/$toolId',
  path: '/$toolId',
  getParentRoute: () => StudioToolsRoute,
} as any)
const StudioSkillsSkillIdRoute = StudioSkillsSkillIdRouteImport.update({
  id: '/$skillId',
  path: '/$skillId',
  getParentRoute: () => StudioSkillsRoute,
} as any)
const StudioPromptsPromptIdRoute = StudioPromptsPromptIdRouteImport.update({
  id: '/$promptId',
  path: '/$promptId',
  getParentRoute: () => StudioPromptsRoute,
} as any)
const StudioBundlesNewRoute = StudioBundlesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => StudioBundlesRoute,
} as any)
const StudioBundlesIdRoute = StudioBundlesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StudioBundlesRoute,
} as any)
const LibraryWikiNewRoute = LibraryWikiNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => LibraryWikiRoute,
} as any)
const LibraryWikiArticleIdRoute = LibraryWikiArticleIdRouteImport.update({
  id: '/$articleId',
  path: '/$articleId',
  getParentRoute: () => LibraryWikiRoute,
} as any)
const LibrarySourcesConnectRoute = LibrarySourcesConnectRouteImport.update({
  id: '/sources/connect',
  path: '/sources/connect',
  getParentRoute: () => LibraryRoute,
} as any)
const LibrarySourcesSourceIdRoute = LibrarySourcesSourceIdRouteImport.update({
  id: '/sources/$sourceId',
  path: '/sources/$sourceId',
  getParentRoute: () => LibraryRoute,
} as any)
const LibraryDocDocIdRoute = LibraryDocDocIdRouteImport.update({
  id: '/doc/$docId',
  path: '/doc/$docId',
  getParentRoute: () => LibraryRoute,
} as any)
const LibraryArticleArticleIdRoute = LibraryArticleArticleIdRouteImport.update({
  id: '/article/$articleId',
  path: '/article/$articleId',
  getParentRoute: () => LibraryRoute,
} as any)
const ConnectionsMcpMarketplaceRoute =
  ConnectionsMcpMarketplaceRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => ConnectionsMcpRoute,
  } as any)
const ConnectionsMcpConnectionIdRoute =
  ConnectionsMcpConnectionIdRouteImport.update({
    id: '/$connectionId',
    path: '/$connectionId',
    getParentRoute: () => ConnectionsMcpRoute,
  } as any)
const ConnectionsFunctionsNewRoute = ConnectionsFunctionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ConnectionsFunctionsRoute,
} as any)
const ConnectionsFunctionsFunctionIdRoute =
  ConnectionsFunctionsFunctionIdRouteImport.update({
    id: '/$functionId',
    path: '/$functionId',
    getParentRoute: () => ConnectionsFunctionsRoute,
  } as any)
const ConnectionsApiNewRoute = ConnectionsApiNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ConnectionsApiRoute,
} as any)
const ConnectionsApiConnectionIdRoute =
  ConnectionsApiConnectionIdRouteImport.update({
    id: '/$connectionId',
    path: '/$connectionId',
    getParentRoute: () => ConnectionsApiRoute,
  } as any)
const AutomateWorkflowsIdRoute = AutomateWorkflowsIdRouteImport.update({
  id: '/workflows/$id',
  path: '/workflows/$id',
  getParentRoute: () => AutomateRoute,
} as any)
const AutomatePlaybooksPlaybookIdRoute =
  AutomatePlaybooksPlaybookIdRouteImport.update({
    id: '/$playbookId',
    path: '/$playbookId',
    getParentRoute: () => AutomatePlaybooksRoute,
  } as any)
const AutomateHistoryExecutionIdRoute =
  AutomateHistoryExecutionIdRouteImport.update({
    id: '/$executionId',
    path: '/$executionId',
    getParentRoute: () => AutomateHistoryRoute,
  } as any)
const AskArgusProjectProjectIdRoute =
  AskArgusProjectProjectIdRouteImport.update({
    id: '/project/$projectId',
    path: '/project/$projectId',
    getParentRoute: () => AskArgusRoute,
  } as any)
const ArgusLiveDashboardsNewRoute = ArgusLiveDashboardsNewRouteImport.update({
  id: '/argus-live/dashboards/new',
  path: '/argus-live/dashboards/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ArgusLiveDashboardsIdRoute = ArgusLiveDashboardsIdRouteImport.update({
  id: '/argus-live/dashboards/$id',
  path: '/argus-live/dashboards/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdEditRoute = AgentsAgentIdEditRouteImport.update({
  id: '/$agentId/edit',
  path: '/$agentId/edit',
  getParentRoute: () => AgentsRoute,
} as any)
const AdminSettingsIntegrationsRoute =
  AdminSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsDataRoute = AdminSettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsComplianceRoute = AdminSettingsComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsApiRoute = AdminSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSecurityThreatRoute = AdminSecurityThreatRouteImport.update({
  id: '/threat',
  path: '/threat',
  getParentRoute: () => AdminSecurityRoute,
} as any)
const AdminSecuritySessionRoute = AdminSecuritySessionRouteImport.update({
  id: '/session',
  path: '/session',
  getParentRoute: () => AdminSecurityRoute,
} as any)
const AdminSecurityPrivilegedRoute = AdminSecurityPrivilegedRouteImport.update({
  id: '/privileged',
  path: '/privileged',
  getParentRoute: () => AdminSecurityRoute,
} as any)
const AdminSecurityKeysRoute = AdminSecurityKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AdminSecurityRoute,
} as any)
const AdminNotificationsLogRoute = AdminNotificationsLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => AdminNotificationsRoute,
} as any)
const AdminNotificationsEscalationRoute =
  AdminNotificationsEscalationRouteImport.update({
    id: '/escalation',
    path: '/escalation',
    getParentRoute: () => AdminNotificationsRoute,
  } as any)
const AdminNotificationsChannelsRoute =
  AdminNotificationsChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AdminNotificationsRoute,
  } as any)
const AdminHealthServicesRoute = AdminHealthServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AdminHealthRoute,
} as any)
const AdminHealthPipelineRoute = AdminHealthPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AdminHealthRoute,
} as any)
const AdminHealthInfraRoute = AdminHealthInfraRouteImport.update({
  id: '/infra',
  path: '/infra',
  getParentRoute: () => AdminHealthRoute,
} as any)
const AdminDiscoverToolsRoute = AdminDiscoverToolsRouteImport.update({
  id: '/discover/tools',
  path: '/discover/tools',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscoverSkillsRoute = AdminDiscoverSkillsRouteImport.update({
  id: '/discover/skills',
  path: '/discover/skills',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscoverPromptsRoute = AdminDiscoverPromptsRouteImport.update({
  id: '/discover/prompts',
  path: '/discover/prompts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscoverFunctionsRoute = AdminDiscoverFunctionsRouteImport.update({
  id: '/discover/functions',
  path: '/discover/functions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscoverConnectionsRoute =
  AdminDiscoverConnectionsRouteImport.update({
    id: '/discover/connections',
    path: '/discover/connections',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminDiscoverAgentsRoute = AdminDiscoverAgentsRouteImport.update({
  id: '/discover/agents',
  path: '/discover/agents',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditIntegrityRoute = AdminAuditIntegrityRouteImport.update({
  id: '/integrity',
  path: '/integrity',
  getParentRoute: () => AdminAuditRoute,
} as any)
const AdminAuditChangesRoute = AdminAuditChangesRouteImport.update({
  id: '/changes',
  path: '/changes',
  getParentRoute: () => AdminAuditRoute,
} as any)
const SysadminTenantsTenantIdIndexRoute =
  SysadminTenantsTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminCatalogWorkflowsIndexRoute =
  SysadminCatalogWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogWorkflowsRoute,
  } as any)
const SysadminCatalogToolsIndexRoute =
  SysadminCatalogToolsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogToolsRoute,
  } as any)
const SysadminCatalogSkillsIndexRoute =
  SysadminCatalogSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogSkillsRoute,
  } as any)
const SysadminCatalogMcpIndexRoute = SysadminCatalogMcpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysadminCatalogMcpRoute,
} as any)
const SysadminCatalogFunctionsIndexRoute =
  SysadminCatalogFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogFunctionsRoute,
  } as any)
const SysadminCatalogArgusLiveIndexRoute =
  SysadminCatalogArgusLiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogArgusLiveRoute,
  } as any)
const SysadminCatalogAgentsIndexRoute =
  SysadminCatalogAgentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SysadminCatalogAgentsRoute,
  } as any)
const ArgusLiveDashboardsIdIndexRoute =
  ArgusLiveDashboardsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ArgusLiveDashboardsIdRoute,
  } as any)
const SysadminTenantsTenantIdUsersRoute =
  SysadminTenantsTenantIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdSettingsRoute =
  SysadminTenantsTenantIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdMemoryRoute =
  SysadminTenantsTenantIdMemoryRouteImport.update({
    id: '/memory',
    path: '/memory',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdLimitsRoute =
  SysadminTenantsTenantIdLimitsRouteImport.update({
    id: '/limits',
    path: '/limits',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdHardwareRoute =
  SysadminTenantsTenantIdHardwareRouteImport.update({
    id: '/hardware',
    path: '/hardware',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdComplianceRoute =
  SysadminTenantsTenantIdComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdBrandingRoute =
  SysadminTenantsTenantIdBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdAuditRoute =
  SysadminTenantsTenantIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminTenantsTenantIdAssignmentsRoute =
  SysadminTenantsTenantIdAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => SysadminTenantsTenantIdRoute,
  } as any)
const SysadminCatalogWorkflowsIdRoute =
  SysadminCatalogWorkflowsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SysadminCatalogWorkflowsRoute,
  } as any)
const SysadminCatalogToolsNewRoute = SysadminCatalogToolsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SysadminCatalogToolsRoute,
} as any)
const SysadminCatalogToolsIdRoute = SysadminCatalogToolsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SysadminCatalogToolsRoute,
} as any)
const SysadminCatalogSkillsIdRoute = SysadminCatalogSkillsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SysadminCatalogSkillsRoute,
} as any)
const SysadminCatalogMcpNewRoute = SysadminCatalogMcpNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SysadminCatalogMcpRoute,
} as any)
const SysadminCatalogMcpIdRoute = SysadminCatalogMcpIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SysadminCatalogMcpRoute,
} as any)
const SysadminCatalogFunctionsNewRoute =
  SysadminCatalogFunctionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SysadminCatalogFunctionsRoute,
  } as any)
const SysadminCatalogArgusLiveIdRoute =
  SysadminCatalogArgusLiveIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SysadminCatalogArgusLiveRoute,
  } as any)
const SysadminCatalogAgentsNewRoute =
  SysadminCatalogAgentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SysadminCatalogAgentsRoute,
  } as any)
const SysadminCatalogAgentsBuilderRoute =
  SysadminCatalogAgentsBuilderRouteImport.update({
    id: '/builder',
    path: '/builder',
    getParentRoute: () => SysadminCatalogAgentsRoute,
  } as any)
const SysadminCatalogAgentsIdRoute = SysadminCatalogAgentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SysadminCatalogAgentsRoute,
} as any)
const LibraryWikiArticleIdEditRoute =
  LibraryWikiArticleIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => LibraryWikiArticleIdRoute,
  } as any)
const ArgusLiveDashboardsIdEditRoute =
  ArgusLiveDashboardsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => ArgusLiveDashboardsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/agents': typeof AgentsRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/approvals': typeof ApprovalsRouteWithChildren
  '/ask-argus': typeof AskArgusRouteWithChildren
  '/automate': typeof AutomateRouteWithChildren
  '/branding': typeof BrandingRoute
  '/connections': typeof ConnectionsRouteWithChildren
  '/evaluation': typeof EvaluationRoute
  '/help': typeof HelpRoute
  '/insights': typeof InsightsRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/models': typeof ModelsRoute
  '/organization-profiles': typeof OrganizationProfilesRoute
  '/organizations': typeof OrganizationsRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/roles': typeof RolesRoute
  '/security': typeof SecurityRoute
  '/settings': typeof SettingsRoute
  '/studio': typeof StudioRouteWithChildren
  '/sysadmin': typeof SysadminRouteWithChildren
  '/trust': typeof TrustRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/workspace': typeof WorkspaceRoute
  '/admin/audit': typeof AdminAuditRouteWithChildren
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/health': typeof AdminHealthRouteWithChildren
  '/admin/helper-budgets': typeof AdminHelperBudgetsRoute
  '/admin/notifications': typeof AdminNotificationsRouteWithChildren
  '/admin/playground': typeof AdminPlaygroundRoute
  '/admin/security': typeof AdminSecurityRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/agents/builder': typeof AgentsBuilderRoute
  '/agents/gallery': typeof AgentsGalleryRoute
  '/agents/new': typeof AgentsNewRoute
  '/approvals/$approvalId': typeof ApprovalsApprovalIdRoute
  '/approvals/history': typeof ApprovalsHistoryRoute
  '/approvals/settings': typeof ApprovalsSettingsRoute
  '/ask-argus/memories': typeof AskArgusMemoriesRoute
  '/ask-argus/projects': typeof AskArgusProjectsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/automate/history': typeof AutomateHistoryRouteWithChildren
  '/automate/new': typeof AutomateNewRoute
  '/automate/nodes': typeof AutomateNodesRoute
  '/automate/playbooks': typeof AutomatePlaybooksRouteWithChildren
  '/connections/$connectionId': typeof ConnectionsConnectionIdRoute
  '/connections/api': typeof ConnectionsApiRouteWithChildren
  '/connections/functions': typeof ConnectionsFunctionsRouteWithChildren
  '/connections/health': typeof ConnectionsHealthRoute
  '/connections/marketplace': typeof ConnectionsMarketplaceRoute
  '/connections/mcp': typeof ConnectionsMcpRouteWithChildren
  '/connections/new-api': typeof ConnectionsNewApiRoute
  '/connections/new-function': typeof ConnectionsNewFunctionRoute
  '/connections/new-mcp': typeof ConnectionsNewMcpRoute
  '/insights/adoption': typeof InsightsAdoptionRoute
  '/insights/agents-knowledge': typeof InsightsAgentsKnowledgeRoute
  '/insights/cost': typeof InsightsCostRoute
  '/insights/quality': typeof InsightsQualityRoute
  '/insights/risk': typeof InsightsRiskRoute
  '/insights/value': typeof InsightsValueRoute
  '/invite/$token': typeof InviteTokenRoute
  '/library/documents': typeof LibraryDocumentsRoute
  '/library/folders': typeof LibraryFoldersRoute
  '/library/quality': typeof LibraryQualityRoute
  '/library/search': typeof LibrarySearchRoute
  '/library/shared': typeof LibrarySharedRoute
  '/library/system': typeof LibrarySystemRoute
  '/library/wiki': typeof LibraryWikiRouteWithChildren
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/setup/$token': typeof SetupTokenRoute
  '/shared/$token': typeof SharedTokenRoute
  '/studio/bundles': typeof StudioBundlesRouteWithChildren
  '/studio/functions': typeof StudioFunctionsRoute
  '/studio/prompts': typeof StudioPromptsRouteWithChildren
  '/studio/skills': typeof StudioSkillsRouteWithChildren
  '/studio/templates': typeof StudioTemplatesRoute
  '/studio/tools': typeof StudioToolsRouteWithChildren
  '/sysadmin/administrators': typeof SysadminAdministratorsRouteWithChildren
  '/sysadmin/admins': typeof SysadminAdminsRoute
  '/sysadmin/audit': typeof SysadminAuditRouteWithChildren
  '/sysadmin/audit-chain': typeof SysadminAuditChainRoute
  '/sysadmin/branding': typeof SysadminBrandingRoute
  '/sysadmin/catalog': typeof SysadminCatalogRouteWithChildren
  '/sysadmin/fine-tuning': typeof SysadminFineTuningRouteWithChildren
  '/sysadmin/governance': typeof SysadminGovernanceRouteWithChildren
  '/sysadmin/library': typeof SysadminLibraryRouteWithChildren
  '/sysadmin/models': typeof SysadminModelsRouteWithChildren
  '/sysadmin/platform': typeof SysadminPlatformRouteWithChildren
  '/sysadmin/runtime': typeof SysadminRuntimeRouteWithChildren
  '/sysadmin/settings': typeof SysadminSettingsRouteWithChildren
  '/sysadmin/studio': typeof SysadminStudioRouteWithChildren
  '/sysadmin/tenants': typeof SysadminTenantsRouteWithChildren
  '/trust/activity': typeof TrustActivityRoute
  '/trust/ai-systems': typeof TrustAiSystemsRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-flows': typeof TrustDataFlowsRoute
  '/trust/evidence': typeof TrustEvidenceRoute
  '/trust/violations': typeof TrustViolationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/activity': typeof UsersActivityRoute
  '/users/departments': typeof UsersDepartmentsRoute
  '/users/groups': typeof UsersGroupsRouteWithChildren
  '/users/invitations': typeof UsersInvitationsRoute
  '/users/roles': typeof UsersRolesRoute
  '/users/sso': typeof UsersSsoRoute
  '/agents/': typeof AgentsIndexRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/argus-live/': typeof ArgusLiveIndexRoute
  '/ask-argus/': typeof AskArgusIndexRoute
  '/automate/': typeof AutomateIndexRoute
  '/connections/': typeof ConnectionsIndexRoute
  '/insights/': typeof InsightsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/setup/': typeof SetupIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/sysadmin/': typeof SysadminIndexRoute
  '/trust/': typeof TrustIndexRoute
  '/users/': typeof UsersIndexRoute
  '/admin/audit/changes': typeof AdminAuditChangesRoute
  '/admin/audit/integrity': typeof AdminAuditIntegrityRoute
  '/admin/discover/agents': typeof AdminDiscoverAgentsRoute
  '/admin/discover/connections': typeof AdminDiscoverConnectionsRoute
  '/admin/discover/functions': typeof AdminDiscoverFunctionsRoute
  '/admin/discover/prompts': typeof AdminDiscoverPromptsRoute
  '/admin/discover/skills': typeof AdminDiscoverSkillsRoute
  '/admin/discover/tools': typeof AdminDiscoverToolsRoute
  '/admin/health/infra': typeof AdminHealthInfraRoute
  '/admin/health/pipeline': typeof AdminHealthPipelineRoute
  '/admin/health/services': typeof AdminHealthServicesRoute
  '/admin/notifications/channels': typeof AdminNotificationsChannelsRoute
  '/admin/notifications/escalation': typeof AdminNotificationsEscalationRoute
  '/admin/notifications/log': typeof AdminNotificationsLogRoute
  '/admin/security/keys': typeof AdminSecurityKeysRoute
  '/admin/security/privileged': typeof AdminSecurityPrivilegedRoute
  '/admin/security/session': typeof AdminSecuritySessionRoute
  '/admin/security/threat': typeof AdminSecurityThreatRoute
  '/admin/settings/api': typeof AdminSettingsApiRoute
  '/admin/settings/compliance': typeof AdminSettingsComplianceRoute
  '/admin/settings/data': typeof AdminSettingsDataRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/agents/$agentId/edit': typeof AgentsAgentIdEditRoute
  '/argus-live/dashboards/$id': typeof ArgusLiveDashboardsIdRouteWithChildren
  '/argus-live/dashboards/new': typeof ArgusLiveDashboardsNewRoute
  '/ask-argus/project/$projectId': typeof AskArgusProjectProjectIdRoute
  '/automate/history/$executionId': typeof AutomateHistoryExecutionIdRoute
  '/automate/playbooks/$playbookId': typeof AutomatePlaybooksPlaybookIdRoute
  '/automate/workflows/$id': typeof AutomateWorkflowsIdRoute
  '/connections/api/$connectionId': typeof ConnectionsApiConnectionIdRoute
  '/connections/api/new': typeof ConnectionsApiNewRoute
  '/connections/functions/$functionId': typeof ConnectionsFunctionsFunctionIdRoute
  '/connections/functions/new': typeof ConnectionsFunctionsNewRoute
  '/connections/mcp/$connectionId': typeof ConnectionsMcpConnectionIdRoute
  '/connections/mcp/marketplace': typeof ConnectionsMcpMarketplaceRoute
  '/library/article/$articleId': typeof LibraryArticleArticleIdRoute
  '/library/doc/$docId': typeof LibraryDocDocIdRoute
  '/library/sources/$sourceId': typeof LibrarySourcesSourceIdRoute
  '/library/sources/connect': typeof LibrarySourcesConnectRoute
  '/library/wiki/$articleId': typeof LibraryWikiArticleIdRouteWithChildren
  '/library/wiki/new': typeof LibraryWikiNewRoute
  '/studio/bundles/$id': typeof StudioBundlesIdRoute
  '/studio/bundles/new': typeof StudioBundlesNewRoute
  '/studio/prompts/$promptId': typeof StudioPromptsPromptIdRoute
  '/studio/skills/$skillId': typeof StudioSkillsSkillIdRoute
  '/studio/tools/$toolId': typeof StudioToolsToolIdRoute
  '/studio/tools/new': typeof StudioToolsNewRoute
  '/sysadmin/administrators/activity': typeof SysadminAdministratorsActivityRoute
  '/sysadmin/administrators/sessions': typeof SysadminAdministratorsSessionsRoute
  '/sysadmin/audit/exports': typeof SysadminAuditExportsRoute
  '/sysadmin/audit/integrity': typeof SysadminAuditIntegrityRoute
  '/sysadmin/audit/stream': typeof SysadminAuditStreamRoute
  '/sysadmin/audit/sysadmin': typeof SysadminAuditSysadminRoute
  '/sysadmin/audit/witness': typeof SysadminAuditWitnessRoute
  '/sysadmin/catalog/agents': typeof SysadminCatalogAgentsRouteWithChildren
  '/sysadmin/catalog/argus-live': typeof SysadminCatalogArgusLiveRouteWithChildren
  '/sysadmin/catalog/assignments': typeof SysadminCatalogAssignmentsRoute
  '/sysadmin/catalog/functions': typeof SysadminCatalogFunctionsRouteWithChildren
  '/sysadmin/catalog/knowledge': typeof SysadminCatalogKnowledgeRoute
  '/sysadmin/catalog/mcp': typeof SysadminCatalogMcpRouteWithChildren
  '/sysadmin/catalog/models': typeof SysadminCatalogModelsRoute
  '/sysadmin/catalog/prompts': typeof SysadminCatalogPromptsRoute
  '/sysadmin/catalog/skills': typeof SysadminCatalogSkillsRouteWithChildren
  '/sysadmin/catalog/tools': typeof SysadminCatalogToolsRouteWithChildren
  '/sysadmin/catalog/workflows': typeof SysadminCatalogWorkflowsRouteWithChildren
  '/sysadmin/fine-tuning/adapters': typeof SysadminFineTuningAdaptersRoute
  '/sysadmin/fine-tuning/evaluation': typeof SysadminFineTuningEvaluationRoute
  '/sysadmin/fine-tuning/golden-set': typeof SysadminFineTuningGoldenSetRoute
  '/sysadmin/fine-tuning/training-data': typeof SysadminFineTuningTrainingDataRoute
  '/sysadmin/governance/approvals': typeof SysadminGovernanceApprovalsRoute
  '/sysadmin/governance/classification': typeof SysadminGovernanceClassificationRoute
  '/sysadmin/governance/compliance': typeof SysadminGovernanceComplianceRoute
  '/sysadmin/governance/guardrails': typeof SysadminGovernanceGuardrailsRoute
  '/sysadmin/governance/pii': typeof SysadminGovernancePiiRoute
  '/sysadmin/library/articles': typeof SysadminLibraryArticlesRoute
  '/sysadmin/library/document-folders': typeof SysadminLibraryDocumentFoldersRoute
  '/sysadmin/library/documents': typeof SysadminLibraryDocumentsRoute
  '/sysadmin/library/folders': typeof SysadminLibraryFoldersRoute
  '/sysadmin/library/sources': typeof SysadminLibrarySourcesRoute
  '/sysadmin/library/tags': typeof SysadminLibraryTagsRoute
  '/sysadmin/models/$id': typeof SysadminModelsIdRoute
  '/sysadmin/models/assignments': typeof SysadminModelsAssignmentsRoute
  '/sysadmin/models/functions': typeof SysadminModelsFunctionsRoute
  '/sysadmin/models/history': typeof SysadminModelsHistoryRoute
  '/sysadmin/models/new': typeof SysadminModelsNewRoute
  '/sysadmin/models/runtime': typeof SysadminModelsRuntimeRoute
  '/sysadmin/models/trust-toggles': typeof SysadminModelsTrustTogglesRoute
  '/sysadmin/platform/airgap': typeof SysadminPlatformAirgapRoute
  '/sysadmin/platform/backups': typeof SysadminPlatformBackupsRoute
  '/sysadmin/platform/builder-analytics': typeof SysadminPlatformBuilderAnalyticsRoute
  '/sysadmin/platform/deployment': typeof SysadminPlatformDeploymentRoute
  '/sysadmin/platform/hardware-profiles': typeof SysadminPlatformHardwareProfilesRoute
  '/sysadmin/platform/helper-budgets': typeof SysadminPlatformHelperBudgetsRoute
  '/sysadmin/platform/keys': typeof SysadminPlatformKeysRoute
  '/sysadmin/platform/license': typeof SysadminPlatformLicenseRoute
  '/sysadmin/platform/updates': typeof SysadminPlatformUpdatesRoute
  '/sysadmin/runtime/hardware': typeof SysadminRuntimeHardwareRoute
  '/sysadmin/runtime/health': typeof SysadminRuntimeHealthRoute
  '/sysadmin/runtime/inference': typeof SysadminRuntimeInferenceRoute
  '/sysadmin/runtime/mcp': typeof SysadminRuntimeMcpRoute
  '/sysadmin/runtime/queues': typeof SysadminRuntimeQueuesRoute
  '/sysadmin/runtime/storage': typeof SysadminRuntimeStorageRoute
  '/sysadmin/settings/api': typeof SysadminSettingsApiRoute
  '/sysadmin/settings/email': typeof SysadminSettingsEmailRoute
  '/sysadmin/settings/idp': typeof SysadminSettingsIdpRoute
  '/sysadmin/settings/notifications': typeof SysadminSettingsNotificationsRoute
  '/sysadmin/studio/agents': typeof SysadminStudioAgentsRoute
  '/sysadmin/studio/categories': typeof SysadminStudioCategoriesRoute
  '/sysadmin/studio/prompts': typeof SysadminStudioPromptsRoute
  '/sysadmin/studio/skills': typeof SysadminStudioSkillsRoute
  '/sysadmin/studio/tools': typeof SysadminStudioToolsRoute
  '/sysadmin/tenants/$tenantId': typeof SysadminTenantsTenantIdRouteWithChildren
  '/trust/frameworks/$frameworkId': typeof TrustFrameworksFrameworkIdRoute
  '/users/groups/$groupId': typeof UsersGroupsGroupIdRoute
  '/admin/audit/': typeof AdminAuditIndexRoute
  '/admin/discover/': typeof AdminDiscoverIndexRoute
  '/admin/health/': typeof AdminHealthIndexRoute
  '/admin/notifications/': typeof AdminNotificationsIndexRoute
  '/admin/security/': typeof AdminSecurityIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/agents/$agentId/': typeof AgentsAgentIdIndexRoute
  '/library/sources/': typeof LibrarySourcesIndexRoute
  '/studio/bundles/': typeof StudioBundlesIndexRoute
  '/studio/prompts/': typeof StudioPromptsIndexRoute
  '/studio/skills/': typeof StudioSkillsIndexRoute
  '/studio/tools/': typeof StudioToolsIndexRoute
  '/sysadmin/administrators/': typeof SysadminAdministratorsIndexRoute
  '/sysadmin/audit/': typeof SysadminAuditIndexRoute
  '/sysadmin/catalog/': typeof SysadminCatalogIndexRoute
  '/sysadmin/fine-tuning/': typeof SysadminFineTuningIndexRoute
  '/sysadmin/governance/': typeof SysadminGovernanceIndexRoute
  '/sysadmin/library/': typeof SysadminLibraryIndexRoute
  '/sysadmin/models/': typeof SysadminModelsIndexRoute
  '/sysadmin/platform/': typeof SysadminPlatformIndexRoute
  '/sysadmin/runtime/': typeof SysadminRuntimeIndexRoute
  '/sysadmin/settings/': typeof SysadminSettingsIndexRoute
  '/sysadmin/studio/': typeof SysadminStudioIndexRoute
  '/sysadmin/tenants/': typeof SysadminTenantsIndexRoute
  '/trust/frameworks/': typeof TrustFrameworksIndexRoute
  '/argus-live/dashboards/$id/edit': typeof ArgusLiveDashboardsIdEditRoute
  '/library/wiki/$articleId/edit': typeof LibraryWikiArticleIdEditRoute
  '/sysadmin/catalog/agents/$id': typeof SysadminCatalogAgentsIdRoute
  '/sysadmin/catalog/agents/builder': typeof SysadminCatalogAgentsBuilderRoute
  '/sysadmin/catalog/agents/new': typeof SysadminCatalogAgentsNewRoute
  '/sysadmin/catalog/argus-live/$id': typeof SysadminCatalogArgusLiveIdRoute
  '/sysadmin/catalog/functions/new': typeof SysadminCatalogFunctionsNewRoute
  '/sysadmin/catalog/mcp/$id': typeof SysadminCatalogMcpIdRoute
  '/sysadmin/catalog/mcp/new': typeof SysadminCatalogMcpNewRoute
  '/sysadmin/catalog/skills/$id': typeof SysadminCatalogSkillsIdRoute
  '/sysadmin/catalog/tools/$id': typeof SysadminCatalogToolsIdRoute
  '/sysadmin/catalog/tools/new': typeof SysadminCatalogToolsNewRoute
  '/sysadmin/catalog/workflows/$id': typeof SysadminCatalogWorkflowsIdRoute
  '/sysadmin/tenants/$tenantId/assignments': typeof SysadminTenantsTenantIdAssignmentsRoute
  '/sysadmin/tenants/$tenantId/audit': typeof SysadminTenantsTenantIdAuditRoute
  '/sysadmin/tenants/$tenantId/branding': typeof SysadminTenantsTenantIdBrandingRoute
  '/sysadmin/tenants/$tenantId/compliance': typeof SysadminTenantsTenantIdComplianceRoute
  '/sysadmin/tenants/$tenantId/hardware': typeof SysadminTenantsTenantIdHardwareRoute
  '/sysadmin/tenants/$tenantId/limits': typeof SysadminTenantsTenantIdLimitsRoute
  '/sysadmin/tenants/$tenantId/memory': typeof SysadminTenantsTenantIdMemoryRoute
  '/sysadmin/tenants/$tenantId/settings': typeof SysadminTenantsTenantIdSettingsRoute
  '/sysadmin/tenants/$tenantId/users': typeof SysadminTenantsTenantIdUsersRoute
  '/argus-live/dashboards/$id/': typeof ArgusLiveDashboardsIdIndexRoute
  '/sysadmin/catalog/agents/': typeof SysadminCatalogAgentsIndexRoute
  '/sysadmin/catalog/argus-live/': typeof SysadminCatalogArgusLiveIndexRoute
  '/sysadmin/catalog/functions/': typeof SysadminCatalogFunctionsIndexRoute
  '/sysadmin/catalog/mcp/': typeof SysadminCatalogMcpIndexRoute
  '/sysadmin/catalog/skills/': typeof SysadminCatalogSkillsIndexRoute
  '/sysadmin/catalog/tools/': typeof SysadminCatalogToolsIndexRoute
  '/sysadmin/catalog/workflows/': typeof SysadminCatalogWorkflowsIndexRoute
  '/sysadmin/tenants/$tenantId/': typeof SysadminTenantsTenantIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/branding': typeof BrandingRoute
  '/evaluation': typeof EvaluationRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/models': typeof ModelsRoute
  '/organization-profiles': typeof OrganizationProfilesRoute
  '/playground': typeof PlaygroundRoute
  '/roles': typeof RolesRoute
  '/security': typeof SecurityRoute
  '/settings': typeof SettingsRoute
  '/workspace': typeof WorkspaceRoute
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/helper-budgets': typeof AdminHelperBudgetsRoute
  '/admin/playground': typeof AdminPlaygroundRoute
  '/admin/users': typeof AdminUsersRoute
  '/agents/builder': typeof AgentsBuilderRoute
  '/agents/gallery': typeof AgentsGalleryRoute
  '/agents/new': typeof AgentsNewRoute
  '/approvals/$approvalId': typeof ApprovalsApprovalIdRoute
  '/approvals/history': typeof ApprovalsHistoryRoute
  '/approvals/settings': typeof ApprovalsSettingsRoute
  '/ask-argus/memories': typeof AskArgusMemoriesRoute
  '/ask-argus/projects': typeof AskArgusProjectsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/automate/history': typeof AutomateHistoryRouteWithChildren
  '/automate/new': typeof AutomateNewRoute
  '/automate/nodes': typeof AutomateNodesRoute
  '/automate/playbooks': typeof AutomatePlaybooksRouteWithChildren
  '/connections/$connectionId': typeof ConnectionsConnectionIdRoute
  '/connections/api': typeof ConnectionsApiRouteWithChildren
  '/connections/functions': typeof ConnectionsFunctionsRouteWithChildren
  '/connections/health': typeof ConnectionsHealthRoute
  '/connections/marketplace': typeof ConnectionsMarketplaceRoute
  '/connections/mcp': typeof ConnectionsMcpRouteWithChildren
  '/connections/new-api': typeof ConnectionsNewApiRoute
  '/connections/new-function': typeof ConnectionsNewFunctionRoute
  '/connections/new-mcp': typeof ConnectionsNewMcpRoute
  '/insights/adoption': typeof InsightsAdoptionRoute
  '/insights/agents-knowledge': typeof InsightsAgentsKnowledgeRoute
  '/insights/cost': typeof InsightsCostRoute
  '/insights/quality': typeof InsightsQualityRoute
  '/insights/risk': typeof InsightsRiskRoute
  '/insights/value': typeof InsightsValueRoute
  '/invite/$token': typeof InviteTokenRoute
  '/library/documents': typeof LibraryDocumentsRoute
  '/library/folders': typeof LibraryFoldersRoute
  '/library/quality': typeof LibraryQualityRoute
  '/library/search': typeof LibrarySearchRoute
  '/library/shared': typeof LibrarySharedRoute
  '/library/system': typeof LibrarySystemRoute
  '/library/wiki': typeof LibraryWikiRouteWithChildren
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/setup/$token': typeof SetupTokenRoute
  '/shared/$token': typeof SharedTokenRoute
  '/studio/functions': typeof StudioFunctionsRoute
  '/studio/templates': typeof StudioTemplatesRoute
  '/sysadmin/admins': typeof SysadminAdminsRoute
  '/sysadmin/audit-chain': typeof SysadminAuditChainRoute
  '/sysadmin/branding': typeof SysadminBrandingRoute
  '/trust/activity': typeof TrustActivityRoute
  '/trust/ai-systems': typeof TrustAiSystemsRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-flows': typeof TrustDataFlowsRoute
  '/trust/evidence': typeof TrustEvidenceRoute
  '/trust/violations': typeof TrustViolationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/activity': typeof UsersActivityRoute
  '/users/departments': typeof UsersDepartmentsRoute
  '/users/groups': typeof UsersGroupsRouteWithChildren
  '/users/invitations': typeof UsersInvitationsRoute
  '/users/roles': typeof UsersRolesRoute
  '/users/sso': typeof UsersSsoRoute
  '/agents': typeof AgentsIndexRoute
  '/approvals': typeof ApprovalsIndexRoute
  '/argus-live': typeof ArgusLiveIndexRoute
  '/ask-argus': typeof AskArgusIndexRoute
  '/automate': typeof AutomateIndexRoute
  '/connections': typeof ConnectionsIndexRoute
  '/insights': typeof InsightsIndexRoute
  '/library': typeof LibraryIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/setup': typeof SetupIndexRoute
  '/studio': typeof StudioIndexRoute
  '/sysadmin': typeof SysadminIndexRoute
  '/trust': typeof TrustIndexRoute
  '/users': typeof UsersIndexRoute
  '/admin/audit/changes': typeof AdminAuditChangesRoute
  '/admin/audit/integrity': typeof AdminAuditIntegrityRoute
  '/admin/discover/agents': typeof AdminDiscoverAgentsRoute
  '/admin/discover/connections': typeof AdminDiscoverConnectionsRoute
  '/admin/discover/functions': typeof AdminDiscoverFunctionsRoute
  '/admin/discover/prompts': typeof AdminDiscoverPromptsRoute
  '/admin/discover/skills': typeof AdminDiscoverSkillsRoute
  '/admin/discover/tools': typeof AdminDiscoverToolsRoute
  '/admin/health/infra': typeof AdminHealthInfraRoute
  '/admin/health/pipeline': typeof AdminHealthPipelineRoute
  '/admin/health/services': typeof AdminHealthServicesRoute
  '/admin/notifications/channels': typeof AdminNotificationsChannelsRoute
  '/admin/notifications/escalation': typeof AdminNotificationsEscalationRoute
  '/admin/notifications/log': typeof AdminNotificationsLogRoute
  '/admin/security/keys': typeof AdminSecurityKeysRoute
  '/admin/security/privileged': typeof AdminSecurityPrivilegedRoute
  '/admin/security/session': typeof AdminSecuritySessionRoute
  '/admin/security/threat': typeof AdminSecurityThreatRoute
  '/admin/settings/api': typeof AdminSettingsApiRoute
  '/admin/settings/compliance': typeof AdminSettingsComplianceRoute
  '/admin/settings/data': typeof AdminSettingsDataRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/agents/$agentId/edit': typeof AgentsAgentIdEditRoute
  '/argus-live/dashboards/new': typeof ArgusLiveDashboardsNewRoute
  '/ask-argus/project/$projectId': typeof AskArgusProjectProjectIdRoute
  '/automate/history/$executionId': typeof AutomateHistoryExecutionIdRoute
  '/automate/playbooks/$playbookId': typeof AutomatePlaybooksPlaybookIdRoute
  '/automate/workflows/$id': typeof AutomateWorkflowsIdRoute
  '/connections/api/$connectionId': typeof ConnectionsApiConnectionIdRoute
  '/connections/api/new': typeof ConnectionsApiNewRoute
  '/connections/functions/$functionId': typeof ConnectionsFunctionsFunctionIdRoute
  '/connections/functions/new': typeof ConnectionsFunctionsNewRoute
  '/connections/mcp/$connectionId': typeof ConnectionsMcpConnectionIdRoute
  '/connections/mcp/marketplace': typeof ConnectionsMcpMarketplaceRoute
  '/library/article/$articleId': typeof LibraryArticleArticleIdRoute
  '/library/doc/$docId': typeof LibraryDocDocIdRoute
  '/library/sources/$sourceId': typeof LibrarySourcesSourceIdRoute
  '/library/sources/connect': typeof LibrarySourcesConnectRoute
  '/library/wiki/$articleId': typeof LibraryWikiArticleIdRouteWithChildren
  '/library/wiki/new': typeof LibraryWikiNewRoute
  '/studio/bundles/$id': typeof StudioBundlesIdRoute
  '/studio/bundles/new': typeof StudioBundlesNewRoute
  '/studio/prompts/$promptId': typeof StudioPromptsPromptIdRoute
  '/studio/skills/$skillId': typeof StudioSkillsSkillIdRoute
  '/studio/tools/$toolId': typeof StudioToolsToolIdRoute
  '/studio/tools/new': typeof StudioToolsNewRoute
  '/sysadmin/administrators/activity': typeof SysadminAdministratorsActivityRoute
  '/sysadmin/administrators/sessions': typeof SysadminAdministratorsSessionsRoute
  '/sysadmin/audit/exports': typeof SysadminAuditExportsRoute
  '/sysadmin/audit/integrity': typeof SysadminAuditIntegrityRoute
  '/sysadmin/audit/stream': typeof SysadminAuditStreamRoute
  '/sysadmin/audit/sysadmin': typeof SysadminAuditSysadminRoute
  '/sysadmin/audit/witness': typeof SysadminAuditWitnessRoute
  '/sysadmin/catalog/assignments': typeof SysadminCatalogAssignmentsRoute
  '/sysadmin/catalog/knowledge': typeof SysadminCatalogKnowledgeRoute
  '/sysadmin/catalog/models': typeof SysadminCatalogModelsRoute
  '/sysadmin/catalog/prompts': typeof SysadminCatalogPromptsRoute
  '/sysadmin/fine-tuning/adapters': typeof SysadminFineTuningAdaptersRoute
  '/sysadmin/fine-tuning/evaluation': typeof SysadminFineTuningEvaluationRoute
  '/sysadmin/fine-tuning/golden-set': typeof SysadminFineTuningGoldenSetRoute
  '/sysadmin/fine-tuning/training-data': typeof SysadminFineTuningTrainingDataRoute
  '/sysadmin/governance/approvals': typeof SysadminGovernanceApprovalsRoute
  '/sysadmin/governance/classification': typeof SysadminGovernanceClassificationRoute
  '/sysadmin/governance/compliance': typeof SysadminGovernanceComplianceRoute
  '/sysadmin/governance/guardrails': typeof SysadminGovernanceGuardrailsRoute
  '/sysadmin/governance/pii': typeof SysadminGovernancePiiRoute
  '/sysadmin/library/articles': typeof SysadminLibraryArticlesRoute
  '/sysadmin/library/document-folders': typeof SysadminLibraryDocumentFoldersRoute
  '/sysadmin/library/documents': typeof SysadminLibraryDocumentsRoute
  '/sysadmin/library/folders': typeof SysadminLibraryFoldersRoute
  '/sysadmin/library/sources': typeof SysadminLibrarySourcesRoute
  '/sysadmin/library/tags': typeof SysadminLibraryTagsRoute
  '/sysadmin/models/$id': typeof SysadminModelsIdRoute
  '/sysadmin/models/assignments': typeof SysadminModelsAssignmentsRoute
  '/sysadmin/models/functions': typeof SysadminModelsFunctionsRoute
  '/sysadmin/models/history': typeof SysadminModelsHistoryRoute
  '/sysadmin/models/new': typeof SysadminModelsNewRoute
  '/sysadmin/models/runtime': typeof SysadminModelsRuntimeRoute
  '/sysadmin/models/trust-toggles': typeof SysadminModelsTrustTogglesRoute
  '/sysadmin/platform/airgap': typeof SysadminPlatformAirgapRoute
  '/sysadmin/platform/backups': typeof SysadminPlatformBackupsRoute
  '/sysadmin/platform/builder-analytics': typeof SysadminPlatformBuilderAnalyticsRoute
  '/sysadmin/platform/deployment': typeof SysadminPlatformDeploymentRoute
  '/sysadmin/platform/hardware-profiles': typeof SysadminPlatformHardwareProfilesRoute
  '/sysadmin/platform/helper-budgets': typeof SysadminPlatformHelperBudgetsRoute
  '/sysadmin/platform/keys': typeof SysadminPlatformKeysRoute
  '/sysadmin/platform/license': typeof SysadminPlatformLicenseRoute
  '/sysadmin/platform/updates': typeof SysadminPlatformUpdatesRoute
  '/sysadmin/runtime/hardware': typeof SysadminRuntimeHardwareRoute
  '/sysadmin/runtime/health': typeof SysadminRuntimeHealthRoute
  '/sysadmin/runtime/inference': typeof SysadminRuntimeInferenceRoute
  '/sysadmin/runtime/mcp': typeof SysadminRuntimeMcpRoute
  '/sysadmin/runtime/queues': typeof SysadminRuntimeQueuesRoute
  '/sysadmin/runtime/storage': typeof SysadminRuntimeStorageRoute
  '/sysadmin/settings/api': typeof SysadminSettingsApiRoute
  '/sysadmin/settings/email': typeof SysadminSettingsEmailRoute
  '/sysadmin/settings/idp': typeof SysadminSettingsIdpRoute
  '/sysadmin/settings/notifications': typeof SysadminSettingsNotificationsRoute
  '/sysadmin/studio/agents': typeof SysadminStudioAgentsRoute
  '/sysadmin/studio/categories': typeof SysadminStudioCategoriesRoute
  '/sysadmin/studio/prompts': typeof SysadminStudioPromptsRoute
  '/sysadmin/studio/skills': typeof SysadminStudioSkillsRoute
  '/sysadmin/studio/tools': typeof SysadminStudioToolsRoute
  '/trust/frameworks/$frameworkId': typeof TrustFrameworksFrameworkIdRoute
  '/users/groups/$groupId': typeof UsersGroupsGroupIdRoute
  '/admin/audit': typeof AdminAuditIndexRoute
  '/admin/discover': typeof AdminDiscoverIndexRoute
  '/admin/health': typeof AdminHealthIndexRoute
  '/admin/notifications': typeof AdminNotificationsIndexRoute
  '/admin/security': typeof AdminSecurityIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/agents/$agentId': typeof AgentsAgentIdIndexRoute
  '/library/sources': typeof LibrarySourcesIndexRoute
  '/studio/bundles': typeof StudioBundlesIndexRoute
  '/studio/prompts': typeof StudioPromptsIndexRoute
  '/studio/skills': typeof StudioSkillsIndexRoute
  '/studio/tools': typeof StudioToolsIndexRoute
  '/sysadmin/administrators': typeof SysadminAdministratorsIndexRoute
  '/sysadmin/audit': typeof SysadminAuditIndexRoute
  '/sysadmin/catalog': typeof SysadminCatalogIndexRoute
  '/sysadmin/fine-tuning': typeof SysadminFineTuningIndexRoute
  '/sysadmin/governance': typeof SysadminGovernanceIndexRoute
  '/sysadmin/library': typeof SysadminLibraryIndexRoute
  '/sysadmin/models': typeof SysadminModelsIndexRoute
  '/sysadmin/platform': typeof SysadminPlatformIndexRoute
  '/sysadmin/runtime': typeof SysadminRuntimeIndexRoute
  '/sysadmin/settings': typeof SysadminSettingsIndexRoute
  '/sysadmin/studio': typeof SysadminStudioIndexRoute
  '/sysadmin/tenants': typeof SysadminTenantsIndexRoute
  '/trust/frameworks': typeof TrustFrameworksIndexRoute
  '/argus-live/dashboards/$id/edit': typeof ArgusLiveDashboardsIdEditRoute
  '/library/wiki/$articleId/edit': typeof LibraryWikiArticleIdEditRoute
  '/sysadmin/catalog/agents/$id': typeof SysadminCatalogAgentsIdRoute
  '/sysadmin/catalog/agents/builder': typeof SysadminCatalogAgentsBuilderRoute
  '/sysadmin/catalog/agents/new': typeof SysadminCatalogAgentsNewRoute
  '/sysadmin/catalog/argus-live/$id': typeof SysadminCatalogArgusLiveIdRoute
  '/sysadmin/catalog/functions/new': typeof SysadminCatalogFunctionsNewRoute
  '/sysadmin/catalog/mcp/$id': typeof SysadminCatalogMcpIdRoute
  '/sysadmin/catalog/mcp/new': typeof SysadminCatalogMcpNewRoute
  '/sysadmin/catalog/skills/$id': typeof SysadminCatalogSkillsIdRoute
  '/sysadmin/catalog/tools/$id': typeof SysadminCatalogToolsIdRoute
  '/sysadmin/catalog/tools/new': typeof SysadminCatalogToolsNewRoute
  '/sysadmin/catalog/workflows/$id': typeof SysadminCatalogWorkflowsIdRoute
  '/sysadmin/tenants/$tenantId/assignments': typeof SysadminTenantsTenantIdAssignmentsRoute
  '/sysadmin/tenants/$tenantId/audit': typeof SysadminTenantsTenantIdAuditRoute
  '/sysadmin/tenants/$tenantId/branding': typeof SysadminTenantsTenantIdBrandingRoute
  '/sysadmin/tenants/$tenantId/compliance': typeof SysadminTenantsTenantIdComplianceRoute
  '/sysadmin/tenants/$tenantId/hardware': typeof SysadminTenantsTenantIdHardwareRoute
  '/sysadmin/tenants/$tenantId/limits': typeof SysadminTenantsTenantIdLimitsRoute
  '/sysadmin/tenants/$tenantId/memory': typeof SysadminTenantsTenantIdMemoryRoute
  '/sysadmin/tenants/$tenantId/settings': typeof SysadminTenantsTenantIdSettingsRoute
  '/sysadmin/tenants/$tenantId/users': typeof SysadminTenantsTenantIdUsersRoute
  '/argus-live/dashboards/$id': typeof ArgusLiveDashboardsIdIndexRoute
  '/sysadmin/catalog/agents': typeof SysadminCatalogAgentsIndexRoute
  '/sysadmin/catalog/argus-live': typeof SysadminCatalogArgusLiveIndexRoute
  '/sysadmin/catalog/functions': typeof SysadminCatalogFunctionsIndexRoute
  '/sysadmin/catalog/mcp': typeof SysadminCatalogMcpIndexRoute
  '/sysadmin/catalog/skills': typeof SysadminCatalogSkillsIndexRoute
  '/sysadmin/catalog/tools': typeof SysadminCatalogToolsIndexRoute
  '/sysadmin/catalog/workflows': typeof SysadminCatalogWorkflowsIndexRoute
  '/sysadmin/tenants/$tenantId': typeof SysadminTenantsTenantIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/agents': typeof AgentsRouteWithChildren
  '/analytics': typeof AnalyticsRoute
  '/approvals': typeof ApprovalsRouteWithChildren
  '/ask-argus': typeof AskArgusRouteWithChildren
  '/automate': typeof AutomateRouteWithChildren
  '/branding': typeof BrandingRoute
  '/connections': typeof ConnectionsRouteWithChildren
  '/evaluation': typeof EvaluationRoute
  '/help': typeof HelpRoute
  '/insights': typeof InsightsRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/models': typeof ModelsRoute
  '/organization-profiles': typeof OrganizationProfilesRoute
  '/organizations': typeof OrganizationsRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/roles': typeof RolesRoute
  '/security': typeof SecurityRoute
  '/settings': typeof SettingsRoute
  '/studio': typeof StudioRouteWithChildren
  '/sysadmin': typeof SysadminRouteWithChildren
  '/trust': typeof TrustRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/workspace': typeof WorkspaceRoute
  '/admin/audit': typeof AdminAuditRouteWithChildren
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/health': typeof AdminHealthRouteWithChildren
  '/admin/helper-budgets': typeof AdminHelperBudgetsRoute
  '/admin/notifications': typeof AdminNotificationsRouteWithChildren
  '/admin/playground': typeof AdminPlaygroundRoute
  '/admin/security': typeof AdminSecurityRouteWithChildren
  '/admin/settings': typeof AdminSettingsRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/agents/builder': typeof AgentsBuilderRoute
  '/agents/gallery': typeof AgentsGalleryRoute
  '/agents/new': typeof AgentsNewRoute
  '/approvals/$approvalId': typeof ApprovalsApprovalIdRoute
  '/approvals/history': typeof ApprovalsHistoryRoute
  '/approvals/settings': typeof ApprovalsSettingsRoute
  '/ask-argus/memories': typeof AskArgusMemoriesRoute
  '/ask-argus/projects': typeof AskArgusProjectsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/automate/history': typeof AutomateHistoryRouteWithChildren
  '/automate/new': typeof AutomateNewRoute
  '/automate/nodes': typeof AutomateNodesRoute
  '/automate/playbooks': typeof AutomatePlaybooksRouteWithChildren
  '/connections/$connectionId': typeof ConnectionsConnectionIdRoute
  '/connections/api': typeof ConnectionsApiRouteWithChildren
  '/connections/functions': typeof ConnectionsFunctionsRouteWithChildren
  '/connections/health': typeof ConnectionsHealthRoute
  '/connections/marketplace': typeof ConnectionsMarketplaceRoute
  '/connections/mcp': typeof ConnectionsMcpRouteWithChildren
  '/connections/new-api': typeof ConnectionsNewApiRoute
  '/connections/new-function': typeof ConnectionsNewFunctionRoute
  '/connections/new-mcp': typeof ConnectionsNewMcpRoute
  '/insights/adoption': typeof InsightsAdoptionRoute
  '/insights/agents-knowledge': typeof InsightsAgentsKnowledgeRoute
  '/insights/cost': typeof InsightsCostRoute
  '/insights/quality': typeof InsightsQualityRoute
  '/insights/risk': typeof InsightsRiskRoute
  '/insights/value': typeof InsightsValueRoute
  '/invite/$token': typeof InviteTokenRoute
  '/library/documents': typeof LibraryDocumentsRoute
  '/library/folders': typeof LibraryFoldersRoute
  '/library/quality': typeof LibraryQualityRoute
  '/library/search': typeof LibrarySearchRoute
  '/library/shared': typeof LibrarySharedRoute
  '/library/system': typeof LibrarySystemRoute
  '/library/wiki': typeof LibraryWikiRouteWithChildren
  '/organizations/$orgId': typeof OrganizationsOrgIdRoute
  '/setup/$token': typeof SetupTokenRoute
  '/shared/$token': typeof SharedTokenRoute
  '/studio/bundles': typeof StudioBundlesRouteWithChildren
  '/studio/functions': typeof StudioFunctionsRoute
  '/studio/prompts': typeof StudioPromptsRouteWithChildren
  '/studio/skills': typeof StudioSkillsRouteWithChildren
  '/studio/templates': typeof StudioTemplatesRoute
  '/studio/tools': typeof StudioToolsRouteWithChildren
  '/sysadmin/administrators': typeof SysadminAdministratorsRouteWithChildren
  '/sysadmin/admins': typeof SysadminAdminsRoute
  '/sysadmin/audit': typeof SysadminAuditRouteWithChildren
  '/sysadmin/audit-chain': typeof SysadminAuditChainRoute
  '/sysadmin/branding': typeof SysadminBrandingRoute
  '/sysadmin/catalog': typeof SysadminCatalogRouteWithChildren
  '/sysadmin/fine-tuning': typeof SysadminFineTuningRouteWithChildren
  '/sysadmin/governance': typeof SysadminGovernanceRouteWithChildren
  '/sysadmin/library': typeof SysadminLibraryRouteWithChildren
  '/sysadmin/models': typeof SysadminModelsRouteWithChildren
  '/sysadmin/platform': typeof SysadminPlatformRouteWithChildren
  '/sysadmin/runtime': typeof SysadminRuntimeRouteWithChildren
  '/sysadmin/settings': typeof SysadminSettingsRouteWithChildren
  '/sysadmin/studio': typeof SysadminStudioRouteWithChildren
  '/sysadmin/tenants': typeof SysadminTenantsRouteWithChildren
  '/trust/activity': typeof TrustActivityRoute
  '/trust/ai-systems': typeof TrustAiSystemsRoute
  '/trust/audit': typeof TrustAuditRoute
  '/trust/data-flows': typeof TrustDataFlowsRoute
  '/trust/evidence': typeof TrustEvidenceRoute
  '/trust/violations': typeof TrustViolationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/activity': typeof UsersActivityRoute
  '/users/departments': typeof UsersDepartmentsRoute
  '/users/groups': typeof UsersGroupsRouteWithChildren
  '/users/invitations': typeof UsersInvitationsRoute
  '/users/roles': typeof UsersRolesRoute
  '/users/sso': typeof UsersSsoRoute
  '/agents/': typeof AgentsIndexRoute
  '/approvals/': typeof ApprovalsIndexRoute
  '/argus-live/': typeof ArgusLiveIndexRoute
  '/ask-argus/': typeof AskArgusIndexRoute
  '/automate/': typeof AutomateIndexRoute
  '/connections/': typeof ConnectionsIndexRoute
  '/insights/': typeof InsightsIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/setup/': typeof SetupIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/sysadmin/': typeof SysadminIndexRoute
  '/trust/': typeof TrustIndexRoute
  '/users/': typeof UsersIndexRoute
  '/admin/audit/changes': typeof AdminAuditChangesRoute
  '/admin/audit/integrity': typeof AdminAuditIntegrityRoute
  '/admin/discover/agents': typeof AdminDiscoverAgentsRoute
  '/admin/discover/connections': typeof AdminDiscoverConnectionsRoute
  '/admin/discover/functions': typeof AdminDiscoverFunctionsRoute
  '/admin/discover/prompts': typeof AdminDiscoverPromptsRoute
  '/admin/discover/skills': typeof AdminDiscoverSkillsRoute
  '/admin/discover/tools': typeof AdminDiscoverToolsRoute
  '/admin/health/infra': typeof AdminHealthInfraRoute
  '/admin/health/pipeline': typeof AdminHealthPipelineRoute
  '/admin/health/services': typeof AdminHealthServicesRoute
  '/admin/notifications/channels': typeof AdminNotificationsChannelsRoute
  '/admin/notifications/escalation': typeof AdminNotificationsEscalationRoute
  '/admin/notifications/log': typeof AdminNotificationsLogRoute
  '/admin/security/keys': typeof AdminSecurityKeysRoute
  '/admin/security/privileged': typeof AdminSecurityPrivilegedRoute
  '/admin/security/session': typeof AdminSecuritySessionRoute
  '/admin/security/threat': typeof AdminSecurityThreatRoute
  '/admin/settings/api': typeof AdminSettingsApiRoute
  '/admin/settings/compliance': typeof AdminSettingsComplianceRoute
  '/admin/settings/data': typeof AdminSettingsDataRoute
  '/admin/settings/integrations': typeof AdminSettingsIntegrationsRoute
  '/agents/$agentId/edit': typeof AgentsAgentIdEditRoute
  '/argus-live/dashboards/$id': typeof ArgusLiveDashboardsIdRouteWithChildren
  '/argus-live/dashboards/new': typeof ArgusLiveDashboardsNewRoute
  '/ask-argus/project/$projectId': typeof AskArgusProjectProjectIdRoute
  '/automate/history/$executionId': typeof AutomateHistoryExecutionIdRoute
  '/automate/playbooks/$playbookId': typeof AutomatePlaybooksPlaybookIdRoute
  '/automate/workflows/$id': typeof AutomateWorkflowsIdRoute
  '/connections/api/$connectionId': typeof ConnectionsApiConnectionIdRoute
  '/connections/api/new': typeof ConnectionsApiNewRoute
  '/connections/functions/$functionId': typeof ConnectionsFunctionsFunctionIdRoute
  '/connections/functions/new': typeof ConnectionsFunctionsNewRoute
  '/connections/mcp/$connectionId': typeof ConnectionsMcpConnectionIdRoute
  '/connections/mcp/marketplace': typeof ConnectionsMcpMarketplaceRoute
  '/library/article/$articleId': typeof LibraryArticleArticleIdRoute
  '/library/doc/$docId': typeof LibraryDocDocIdRoute
  '/library/sources/$sourceId': typeof LibrarySourcesSourceIdRoute
  '/library/sources/connect': typeof LibrarySourcesConnectRoute
  '/library/wiki/$articleId': typeof LibraryWikiArticleIdRouteWithChildren
  '/library/wiki/new': typeof LibraryWikiNewRoute
  '/studio/bundles/$id': typeof StudioBundlesIdRoute
  '/studio/bundles/new': typeof StudioBundlesNewRoute
  '/studio/prompts/$promptId': typeof StudioPromptsPromptIdRoute
  '/studio/skills/$skillId': typeof StudioSkillsSkillIdRoute
  '/studio/tools/$toolId': typeof StudioToolsToolIdRoute
  '/studio/tools/new': typeof StudioToolsNewRoute
  '/sysadmin/administrators/activity': typeof SysadminAdministratorsActivityRoute
  '/sysadmin/administrators/sessions': typeof SysadminAdministratorsSessionsRoute
  '/sysadmin/audit/exports': typeof SysadminAuditExportsRoute
  '/sysadmin/audit/integrity': typeof SysadminAuditIntegrityRoute
  '/sysadmin/audit/stream': typeof SysadminAuditStreamRoute
  '/sysadmin/audit/sysadmin': typeof SysadminAuditSysadminRoute
  '/sysadmin/audit/witness': typeof SysadminAuditWitnessRoute
  '/sysadmin/catalog/agents': typeof SysadminCatalogAgentsRouteWithChildren
  '/sysadmin/catalog/argus-live': typeof SysadminCatalogArgusLiveRouteWithChildren
  '/sysadmin/catalog/assignments': typeof SysadminCatalogAssignmentsRoute
  '/sysadmin/catalog/functions': typeof SysadminCatalogFunctionsRouteWithChildren
  '/sysadmin/catalog/knowledge': typeof SysadminCatalogKnowledgeRoute
  '/sysadmin/catalog/mcp': typeof SysadminCatalogMcpRouteWithChildren
  '/sysadmin/catalog/models': typeof SysadminCatalogModelsRoute
  '/sysadmin/catalog/prompts': typeof SysadminCatalogPromptsRoute
  '/sysadmin/catalog/skills': typeof SysadminCatalogSkillsRouteWithChildren
  '/sysadmin/catalog/tools': typeof SysadminCatalogToolsRouteWithChildren
  '/sysadmin/catalog/workflows': typeof SysadminCatalogWorkflowsRouteWithChildren
  '/sysadmin/fine-tuning/adapters': typeof SysadminFineTuningAdaptersRoute
  '/sysadmin/fine-tuning/evaluation': typeof SysadminFineTuningEvaluationRoute
  '/sysadmin/fine-tuning/golden-set': typeof SysadminFineTuningGoldenSetRoute
  '/sysadmin/fine-tuning/training-data': typeof SysadminFineTuningTrainingDataRoute
  '/sysadmin/governance/approvals': typeof SysadminGovernanceApprovalsRoute
  '/sysadmin/governance/classification': typeof SysadminGovernanceClassificationRoute
  '/sysadmin/governance/compliance': typeof SysadminGovernanceComplianceRoute
  '/sysadmin/governance/guardrails': typeof SysadminGovernanceGuardrailsRoute
  '/sysadmin/governance/pii': typeof SysadminGovernancePiiRoute
  '/sysadmin/library/articles': typeof SysadminLibraryArticlesRoute
  '/sysadmin/library/document-folders': typeof SysadminLibraryDocumentFoldersRoute
  '/sysadmin/library/documents': typeof SysadminLibraryDocumentsRoute
  '/sysadmin/library/folders': typeof SysadminLibraryFoldersRoute
  '/sysadmin/library/sources': typeof SysadminLibrarySourcesRoute
  '/sysadmin/library/tags': typeof SysadminLibraryTagsRoute
  '/sysadmin/models/$id': typeof SysadminModelsIdRoute
  '/sysadmin/models/assignments': typeof SysadminModelsAssignmentsRoute
  '/sysadmin/models/functions': typeof SysadminModelsFunctionsRoute
  '/sysadmin/models/history': typeof SysadminModelsHistoryRoute
  '/sysadmin/models/new': typeof SysadminModelsNewRoute
  '/sysadmin/models/runtime': typeof SysadminModelsRuntimeRoute
  '/sysadmin/models/trust-toggles': typeof SysadminModelsTrustTogglesRoute
  '/sysadmin/platform/airgap': typeof SysadminPlatformAirgapRoute
  '/sysadmin/platform/backups': typeof SysadminPlatformBackupsRoute
  '/sysadmin/platform/builder-analytics': typeof SysadminPlatformBuilderAnalyticsRoute
  '/sysadmin/platform/deployment': typeof SysadminPlatformDeploymentRoute
  '/sysadmin/platform/hardware-profiles': typeof SysadminPlatformHardwareProfilesRoute
  '/sysadmin/platform/helper-budgets': typeof SysadminPlatformHelperBudgetsRoute
  '/sysadmin/platform/keys': typeof SysadminPlatformKeysRoute
  '/sysadmin/platform/license': typeof SysadminPlatformLicenseRoute
  '/sysadmin/platform/updates': typeof SysadminPlatformUpdatesRoute
  '/sysadmin/runtime/hardware': typeof SysadminRuntimeHardwareRoute
  '/sysadmin/runtime/health': typeof SysadminRuntimeHealthRoute
  '/sysadmin/runtime/inference': typeof SysadminRuntimeInferenceRoute
  '/sysadmin/runtime/mcp': typeof SysadminRuntimeMcpRoute
  '/sysadmin/runtime/queues': typeof SysadminRuntimeQueuesRoute
  '/sysadmin/runtime/storage': typeof SysadminRuntimeStorageRoute
  '/sysadmin/settings/api': typeof SysadminSettingsApiRoute
  '/sysadmin/settings/email': typeof SysadminSettingsEmailRoute
  '/sysadmin/settings/idp': typeof SysadminSettingsIdpRoute
  '/sysadmin/settings/notifications': typeof SysadminSettingsNotificationsRoute
  '/sysadmin/studio/agents': typeof SysadminStudioAgentsRoute
  '/sysadmin/studio/categories': typeof SysadminStudioCategoriesRoute
  '/sysadmin/studio/prompts': typeof SysadminStudioPromptsRoute
  '/sysadmin/studio/skills': typeof SysadminStudioSkillsRoute
  '/sysadmin/studio/tools': typeof SysadminStudioToolsRoute
  '/sysadmin/tenants/$tenantId': typeof SysadminTenantsTenantIdRouteWithChildren
  '/trust/frameworks/$frameworkId': typeof TrustFrameworksFrameworkIdRoute
  '/users/groups/$groupId': typeof UsersGroupsGroupIdRoute
  '/admin/audit/': typeof AdminAuditIndexRoute
  '/admin/discover/': typeof AdminDiscoverIndexRoute
  '/admin/health/': typeof AdminHealthIndexRoute
  '/admin/notifications/': typeof AdminNotificationsIndexRoute
  '/admin/security/': typeof AdminSecurityIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/agents/$agentId/': typeof AgentsAgentIdIndexRoute
  '/library/sources/': typeof LibrarySourcesIndexRoute
  '/studio/bundles/': typeof StudioBundlesIndexRoute
  '/studio/prompts/': typeof StudioPromptsIndexRoute
  '/studio/skills/': typeof StudioSkillsIndexRoute
  '/studio/tools/': typeof StudioToolsIndexRoute
  '/sysadmin/administrators/': typeof SysadminAdministratorsIndexRoute
  '/sysadmin/audit/': typeof SysadminAuditIndexRoute
  '/sysadmin/catalog/': typeof SysadminCatalogIndexRoute
  '/sysadmin/fine-tuning/': typeof SysadminFineTuningIndexRoute
  '/sysadmin/governance/': typeof SysadminGovernanceIndexRoute
  '/sysadmin/library/': typeof SysadminLibraryIndexRoute
  '/sysadmin/models/': typeof SysadminModelsIndexRoute
  '/sysadmin/platform/': typeof SysadminPlatformIndexRoute
  '/sysadmin/runtime/': typeof SysadminRuntimeIndexRoute
  '/sysadmin/settings/': typeof SysadminSettingsIndexRoute
  '/sysadmin/studio/': typeof SysadminStudioIndexRoute
  '/sysadmin/tenants/': typeof SysadminTenantsIndexRoute
  '/trust/frameworks/': typeof TrustFrameworksIndexRoute
  '/argus-live/dashboards/$id/edit': typeof ArgusLiveDashboardsIdEditRoute
  '/library/wiki/$articleId/edit': typeof LibraryWikiArticleIdEditRoute
  '/sysadmin/catalog/agents/$id': typeof SysadminCatalogAgentsIdRoute
  '/sysadmin/catalog/agents/builder': typeof SysadminCatalogAgentsBuilderRoute
  '/sysadmin/catalog/agents/new': typeof SysadminCatalogAgentsNewRoute
  '/sysadmin/catalog/argus-live/$id': typeof SysadminCatalogArgusLiveIdRoute
  '/sysadmin/catalog/functions/new': typeof SysadminCatalogFunctionsNewRoute
  '/sysadmin/catalog/mcp/$id': typeof SysadminCatalogMcpIdRoute
  '/sysadmin/catalog/mcp/new': typeof SysadminCatalogMcpNewRoute
  '/sysadmin/catalog/skills/$id': typeof SysadminCatalogSkillsIdRoute
  '/sysadmin/catalog/tools/$id': typeof SysadminCatalogToolsIdRoute
  '/sysadmin/catalog/tools/new': typeof SysadminCatalogToolsNewRoute
  '/sysadmin/catalog/workflows/$id': typeof SysadminCatalogWorkflowsIdRoute
  '/sysadmin/tenants/$tenantId/assignments': typeof SysadminTenantsTenantIdAssignmentsRoute
  '/sysadmin/tenants/$tenantId/audit': typeof SysadminTenantsTenantIdAuditRoute
  '/sysadmin/tenants/$tenantId/branding': typeof SysadminTenantsTenantIdBrandingRoute
  '/sysadmin/tenants/$tenantId/compliance': typeof SysadminTenantsTenantIdComplianceRoute
  '/sysadmin/tenants/$tenantId/hardware': typeof SysadminTenantsTenantIdHardwareRoute
  '/sysadmin/tenants/$tenantId/limits': typeof SysadminTenantsTenantIdLimitsRoute
  '/sysadmin/tenants/$tenantId/memory': typeof SysadminTenantsTenantIdMemoryRoute
  '/sysadmin/tenants/$tenantId/settings': typeof SysadminTenantsTenantIdSettingsRoute
  '/sysadmin/tenants/$tenantId/users': typeof SysadminTenantsTenantIdUsersRoute
  '/argus-live/dashboards/$id/': typeof ArgusLiveDashboardsIdIndexRoute
  '/sysadmin/catalog/agents/': typeof SysadminCatalogAgentsIndexRoute
  '/sysadmin/catalog/argus-live/': typeof SysadminCatalogArgusLiveIndexRoute
  '/sysadmin/catalog/functions/': typeof SysadminCatalogFunctionsIndexRoute
  '/sysadmin/catalog/mcp/': typeof SysadminCatalogMcpIndexRoute
  '/sysadmin/catalog/skills/': typeof SysadminCatalogSkillsIndexRoute
  '/sysadmin/catalog/tools/': typeof SysadminCatalogToolsIndexRoute
  '/sysadmin/catalog/workflows/': typeof SysadminCatalogWorkflowsIndexRoute
  '/sysadmin/tenants/$tenantId/': typeof SysadminTenantsTenantIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/admin'
    | '/agents'
    | '/analytics'
    | '/approvals'
    | '/ask-argus'
    | '/automate'
    | '/branding'
    | '/connections'
    | '/evaluation'
    | '/help'
    | '/insights'
    | '/library'
    | '/login'
    | '/mcp'
    | '/models'
    | '/organization-profiles'
    | '/organizations'
    | '/playground'
    | '/roles'
    | '/security'
    | '/settings'
    | '/studio'
    | '/sysadmin'
    | '/trust'
    | '/users'
    | '/workspace'
    | '/admin/audit'
    | '/admin/branding'
    | '/admin/health'
    | '/admin/helper-budgets'
    | '/admin/notifications'
    | '/admin/playground'
    | '/admin/security'
    | '/admin/settings'
    | '/admin/users'
    | '/agents/builder'
    | '/agents/gallery'
    | '/agents/new'
    | '/approvals/$approvalId'
    | '/approvals/history'
    | '/approvals/settings'
    | '/ask-argus/memories'
    | '/ask-argus/projects'
    | '/auth/callback'
    | '/automate/history'
    | '/automate/new'
    | '/automate/nodes'
    | '/automate/playbooks'
    | '/connections/$connectionId'
    | '/connections/api'
    | '/connections/functions'
    | '/connections/health'
    | '/connections/marketplace'
    | '/connections/mcp'
    | '/connections/new-api'
    | '/connections/new-function'
    | '/connections/new-mcp'
    | '/insights/adoption'
    | '/insights/agents-knowledge'
    | '/insights/cost'
    | '/insights/quality'
    | '/insights/risk'
    | '/insights/value'
    | '/invite/$token'
    | '/library/documents'
    | '/library/folders'
    | '/library/quality'
    | '/library/search'
    | '/library/shared'
    | '/library/system'
    | '/library/wiki'
    | '/organizations/$orgId'
    | '/setup/$token'
    | '/shared/$token'
    | '/studio/bundles'
    | '/studio/functions'
    | '/studio/prompts'
    | '/studio/skills'
    | '/studio/templates'
    | '/studio/tools'
    | '/sysadmin/administrators'
    | '/sysadmin/admins'
    | '/sysadmin/audit'
    | '/sysadmin/audit-chain'
    | '/sysadmin/branding'
    | '/sysadmin/catalog'
    | '/sysadmin/fine-tuning'
    | '/sysadmin/governance'
    | '/sysadmin/library'
    | '/sysadmin/models'
    | '/sysadmin/platform'
    | '/sysadmin/runtime'
    | '/sysadmin/settings'
    | '/sysadmin/studio'
    | '/sysadmin/tenants'
    | '/trust/activity'
    | '/trust/ai-systems'
    | '/trust/audit'
    | '/trust/data-flows'
    | '/trust/evidence'
    | '/trust/violations'
    | '/users/$userId'
    | '/users/activity'
    | '/users/departments'
    | '/users/groups'
    | '/users/invitations'
    | '/users/roles'
    | '/users/sso'
    | '/agents/'
    | '/approvals/'
    | '/argus-live/'
    | '/ask-argus/'
    | '/automate/'
    | '/connections/'
    | '/insights/'
    | '/library/'
    | '/organizations/'
    | '/setup/'
    | '/studio/'
    | '/sysadmin/'
    | '/trust/'
    | '/users/'
    | '/admin/audit/changes'
    | '/admin/audit/integrity'
    | '/admin/discover/agents'
    | '/admin/discover/connections'
    | '/admin/discover/functions'
    | '/admin/discover/prompts'
    | '/admin/discover/skills'
    | '/admin/discover/tools'
    | '/admin/health/infra'
    | '/admin/health/pipeline'
    | '/admin/health/services'
    | '/admin/notifications/channels'
    | '/admin/notifications/escalation'
    | '/admin/notifications/log'
    | '/admin/security/keys'
    | '/admin/security/privileged'
    | '/admin/security/session'
    | '/admin/security/threat'
    | '/admin/settings/api'
    | '/admin/settings/compliance'
    | '/admin/settings/data'
    | '/admin/settings/integrations'
    | '/agents/$agentId/edit'
    | '/argus-live/dashboards/$id'
    | '/argus-live/dashboards/new'
    | '/ask-argus/project/$projectId'
    | '/automate/history/$executionId'
    | '/automate/playbooks/$playbookId'
    | '/automate/workflows/$id'
    | '/connections/api/$connectionId'
    | '/connections/api/new'
    | '/connections/functions/$functionId'
    | '/connections/functions/new'
    | '/connections/mcp/$connectionId'
    | '/connections/mcp/marketplace'
    | '/library/article/$articleId'
    | '/library/doc/$docId'
    | '/library/sources/$sourceId'
    | '/library/sources/connect'
    | '/library/wiki/$articleId'
    | '/library/wiki/new'
    | '/studio/bundles/$id'
    | '/studio/bundles/new'
    | '/studio/prompts/$promptId'
    | '/studio/skills/$skillId'
    | '/studio/tools/$toolId'
    | '/studio/tools/new'
    | '/sysadmin/administrators/activity'
    | '/sysadmin/administrators/sessions'
    | '/sysadmin/audit/exports'
    | '/sysadmin/audit/integrity'
    | '/sysadmin/audit/stream'
    | '/sysadmin/audit/sysadmin'
    | '/sysadmin/audit/witness'
    | '/sysadmin/catalog/agents'
    | '/sysadmin/catalog/argus-live'
    | '/sysadmin/catalog/assignments'
    | '/sysadmin/catalog/functions'
    | '/sysadmin/catalog/knowledge'
    | '/sysadmin/catalog/mcp'
    | '/sysadmin/catalog/models'
    | '/sysadmin/catalog/prompts'
    | '/sysadmin/catalog/skills'
    | '/sysadmin/catalog/tools'
    | '/sysadmin/catalog/workflows'
    | '/sysadmin/fine-tuning/adapters'
    | '/sysadmin/fine-tuning/evaluation'
    | '/sysadmin/fine-tuning/golden-set'
    | '/sysadmin/fine-tuning/training-data'
    | '/sysadmin/governance/approvals'
    | '/sysadmin/governance/classification'
    | '/sysadmin/governance/compliance'
    | '/sysadmin/governance/guardrails'
    | '/sysadmin/governance/pii'
    | '/sysadmin/library/articles'
    | '/sysadmin/library/document-folders'
    | '/sysadmin/library/documents'
    | '/sysadmin/library/folders'
    | '/sysadmin/library/sources'
    | '/sysadmin/library/tags'
    | '/sysadmin/models/$id'
    | '/sysadmin/models/assignments'
    | '/sysadmin/models/functions'
    | '/sysadmin/models/history'
    | '/sysadmin/models/new'
    | '/sysadmin/models/runtime'
    | '/sysadmin/models/trust-toggles'
    | '/sysadmin/platform/airgap'
    | '/sysadmin/platform/backups'
    | '/sysadmin/platform/builder-analytics'
    | '/sysadmin/platform/deployment'
    | '/sysadmin/platform/hardware-profiles'
    | '/sysadmin/platform/helper-budgets'
    | '/sysadmin/platform/keys'
    | '/sysadmin/platform/license'
    | '/sysadmin/platform/updates'
    | '/sysadmin/runtime/hardware'
    | '/sysadmin/runtime/health'
    | '/sysadmin/runtime/inference'
    | '/sysadmin/runtime/mcp'
    | '/sysadmin/runtime/queues'
    | '/sysadmin/runtime/storage'
    | '/sysadmin/settings/api'
    | '/sysadmin/settings/email'
    | '/sysadmin/settings/idp'
    | '/sysadmin/settings/notifications'
    | '/sysadmin/studio/agents'
    | '/sysadmin/studio/categories'
    | '/sysadmin/studio/prompts'
    | '/sysadmin/studio/skills'
    | '/sysadmin/studio/tools'
    | '/sysadmin/tenants/$tenantId'
    | '/trust/frameworks/$frameworkId'
    | '/users/groups/$groupId'
    | '/admin/audit/'
    | '/admin/discover/'
    | '/admin/health/'
    | '/admin/notifications/'
    | '/admin/security/'
    | '/admin/settings/'
    | '/agents/$agentId/'
    | '/library/sources/'
    | '/studio/bundles/'
    | '/studio/prompts/'
    | '/studio/skills/'
    | '/studio/tools/'
    | '/sysadmin/administrators/'
    | '/sysadmin/audit/'
    | '/sysadmin/catalog/'
    | '/sysadmin/fine-tuning/'
    | '/sysadmin/governance/'
    | '/sysadmin/library/'
    | '/sysadmin/models/'
    | '/sysadmin/platform/'
    | '/sysadmin/runtime/'
    | '/sysadmin/settings/'
    | '/sysadmin/studio/'
    | '/sysadmin/tenants/'
    | '/trust/frameworks/'
    | '/argus-live/dashboards/$id/edit'
    | '/library/wiki/$articleId/edit'
    | '/sysadmin/catalog/agents/$id'
    | '/sysadmin/catalog/agents/builder'
    | '/sysadmin/catalog/agents/new'
    | '/sysadmin/catalog/argus-live/$id'
    | '/sysadmin/catalog/functions/new'
    | '/sysadmin/catalog/mcp/$id'
    | '/sysadmin/catalog/mcp/new'
    | '/sysadmin/catalog/skills/$id'
    | '/sysadmin/catalog/tools/$id'
    | '/sysadmin/catalog/tools/new'
    | '/sysadmin/catalog/workflows/$id'
    | '/sysadmin/tenants/$tenantId/assignments'
    | '/sysadmin/tenants/$tenantId/audit'
    | '/sysadmin/tenants/$tenantId/branding'
    | '/sysadmin/tenants/$tenantId/compliance'
    | '/sysadmin/tenants/$tenantId/hardware'
    | '/sysadmin/tenants/$tenantId/limits'
    | '/sysadmin/tenants/$tenantId/memory'
    | '/sysadmin/tenants/$tenantId/settings'
    | '/sysadmin/tenants/$tenantId/users'
    | '/argus-live/dashboards/$id/'
    | '/sysadmin/catalog/agents/'
    | '/sysadmin/catalog/argus-live/'
    | '/sysadmin/catalog/functions/'
    | '/sysadmin/catalog/mcp/'
    | '/sysadmin/catalog/skills/'
    | '/sysadmin/catalog/tools/'
    | '/sysadmin/catalog/workflows/'
    | '/sysadmin/tenants/$tenantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/admin'
    | '/analytics'
    | '/branding'
    | '/evaluation'
    | '/help'
    | '/login'
    | '/mcp'
    | '/models'
    | '/organization-profiles'
    | '/playground'
    | '/roles'
    | '/security'
    | '/settings'
    | '/workspace'
    | '/admin/branding'
    | '/admin/helper-budgets'
    | '/admin/playground'
    | '/admin/users'
    | '/agents/builder'
    | '/agents/gallery'
    | '/agents/new'
    | '/approvals/$approvalId'
    | '/approvals/history'
    | '/approvals/settings'
    | '/ask-argus/memories'
    | '/ask-argus/projects'
    | '/auth/callback'
    | '/automate/history'
    | '/automate/new'
    | '/automate/nodes'
    | '/automate/playbooks'
    | '/connections/$connectionId'
    | '/connections/api'
    | '/connections/functions'
    | '/connections/health'
    | '/connections/marketplace'
    | '/connections/mcp'
    | '/connections/new-api'
    | '/connections/new-function'
    | '/connections/new-mcp'
    | '/insights/adoption'
    | '/insights/agents-knowledge'
    | '/insights/cost'
    | '/insights/quality'
    | '/insights/risk'
    | '/insights/value'
    | '/invite/$token'
    | '/library/documents'
    | '/library/folders'
    | '/library/quality'
    | '/library/search'
    | '/library/shared'
    | '/library/system'
    | '/library/wiki'
    | '/organizations/$orgId'
    | '/setup/$token'
    | '/shared/$token'
    | '/studio/functions'
    | '/studio/templates'
    | '/sysadmin/admins'
    | '/sysadmin/audit-chain'
    | '/sysadmin/branding'
    | '/trust/activity'
    | '/trust/ai-systems'
    | '/trust/audit'
    | '/trust/data-flows'
    | '/trust/evidence'
    | '/trust/violations'
    | '/users/$userId'
    | '/users/activity'
    | '/users/departments'
    | '/users/groups'
    | '/users/invitations'
    | '/users/roles'
    | '/users/sso'
    | '/agents'
    | '/approvals'
    | '/argus-live'
    | '/ask-argus'
    | '/automate'
    | '/connections'
    | '/insights'
    | '/library'
    | '/organizations'
    | '/setup'
    | '/studio'
    | '/sysadmin'
    | '/trust'
    | '/users'
    | '/admin/audit/changes'
    | '/admin/audit/integrity'
    | '/admin/discover/agents'
    | '/admin/discover/connections'
    | '/admin/discover/functions'
    | '/admin/discover/prompts'
    | '/admin/discover/skills'
    | '/admin/discover/tools'
    | '/admin/health/infra'
    | '/admin/health/pipeline'
    | '/admin/health/services'
    | '/admin/notifications/channels'
    | '/admin/notifications/escalation'
    | '/admin/notifications/log'
    | '/admin/security/keys'
    | '/admin/security/privileged'
    | '/admin/security/session'
    | '/admin/security/threat'
    | '/admin/settings/api'
    | '/admin/settings/compliance'
    | '/admin/settings/data'
    | '/admin/settings/integrations'
    | '/agents/$agentId/edit'
    | '/argus-live/dashboards/new'
    | '/ask-argus/project/$projectId'
    | '/automate/history/$executionId'
    | '/automate/playbooks/$playbookId'
    | '/automate/workflows/$id'
    | '/connections/api/$connectionId'
    | '/connections/api/new'
    | '/connections/functions/$functionId'
    | '/connections/functions/new'
    | '/connections/mcp/$connectionId'
    | '/connections/mcp/marketplace'
    | '/library/article/$articleId'
    | '/library/doc/$docId'
    | '/library/sources/$sourceId'
    | '/library/sources/connect'
    | '/library/wiki/$articleId'
    | '/library/wiki/new'
    | '/studio/bundles/$id'
    | '/studio/bundles/new'
    | '/studio/prompts/$promptId'
    | '/studio/skills/$skillId'
    | '/studio/tools/$toolId'
    | '/studio/tools/new'
    | '/sysadmin/administrators/activity'
    | '/sysadmin/administrators/sessions'
    | '/sysadmin/audit/exports'
    | '/sysadmin/audit/integrity'
    | '/sysadmin/audit/stream'
    | '/sysadmin/audit/sysadmin'
    | '/sysadmin/audit/witness'
    | '/sysadmin/catalog/assignments'
    | '/sysadmin/catalog/knowledge'
    | '/sysadmin/catalog/models'
    | '/sysadmin/catalog/prompts'
    | '/sysadmin/fine-tuning/adapters'
    | '/sysadmin/fine-tuning/evaluation'
    | '/sysadmin/fine-tuning/golden-set'
    | '/sysadmin/fine-tuning/training-data'
    | '/sysadmin/governance/approvals'
    | '/sysadmin/governance/classification'
    | '/sysadmin/governance/compliance'
    | '/sysadmin/governance/guardrails'
    | '/sysadmin/governance/pii'
    | '/sysadmin/library/articles'
    | '/sysadmin/library/document-folders'
    | '/sysadmin/library/documents'
    | '/sysadmin/library/folders'
    | '/sysadmin/library/sources'
    | '/sysadmin/library/tags'
    | '/sysadmin/models/$id'
    | '/sysadmin/models/assignments'
    | '/sysadmin/models/functions'
    | '/sysadmin/models/history'
    | '/sysadmin/models/new'
    | '/sysadmin/models/runtime'
    | '/sysadmin/models/trust-toggles'
    | '/sysadmin/platform/airgap'
    | '/sysadmin/platform/backups'
    | '/sysadmin/platform/builder-analytics'
    | '/sysadmin/platform/deployment'
    | '/sysadmin/platform/hardware-profiles'
    | '/sysadmin/platform/helper-budgets'
    | '/sysadmin/platform/keys'
    | '/sysadmin/platform/license'
    | '/sysadmin/platform/updates'
    | '/sysadmin/runtime/hardware'
    | '/sysadmin/runtime/health'
    | '/sysadmin/runtime/inference'
    | '/sysadmin/runtime/mcp'
    | '/sysadmin/runtime/queues'
    | '/sysadmin/runtime/storage'
    | '/sysadmin/settings/api'
    | '/sysadmin/settings/email'
    | '/sysadmin/settings/idp'
    | '/sysadmin/settings/notifications'
    | '/sysadmin/studio/agents'
    | '/sysadmin/studio/categories'
    | '/sysadmin/studio/prompts'
    | '/sysadmin/studio/skills'
    | '/sysadmin/studio/tools'
    | '/trust/frameworks/$frameworkId'
    | '/users/groups/$groupId'
    | '/admin/audit'
    | '/admin/discover'
    | '/admin/health'
    | '/admin/notifications'
    | '/admin/security'
    | '/admin/settings'
    | '/agents/$agentId'
    | '/library/sources'
    | '/studio/bundles'
    | '/studio/prompts'
    | '/studio/skills'
    | '/studio/tools'
    | '/sysadmin/administrators'
    | '/sysadmin/audit'
    | '/sysadmin/catalog'
    | '/sysadmin/fine-tuning'
    | '/sysadmin/governance'
    | '/sysadmin/library'
    | '/sysadmin/models'
    | '/sysadmin/platform'
    | '/sysadmin/runtime'
    | '/sysadmin/settings'
    | '/sysadmin/studio'
    | '/sysadmin/tenants'
    | '/trust/frameworks'
    | '/argus-live/dashboards/$id/edit'
    | '/library/wiki/$articleId/edit'
    | '/sysadmin/catalog/agents/$id'
    | '/sysadmin/catalog/agents/builder'
    | '/sysadmin/catalog/agents/new'
    | '/sysadmin/catalog/argus-live/$id'
    | '/sysadmin/catalog/functions/new'
    | '/sysadmin/catalog/mcp/$id'
    | '/sysadmin/catalog/mcp/new'
    | '/sysadmin/catalog/skills/$id'
    | '/sysadmin/catalog/tools/$id'
    | '/sysadmin/catalog/tools/new'
    | '/sysadmin/catalog/workflows/$id'
    | '/sysadmin/tenants/$tenantId/assignments'
    | '/sysadmin/tenants/$tenantId/audit'
    | '/sysadmin/tenants/$tenantId/branding'
    | '/sysadmin/tenants/$tenantId/compliance'
    | '/sysadmin/tenants/$tenantId/hardware'
    | '/sysadmin/tenants/$tenantId/limits'
    | '/sysadmin/tenants/$tenantId/memory'
    | '/sysadmin/tenants/$tenantId/settings'
    | '/sysadmin/tenants/$tenantId/users'
    | '/argus-live/dashboards/$id'
    | '/sysadmin/catalog/agents'
    | '/sysadmin/catalog/argus-live'
    | '/sysadmin/catalog/functions'
    | '/sysadmin/catalog/mcp'
    | '/sysadmin/catalog/skills'
    | '/sysadmin/catalog/tools'
    | '/sysadmin/catalog/workflows'
    | '/sysadmin/tenants/$tenantId'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/admin'
    | '/agents'
    | '/analytics'
    | '/approvals'
    | '/ask-argus'
    | '/automate'
    | '/branding'
    | '/connections'
    | '/evaluation'
    | '/help'
    | '/insights'
    | '/library'
    | '/login'
    | '/mcp'
    | '/models'
    | '/organization-profiles'
    | '/organizations'
    | '/playground'
    | '/roles'
    | '/security'
    | '/settings'
    | '/studio'
    | '/sysadmin'
    | '/trust'
    | '/users'
    | '/workspace'
    | '/admin/audit'
    | '/admin/branding'
    | '/admin/health'
    | '/admin/helper-budgets'
    | '/admin/notifications'
    | '/admin/playground'
    | '/admin/security'
    | '/admin/settings'
    | '/admin/users'
    | '/agents/builder'
    | '/agents/gallery'
    | '/agents/new'
    | '/approvals/$approvalId'
    | '/approvals/history'
    | '/approvals/settings'
    | '/ask-argus/memories'
    | '/ask-argus/projects'
    | '/auth/callback'
    | '/automate/history'
    | '/automate/new'
    | '/automate/nodes'
    | '/automate/playbooks'
    | '/connections/$connectionId'
    | '/connections/api'
    | '/connections/functions'
    | '/connections/health'
    | '/connections/marketplace'
    | '/connections/mcp'
    | '/connections/new-api'
    | '/connections/new-function'
    | '/connections/new-mcp'
    | '/insights/adoption'
    | '/insights/agents-knowledge'
    | '/insights/cost'
    | '/insights/quality'
    | '/insights/risk'
    | '/insights/value'
    | '/invite/$token'
    | '/library/documents'
    | '/library/folders'
    | '/library/quality'
    | '/library/search'
    | '/library/shared'
    | '/library/system'
    | '/library/wiki'
    | '/organizations/$orgId'
    | '/setup/$token'
    | '/shared/$token'
    | '/studio/bundles'
    | '/studio/functions'
    | '/studio/prompts'
    | '/studio/skills'
    | '/studio/templates'
    | '/studio/tools'
    | '/sysadmin/administrators'
    | '/sysadmin/admins'
    | '/sysadmin/audit'
    | '/sysadmin/audit-chain'
    | '/sysadmin/branding'
    | '/sysadmin/catalog'
    | '/sysadmin/fine-tuning'
    | '/sysadmin/governance'
    | '/sysadmin/library'
    | '/sysadmin/models'
    | '/sysadmin/platform'
    | '/sysadmin/runtime'
    | '/sysadmin/settings'
    | '/sysadmin/studio'
    | '/sysadmin/tenants'
    | '/trust/activity'
    | '/trust/ai-systems'
    | '/trust/audit'
    | '/trust/data-flows'
    | '/trust/evidence'
    | '/trust/violations'
    | '/users/$userId'
    | '/users/activity'
    | '/users/departments'
    | '/users/groups'
    | '/users/invitations'
    | '/users/roles'
    | '/users/sso'
    | '/agents/'
    | '/approvals/'
    | '/argus-live/'
    | '/ask-argus/'
    | '/automate/'
    | '/connections/'
    | '/insights/'
    | '/library/'
    | '/organizations/'
    | '/setup/'
    | '/studio/'
    | '/sysadmin/'
    | '/trust/'
    | '/users/'
    | '/admin/audit/changes'
    | '/admin/audit/integrity'
    | '/admin/discover/agents'
    | '/admin/discover/connections'
    | '/admin/discover/functions'
    | '/admin/discover/prompts'
    | '/admin/discover/skills'
    | '/admin/discover/tools'
    | '/admin/health/infra'
    | '/admin/health/pipeline'
    | '/admin/health/services'
    | '/admin/notifications/channels'
    | '/admin/notifications/escalation'
    | '/admin/notifications/log'
    | '/admin/security/keys'
    | '/admin/security/privileged'
    | '/admin/security/session'
    | '/admin/security/threat'
    | '/admin/settings/api'
    | '/admin/settings/compliance'
    | '/admin/settings/data'
    | '/admin/settings/integrations'
    | '/agents/$agentId/edit'
    | '/argus-live/dashboards/$id'
    | '/argus-live/dashboards/new'
    | '/ask-argus/project/$projectId'
    | '/automate/history/$executionId'
    | '/automate/playbooks/$playbookId'
    | '/automate/workflows/$id'
    | '/connections/api/$connectionId'
    | '/connections/api/new'
    | '/connections/functions/$functionId'
    | '/connections/functions/new'
    | '/connections/mcp/$connectionId'
    | '/connections/mcp/marketplace'
    | '/library/article/$articleId'
    | '/library/doc/$docId'
    | '/library/sources/$sourceId'
    | '/library/sources/connect'
    | '/library/wiki/$articleId'
    | '/library/wiki/new'
    | '/studio/bundles/$id'
    | '/studio/bundles/new'
    | '/studio/prompts/$promptId'
    | '/studio/skills/$skillId'
    | '/studio/tools/$toolId'
    | '/studio/tools/new'
    | '/sysadmin/administrators/activity'
    | '/sysadmin/administrators/sessions'
    | '/sysadmin/audit/exports'
    | '/sysadmin/audit/integrity'
    | '/sysadmin/audit/stream'
    | '/sysadmin/audit/sysadmin'
    | '/sysadmin/audit/witness'
    | '/sysadmin/catalog/agents'
    | '/sysadmin/catalog/argus-live'
    | '/sysadmin/catalog/assignments'
    | '/sysadmin/catalog/functions'
    | '/sysadmin/catalog/knowledge'
    | '/sysadmin/catalog/mcp'
    | '/sysadmin/catalog/models'
    | '/sysadmin/catalog/prompts'
    | '/sysadmin/catalog/skills'
    | '/sysadmin/catalog/tools'
    | '/sysadmin/catalog/workflows'
    | '/sysadmin/fine-tuning/adapters'
    | '/sysadmin/fine-tuning/evaluation'
    | '/sysadmin/fine-tuning/golden-set'
    | '/sysadmin/fine-tuning/training-data'
    | '/sysadmin/governance/approvals'
    | '/sysadmin/governance/classification'
    | '/sysadmin/governance/compliance'
    | '/sysadmin/governance/guardrails'
    | '/sysadmin/governance/pii'
    | '/sysadmin/library/articles'
    | '/sysadmin/library/document-folders'
    | '/sysadmin/library/documents'
    | '/sysadmin/library/folders'
    | '/sysadmin/library/sources'
    | '/sysadmin/library/tags'
    | '/sysadmin/models/$id'
    | '/sysadmin/models/assignments'
    | '/sysadmin/models/functions'
    | '/sysadmin/models/history'
    | '/sysadmin/models/new'
    | '/sysadmin/models/runtime'
    | '/sysadmin/models/trust-toggles'
    | '/sysadmin/platform/airgap'
    | '/sysadmin/platform/backups'
    | '/sysadmin/platform/builder-analytics'
    | '/sysadmin/platform/deployment'
    | '/sysadmin/platform/hardware-profiles'
    | '/sysadmin/platform/helper-budgets'
    | '/sysadmin/platform/keys'
    | '/sysadmin/platform/license'
    | '/sysadmin/platform/updates'
    | '/sysadmin/runtime/hardware'
    | '/sysadmin/runtime/health'
    | '/sysadmin/runtime/inference'
    | '/sysadmin/runtime/mcp'
    | '/sysadmin/runtime/queues'
    | '/sysadmin/runtime/storage'
    | '/sysadmin/settings/api'
    | '/sysadmin/settings/email'
    | '/sysadmin/settings/idp'
    | '/sysadmin/settings/notifications'
    | '/sysadmin/studio/agents'
    | '/sysadmin/studio/categories'
    | '/sysadmin/studio/prompts'
    | '/sysadmin/studio/skills'
    | '/sysadmin/studio/tools'
    | '/sysadmin/tenants/$tenantId'
    | '/trust/frameworks/$frameworkId'
    | '/users/groups/$groupId'
    | '/admin/audit/'
    | '/admin/discover/'
    | '/admin/health/'
    | '/admin/notifications/'
    | '/admin/security/'
    | '/admin/settings/'
    | '/agents/$agentId/'
    | '/library/sources/'
    | '/studio/bundles/'
    | '/studio/prompts/'
    | '/studio/skills/'
    | '/studio/tools/'
    | '/sysadmin/administrators/'
    | '/sysadmin/audit/'
    | '/sysadmin/catalog/'
    | '/sysadmin/fine-tuning/'
    | '/sysadmin/governance/'
    | '/sysadmin/library/'
    | '/sysadmin/models/'
    | '/sysadmin/platform/'
    | '/sysadmin/runtime/'
    | '/sysadmin/settings/'
    | '/sysadmin/studio/'
    | '/sysadmin/tenants/'
    | '/trust/frameworks/'
    | '/argus-live/dashboards/$id/edit'
    | '/library/wiki/$articleId/edit'
    | '/sysadmin/catalog/agents/$id'
    | '/sysadmin/catalog/agents/builder'
    | '/sysadmin/catalog/agents/new'
    | '/sysadmin/catalog/argus-live/$id'
    | '/sysadmin/catalog/functions/new'
    | '/sysadmin/catalog/mcp/$id'
    | '/sysadmin/catalog/mcp/new'
    | '/sysadmin/catalog/skills/$id'
    | '/sysadmin/catalog/tools/$id'
    | '/sysadmin/catalog/tools/new'
    | '/sysadmin/catalog/workflows/$id'
    | '/sysadmin/tenants/$tenantId/assignments'
    | '/sysadmin/tenants/$tenantId/audit'
    | '/sysadmin/tenants/$tenantId/branding'
    | '/sysadmin/tenants/$tenantId/compliance'
    | '/sysadmin/tenants/$tenantId/hardware'
    | '/sysadmin/tenants/$tenantId/limits'
    | '/sysadmin/tenants/$tenantId/memory'
    | '/sysadmin/tenants/$tenantId/settings'
    | '/sysadmin/tenants/$tenantId/users'
    | '/argus-live/dashboards/$id/'
    | '/sysadmin/catalog/agents/'
    | '/sysadmin/catalog/argus-live/'
    | '/sysadmin/catalog/functions/'
    | '/sysadmin/catalog/mcp/'
    | '/sysadmin/catalog/skills/'
    | '/sysadmin/catalog/tools/'
    | '/sysadmin/catalog/workflows/'
    | '/sysadmin/tenants/$tenantId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRouteWithChildren
  AgentsRoute: typeof AgentsRouteWithChildren
  AnalyticsRoute: typeof AnalyticsRoute
  ApprovalsRoute: typeof ApprovalsRouteWithChildren
  AskArgusRoute: typeof AskArgusRouteWithChildren
  AutomateRoute: typeof AutomateRouteWithChildren
  BrandingRoute: typeof BrandingRoute
  ConnectionsRoute: typeof ConnectionsRouteWithChildren
  EvaluationRoute: typeof EvaluationRoute
  HelpRoute: typeof HelpRoute
  InsightsRoute: typeof InsightsRouteWithChildren
  LibraryRoute: typeof LibraryRouteWithChildren
  LoginRoute: typeof LoginRoute
  McpRoute: typeof McpRoute
  ModelsRoute: typeof ModelsRoute
  OrganizationProfilesRoute: typeof OrganizationProfilesRoute
  OrganizationsRoute: typeof OrganizationsRouteWithChildren
  PlaygroundRoute: typeof PlaygroundRoute
  RolesRoute: typeof RolesRoute
  SecurityRoute: typeof SecurityRoute
  SettingsRoute: typeof SettingsRoute
  StudioRoute: typeof StudioRouteWithChildren
  SysadminRoute: typeof SysadminRouteWithChildren
  TrustRoute: typeof TrustRouteWithChildren
  UsersRoute: typeof UsersRouteWithChildren
  WorkspaceRoute: typeof WorkspaceRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InviteTokenRoute: typeof InviteTokenRoute
  SetupTokenRoute: typeof SetupTokenRoute
  SharedTokenRoute: typeof SharedTokenRoute
  ArgusLiveIndexRoute: typeof ArgusLiveIndexRoute
  SetupIndexRoute: typeof SetupIndexRoute
  ArgusLiveDashboardsIdRoute: typeof ArgusLiveDashboardsIdRouteWithChildren
  ArgusLiveDashboardsNewRoute: typeof ArgusLiveDashboardsNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace': {
      id: '/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust': {
      id: '/trust'
      path: '/trust'
      fullPath: '/trust'
      preLoaderRoute: typeof TrustRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sysadmin': {
      id: '/sysadmin'
      path: '/sysadmin'
      fullPath: '/sysadmin'
      preLoaderRoute: typeof SysadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles': {
      id: '/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof RolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization-profiles': {
      id: '/organization-profiles'
      path: '/organization-profiles'
      fullPath: '/organization-profiles'
      preLoaderRoute: typeof OrganizationProfilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/models': {
      id: '/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof ModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights': {
      id: '/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof InsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluation': {
      id: '/evaluation'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof EvaluationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections': {
      id: '/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branding': {
      id: '/branding'
      path: '/branding'
      fullPath: '/branding'
      preLoaderRoute: typeof BrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automate': {
      id: '/automate'
      path: '/automate'
      fullPath: '/automate'
      preLoaderRoute: typeof AutomateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ask-argus': {
      id: '/ask-argus'
      path: '/ask-argus'
      fullPath: '/ask-argus'
      preLoaderRoute: typeof AskArgusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRoute
    }
    '/trust/': {
      id: '/trust/'
      path: '/'
      fullPath: '/trust/'
      preLoaderRoute: typeof TrustIndexRouteImport
      parentRoute: typeof TrustRoute
    }
    '/sysadmin/': {
      id: '/sysadmin/'
      path: '/'
      fullPath: '/sysadmin/'
      preLoaderRoute: typeof SysadminIndexRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/studio/': {
      id: '/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof StudioIndexRouteImport
      parentRoute: typeof StudioRoute
    }
    '/setup/': {
      id: '/setup/'
      path: '/setup'
      fullPath: '/setup/'
      preLoaderRoute: typeof SetupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof OrganizationsRoute
    }
    '/library/': {
      id: '/library/'
      path: '/'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/insights/': {
      id: '/insights/'
      path: '/'
      fullPath: '/insights/'
      preLoaderRoute: typeof InsightsIndexRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/connections/': {
      id: '/connections/'
      path: '/'
      fullPath: '/connections/'
      preLoaderRoute: typeof ConnectionsIndexRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/automate/': {
      id: '/automate/'
      path: '/'
      fullPath: '/automate/'
      preLoaderRoute: typeof AutomateIndexRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/ask-argus/': {
      id: '/ask-argus/'
      path: '/'
      fullPath: '/ask-argus/'
      preLoaderRoute: typeof AskArgusIndexRouteImport
      parentRoute: typeof AskArgusRoute
    }
    '/argus-live/': {
      id: '/argus-live/'
      path: '/argus-live'
      fullPath: '/argus-live/'
      preLoaderRoute: typeof ArgusLiveIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals/': {
      id: '/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof ApprovalsIndexRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/users/sso': {
      id: '/users/sso'
      path: '/sso'
      fullPath: '/users/sso'
      preLoaderRoute: typeof UsersSsoRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/roles': {
      id: '/users/roles'
      path: '/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof UsersRolesRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/invitations': {
      id: '/users/invitations'
      path: '/invitations'
      fullPath: '/users/invitations'
      preLoaderRoute: typeof UsersInvitationsRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/groups': {
      id: '/users/groups'
      path: '/groups'
      fullPath: '/users/groups'
      preLoaderRoute: typeof UsersGroupsRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/departments': {
      id: '/users/departments'
      path: '/departments'
      fullPath: '/users/departments'
      preLoaderRoute: typeof UsersDepartmentsRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/activity': {
      id: '/users/activity'
      path: '/activity'
      fullPath: '/users/activity'
      preLoaderRoute: typeof UsersActivityRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof UsersRoute
    }
    '/trust/violations': {
      id: '/trust/violations'
      path: '/violations'
      fullPath: '/trust/violations'
      preLoaderRoute: typeof TrustViolationsRouteImport
      parentRoute: typeof TrustRoute
    }
    '/trust/evidence': {
      id: '/trust/evidence'
      path: '/evidence'
      fullPath: '/trust/evidence'
      preLoaderRoute: typeof TrustEvidenceRouteImport
      parentRoute: typeof TrustRoute
    }
    '/trust/data-flows': {
      id: '/trust/data-flows'
      path: '/data-flows'
      fullPath: '/trust/data-flows'
      preLoaderRoute: typeof TrustDataFlowsRouteImport
      parentRoute: typeof TrustRoute
    }
    '/trust/audit': {
      id: '/trust/audit'
      path: '/audit'
      fullPath: '/trust/audit'
      preLoaderRoute: typeof TrustAuditRouteImport
      parentRoute: typeof TrustRoute
    }
    '/trust/ai-systems': {
      id: '/trust/ai-systems'
      path: '/ai-systems'
      fullPath: '/trust/ai-systems'
      preLoaderRoute: typeof TrustAiSystemsRouteImport
      parentRoute: typeof TrustRoute
    }
    '/trust/activity': {
      id: '/trust/activity'
      path: '/activity'
      fullPath: '/trust/activity'
      preLoaderRoute: typeof TrustActivityRouteImport
      parentRoute: typeof TrustRoute
    }
    '/sysadmin/tenants': {
      id: '/sysadmin/tenants'
      path: '/tenants'
      fullPath: '/sysadmin/tenants'
      preLoaderRoute: typeof SysadminTenantsRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/studio': {
      id: '/sysadmin/studio'
      path: '/studio'
      fullPath: '/sysadmin/studio'
      preLoaderRoute: typeof SysadminStudioRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/settings': {
      id: '/sysadmin/settings'
      path: '/settings'
      fullPath: '/sysadmin/settings'
      preLoaderRoute: typeof SysadminSettingsRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/runtime': {
      id: '/sysadmin/runtime'
      path: '/runtime'
      fullPath: '/sysadmin/runtime'
      preLoaderRoute: typeof SysadminRuntimeRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/platform': {
      id: '/sysadmin/platform'
      path: '/platform'
      fullPath: '/sysadmin/platform'
      preLoaderRoute: typeof SysadminPlatformRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/models': {
      id: '/sysadmin/models'
      path: '/models'
      fullPath: '/sysadmin/models'
      preLoaderRoute: typeof SysadminModelsRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/library': {
      id: '/sysadmin/library'
      path: '/library'
      fullPath: '/sysadmin/library'
      preLoaderRoute: typeof SysadminLibraryRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/governance': {
      id: '/sysadmin/governance'
      path: '/governance'
      fullPath: '/sysadmin/governance'
      preLoaderRoute: typeof SysadminGovernanceRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/fine-tuning': {
      id: '/sysadmin/fine-tuning'
      path: '/fine-tuning'
      fullPath: '/sysadmin/fine-tuning'
      preLoaderRoute: typeof SysadminFineTuningRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/catalog': {
      id: '/sysadmin/catalog'
      path: '/catalog'
      fullPath: '/sysadmin/catalog'
      preLoaderRoute: typeof SysadminCatalogRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/branding': {
      id: '/sysadmin/branding'
      path: '/branding'
      fullPath: '/sysadmin/branding'
      preLoaderRoute: typeof SysadminBrandingRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/audit-chain': {
      id: '/sysadmin/audit-chain'
      path: '/audit-chain'
      fullPath: '/sysadmin/audit-chain'
      preLoaderRoute: typeof SysadminAuditChainRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/audit': {
      id: '/sysadmin/audit'
      path: '/audit'
      fullPath: '/sysadmin/audit'
      preLoaderRoute: typeof SysadminAuditRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/admins': {
      id: '/sysadmin/admins'
      path: '/admins'
      fullPath: '/sysadmin/admins'
      preLoaderRoute: typeof SysadminAdminsRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/sysadmin/administrators': {
      id: '/sysadmin/administrators'
      path: '/administrators'
      fullPath: '/sysadmin/administrators'
      preLoaderRoute: typeof SysadminAdministratorsRouteImport
      parentRoute: typeof SysadminRoute
    }
    '/studio/tools': {
      id: '/studio/tools'
      path: '/tools'
      fullPath: '/studio/tools'
      preLoaderRoute: typeof StudioToolsRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/templates': {
      id: '/studio/templates'
      path: '/templates'
      fullPath: '/studio/templates'
      preLoaderRoute: typeof StudioTemplatesRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/skills': {
      id: '/studio/skills'
      path: '/skills'
      fullPath: '/studio/skills'
      preLoaderRoute: typeof StudioSkillsRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/prompts': {
      id: '/studio/prompts'
      path: '/prompts'
      fullPath: '/studio/prompts'
      preLoaderRoute: typeof StudioPromptsRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/functions': {
      id: '/studio/functions'
      path: '/functions'
      fullPath: '/studio/functions'
      preLoaderRoute: typeof StudioFunctionsRouteImport
      parentRoute: typeof StudioRoute
    }
    '/studio/bundles': {
      id: '/studio/bundles'
      path: '/bundles'
      fullPath: '/studio/bundles'
      preLoaderRoute: typeof StudioBundlesRouteImport
      parentRoute: typeof StudioRoute
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/$token': {
      id: '/setup/$token'
      path: '/setup/$token'
      fullPath: '/setup/$token'
      preLoaderRoute: typeof SetupTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$orgId': {
      id: '/organizations/$orgId'
      path: '/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof OrganizationsOrgIdRouteImport
      parentRoute: typeof OrganizationsRoute
    }
    '/library/wiki': {
      id: '/library/wiki'
      path: '/wiki'
      fullPath: '/library/wiki'
      preLoaderRoute: typeof LibraryWikiRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/system': {
      id: '/library/system'
      path: '/system'
      fullPath: '/library/system'
      preLoaderRoute: typeof LibrarySystemRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/shared': {
      id: '/library/shared'
      path: '/shared'
      fullPath: '/library/shared'
      preLoaderRoute: typeof LibrarySharedRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/search': {
      id: '/library/search'
      path: '/search'
      fullPath: '/library/search'
      preLoaderRoute: typeof LibrarySearchRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/quality': {
      id: '/library/quality'
      path: '/quality'
      fullPath: '/library/quality'
      preLoaderRoute: typeof LibraryQualityRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/folders': {
      id: '/library/folders'
      path: '/folders'
      fullPath: '/library/folders'
      preLoaderRoute: typeof LibraryFoldersRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/documents': {
      id: '/library/documents'
      path: '/documents'
      fullPath: '/library/documents'
      preLoaderRoute: typeof LibraryDocumentsRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights/value': {
      id: '/insights/value'
      path: '/value'
      fullPath: '/insights/value'
      preLoaderRoute: typeof InsightsValueRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/insights/risk': {
      id: '/insights/risk'
      path: '/risk'
      fullPath: '/insights/risk'
      preLoaderRoute: typeof InsightsRiskRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/insights/quality': {
      id: '/insights/quality'
      path: '/quality'
      fullPath: '/insights/quality'
      preLoaderRoute: typeof InsightsQualityRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/insights/cost': {
      id: '/insights/cost'
      path: '/cost'
      fullPath: '/insights/cost'
      preLoaderRoute: typeof InsightsCostRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/insights/agents-knowledge': {
      id: '/insights/agents-knowledge'
      path: '/agents-knowledge'
      fullPath: '/insights/agents-knowledge'
      preLoaderRoute: typeof InsightsAgentsKnowledgeRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/insights/adoption': {
      id: '/insights/adoption'
      path: '/adoption'
      fullPath: '/insights/adoption'
      preLoaderRoute: typeof InsightsAdoptionRouteImport
      parentRoute: typeof InsightsRoute
    }
    '/connections/new-mcp': {
      id: '/connections/new-mcp'
      path: '/new-mcp'
      fullPath: '/connections/new-mcp'
      preLoaderRoute: typeof ConnectionsNewMcpRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/new-function': {
      id: '/connections/new-function'
      path: '/new-function'
      fullPath: '/connections/new-function'
      preLoaderRoute: typeof ConnectionsNewFunctionRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/new-api': {
      id: '/connections/new-api'
      path: '/new-api'
      fullPath: '/connections/new-api'
      preLoaderRoute: typeof ConnectionsNewApiRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/mcp': {
      id: '/connections/mcp'
      path: '/mcp'
      fullPath: '/connections/mcp'
      preLoaderRoute: typeof ConnectionsMcpRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/marketplace': {
      id: '/connections/marketplace'
      path: '/marketplace'
      fullPath: '/connections/marketplace'
      preLoaderRoute: typeof ConnectionsMarketplaceRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/health': {
      id: '/connections/health'
      path: '/health'
      fullPath: '/connections/health'
      preLoaderRoute: typeof ConnectionsHealthRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/functions': {
      id: '/connections/functions'
      path: '/functions'
      fullPath: '/connections/functions'
      preLoaderRoute: typeof ConnectionsFunctionsRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/api': {
      id: '/connections/api'
      path: '/api'
      fullPath: '/connections/api'
      preLoaderRoute: typeof ConnectionsApiRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/connections/$connectionId': {
      id: '/connections/$connectionId'
      path: '/$connectionId'
      fullPath: '/connections/$connectionId'
      preLoaderRoute: typeof ConnectionsConnectionIdRouteImport
      parentRoute: typeof ConnectionsRoute
    }
    '/automate/playbooks': {
      id: '/automate/playbooks'
      path: '/playbooks'
      fullPath: '/automate/playbooks'
      preLoaderRoute: typeof AutomatePlaybooksRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/automate/nodes': {
      id: '/automate/nodes'
      path: '/nodes'
      fullPath: '/automate/nodes'
      preLoaderRoute: typeof AutomateNodesRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/automate/new': {
      id: '/automate/new'
      path: '/new'
      fullPath: '/automate/new'
      preLoaderRoute: typeof AutomateNewRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/automate/history': {
      id: '/automate/history'
      path: '/history'
      fullPath: '/automate/history'
      preLoaderRoute: typeof AutomateHistoryRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ask-argus/projects': {
      id: '/ask-argus/projects'
      path: '/projects'
      fullPath: '/ask-argus/projects'
      preLoaderRoute: typeof AskArgusProjectsRouteImport
      parentRoute: typeof AskArgusRoute
    }
    '/ask-argus/memories': {
      id: '/ask-argus/memories'
      path: '/memories'
      fullPath: '/ask-argus/memories'
      preLoaderRoute: typeof AskArgusMemoriesRouteImport
      parentRoute: typeof AskArgusRoute
    }
    '/approvals/settings': {
      id: '/approvals/settings'
      path: '/settings'
      fullPath: '/approvals/settings'
      preLoaderRoute: typeof ApprovalsSettingsRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/approvals/history': {
      id: '/approvals/history'
      path: '/history'
      fullPath: '/approvals/history'
      preLoaderRoute: typeof ApprovalsHistoryRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/approvals/$approvalId': {
      id: '/approvals/$approvalId'
      path: '/$approvalId'
      fullPath: '/approvals/$approvalId'
      preLoaderRoute: typeof ApprovalsApprovalIdRouteImport
      parentRoute: typeof ApprovalsRoute
    }
    '/agents/new': {
      id: '/agents/new'
      path: '/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AgentsNewRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/agents/gallery': {
      id: '/agents/gallery'
      path: '/gallery'
      fullPath: '/agents/gallery'
      preLoaderRoute: typeof AgentsGalleryRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/agents/builder': {
      id: '/agents/builder'
      path: '/builder'
      fullPath: '/agents/builder'
      preLoaderRoute: typeof AgentsBuilderRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/security': {
      id: '/admin/security'
      path: '/security'
      fullPath: '/admin/security'
      preLoaderRoute: typeof AdminSecurityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/playground': {
      id: '/admin/playground'
      path: '/playground'
      fullPath: '/admin/playground'
      preLoaderRoute: typeof AdminPlaygroundRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/helper-budgets': {
      id: '/admin/helper-budgets'
      path: '/helper-budgets'
      fullPath: '/admin/helper-budgets'
      preLoaderRoute: typeof AdminHelperBudgetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/health': {
      id: '/admin/health'
      path: '/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AdminHealthRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/branding': {
      id: '/admin/branding'
      path: '/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AdminBrandingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/trust/frameworks/': {
      id: '/trust/frameworks/'
      path: '/frameworks'
      fullPath: '/trust/frameworks/'
      preLoaderRoute: typeof TrustFrameworksIndexRouteImport
      parentRoute: typeof TrustRoute
    }
    '/sysadmin/tenants/': {
      id: '/sysadmin/tenants/'
      path: '/'
      fullPath: '/sysadmin/tenants/'
      preLoaderRoute: typeof SysadminTenantsIndexRouteImport
      parentRoute: typeof SysadminTenantsRoute
    }
    '/sysadmin/studio/': {
      id: '/sysadmin/studio/'
      path: '/'
      fullPath: '/sysadmin/studio/'
      preLoaderRoute: typeof SysadminStudioIndexRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/settings/': {
      id: '/sysadmin/settings/'
      path: '/'
      fullPath: '/sysadmin/settings/'
      preLoaderRoute: typeof SysadminSettingsIndexRouteImport
      parentRoute: typeof SysadminSettingsRoute
    }
    '/sysadmin/runtime/': {
      id: '/sysadmin/runtime/'
      path: '/'
      fullPath: '/sysadmin/runtime/'
      preLoaderRoute: typeof SysadminRuntimeIndexRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/platform/': {
      id: '/sysadmin/platform/'
      path: '/'
      fullPath: '/sysadmin/platform/'
      preLoaderRoute: typeof SysadminPlatformIndexRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/models/': {
      id: '/sysadmin/models/'
      path: '/'
      fullPath: '/sysadmin/models/'
      preLoaderRoute: typeof SysadminModelsIndexRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/library/': {
      id: '/sysadmin/library/'
      path: '/'
      fullPath: '/sysadmin/library/'
      preLoaderRoute: typeof SysadminLibraryIndexRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/governance/': {
      id: '/sysadmin/governance/'
      path: '/'
      fullPath: '/sysadmin/governance/'
      preLoaderRoute: typeof SysadminGovernanceIndexRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/fine-tuning/': {
      id: '/sysadmin/fine-tuning/'
      path: '/'
      fullPath: '/sysadmin/fine-tuning/'
      preLoaderRoute: typeof SysadminFineTuningIndexRouteImport
      parentRoute: typeof SysadminFineTuningRoute
    }
    '/sysadmin/catalog/': {
      id: '/sysadmin/catalog/'
      path: '/'
      fullPath: '/sysadmin/catalog/'
      preLoaderRoute: typeof SysadminCatalogIndexRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/audit/': {
      id: '/sysadmin/audit/'
      path: '/'
      fullPath: '/sysadmin/audit/'
      preLoaderRoute: typeof SysadminAuditIndexRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/administrators/': {
      id: '/sysadmin/administrators/'
      path: '/'
      fullPath: '/sysadmin/administrators/'
      preLoaderRoute: typeof SysadminAdministratorsIndexRouteImport
      parentRoute: typeof SysadminAdministratorsRoute
    }
    '/studio/tools/': {
      id: '/studio/tools/'
      path: '/'
      fullPath: '/studio/tools/'
      preLoaderRoute: typeof StudioToolsIndexRouteImport
      parentRoute: typeof StudioToolsRoute
    }
    '/studio/skills/': {
      id: '/studio/skills/'
      path: '/'
      fullPath: '/studio/skills/'
      preLoaderRoute: typeof StudioSkillsIndexRouteImport
      parentRoute: typeof StudioSkillsRoute
    }
    '/studio/prompts/': {
      id: '/studio/prompts/'
      path: '/'
      fullPath: '/studio/prompts/'
      preLoaderRoute: typeof StudioPromptsIndexRouteImport
      parentRoute: typeof StudioPromptsRoute
    }
    '/studio/bundles/': {
      id: '/studio/bundles/'
      path: '/'
      fullPath: '/studio/bundles/'
      preLoaderRoute: typeof StudioBundlesIndexRouteImport
      parentRoute: typeof StudioBundlesRoute
    }
    '/library/sources/': {
      id: '/library/sources/'
      path: '/sources'
      fullPath: '/library/sources/'
      preLoaderRoute: typeof LibrarySourcesIndexRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/agents/$agentId/': {
      id: '/agents/$agentId/'
      path: '/$agentId'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AgentsAgentIdIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/security/': {
      id: '/admin/security/'
      path: '/'
      fullPath: '/admin/security/'
      preLoaderRoute: typeof AdminSecurityIndexRouteImport
      parentRoute: typeof AdminSecurityRoute
    }
    '/admin/notifications/': {
      id: '/admin/notifications/'
      path: '/'
      fullPath: '/admin/notifications/'
      preLoaderRoute: typeof AdminNotificationsIndexRouteImport
      parentRoute: typeof AdminNotificationsRoute
    }
    '/admin/health/': {
      id: '/admin/health/'
      path: '/'
      fullPath: '/admin/health/'
      preLoaderRoute: typeof AdminHealthIndexRouteImport
      parentRoute: typeof AdminHealthRoute
    }
    '/admin/discover/': {
      id: '/admin/discover/'
      path: '/discover'
      fullPath: '/admin/discover/'
      preLoaderRoute: typeof AdminDiscoverIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit/': {
      id: '/admin/audit/'
      path: '/'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AdminAuditIndexRouteImport
      parentRoute: typeof AdminAuditRoute
    }
    '/users/groups/$groupId': {
      id: '/users/groups/$groupId'
      path: '/$groupId'
      fullPath: '/users/groups/$groupId'
      preLoaderRoute: typeof UsersGroupsGroupIdRouteImport
      parentRoute: typeof UsersGroupsRoute
    }
    '/trust/frameworks/$frameworkId': {
      id: '/trust/frameworks/$frameworkId'
      path: '/frameworks/$frameworkId'
      fullPath: '/trust/frameworks/$frameworkId'
      preLoaderRoute: typeof TrustFrameworksFrameworkIdRouteImport
      parentRoute: typeof TrustRoute
    }
    '/sysadmin/tenants/$tenantId': {
      id: '/sysadmin/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/sysadmin/tenants/$tenantId'
      preLoaderRoute: typeof SysadminTenantsTenantIdRouteImport
      parentRoute: typeof SysadminTenantsRoute
    }
    '/sysadmin/studio/tools': {
      id: '/sysadmin/studio/tools'
      path: '/tools'
      fullPath: '/sysadmin/studio/tools'
      preLoaderRoute: typeof SysadminStudioToolsRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/studio/skills': {
      id: '/sysadmin/studio/skills'
      path: '/skills'
      fullPath: '/sysadmin/studio/skills'
      preLoaderRoute: typeof SysadminStudioSkillsRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/studio/prompts': {
      id: '/sysadmin/studio/prompts'
      path: '/prompts'
      fullPath: '/sysadmin/studio/prompts'
      preLoaderRoute: typeof SysadminStudioPromptsRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/studio/categories': {
      id: '/sysadmin/studio/categories'
      path: '/categories'
      fullPath: '/sysadmin/studio/categories'
      preLoaderRoute: typeof SysadminStudioCategoriesRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/studio/agents': {
      id: '/sysadmin/studio/agents'
      path: '/agents'
      fullPath: '/sysadmin/studio/agents'
      preLoaderRoute: typeof SysadminStudioAgentsRouteImport
      parentRoute: typeof SysadminStudioRoute
    }
    '/sysadmin/settings/notifications': {
      id: '/sysadmin/settings/notifications'
      path: '/notifications'
      fullPath: '/sysadmin/settings/notifications'
      preLoaderRoute: typeof SysadminSettingsNotificationsRouteImport
      parentRoute: typeof SysadminSettingsRoute
    }
    '/sysadmin/settings/idp': {
      id: '/sysadmin/settings/idp'
      path: '/idp'
      fullPath: '/sysadmin/settings/idp'
      preLoaderRoute: typeof SysadminSettingsIdpRouteImport
      parentRoute: typeof SysadminSettingsRoute
    }
    '/sysadmin/settings/email': {
      id: '/sysadmin/settings/email'
      path: '/email'
      fullPath: '/sysadmin/settings/email'
      preLoaderRoute: typeof SysadminSettingsEmailRouteImport
      parentRoute: typeof SysadminSettingsRoute
    }
    '/sysadmin/settings/api': {
      id: '/sysadmin/settings/api'
      path: '/api'
      fullPath: '/sysadmin/settings/api'
      preLoaderRoute: typeof SysadminSettingsApiRouteImport
      parentRoute: typeof SysadminSettingsRoute
    }
    '/sysadmin/runtime/storage': {
      id: '/sysadmin/runtime/storage'
      path: '/storage'
      fullPath: '/sysadmin/runtime/storage'
      preLoaderRoute: typeof SysadminRuntimeStorageRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/runtime/queues': {
      id: '/sysadmin/runtime/queues'
      path: '/queues'
      fullPath: '/sysadmin/runtime/queues'
      preLoaderRoute: typeof SysadminRuntimeQueuesRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/runtime/mcp': {
      id: '/sysadmin/runtime/mcp'
      path: '/mcp'
      fullPath: '/sysadmin/runtime/mcp'
      preLoaderRoute: typeof SysadminRuntimeMcpRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/runtime/inference': {
      id: '/sysadmin/runtime/inference'
      path: '/inference'
      fullPath: '/sysadmin/runtime/inference'
      preLoaderRoute: typeof SysadminRuntimeInferenceRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/runtime/health': {
      id: '/sysadmin/runtime/health'
      path: '/health'
      fullPath: '/sysadmin/runtime/health'
      preLoaderRoute: typeof SysadminRuntimeHealthRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/runtime/hardware': {
      id: '/sysadmin/runtime/hardware'
      path: '/hardware'
      fullPath: '/sysadmin/runtime/hardware'
      preLoaderRoute: typeof SysadminRuntimeHardwareRouteImport
      parentRoute: typeof SysadminRuntimeRoute
    }
    '/sysadmin/platform/updates': {
      id: '/sysadmin/platform/updates'
      path: '/updates'
      fullPath: '/sysadmin/platform/updates'
      preLoaderRoute: typeof SysadminPlatformUpdatesRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/license': {
      id: '/sysadmin/platform/license'
      path: '/license'
      fullPath: '/sysadmin/platform/license'
      preLoaderRoute: typeof SysadminPlatformLicenseRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/keys': {
      id: '/sysadmin/platform/keys'
      path: '/keys'
      fullPath: '/sysadmin/platform/keys'
      preLoaderRoute: typeof SysadminPlatformKeysRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/helper-budgets': {
      id: '/sysadmin/platform/helper-budgets'
      path: '/helper-budgets'
      fullPath: '/sysadmin/platform/helper-budgets'
      preLoaderRoute: typeof SysadminPlatformHelperBudgetsRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/hardware-profiles': {
      id: '/sysadmin/platform/hardware-profiles'
      path: '/hardware-profiles'
      fullPath: '/sysadmin/platform/hardware-profiles'
      preLoaderRoute: typeof SysadminPlatformHardwareProfilesRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/deployment': {
      id: '/sysadmin/platform/deployment'
      path: '/deployment'
      fullPath: '/sysadmin/platform/deployment'
      preLoaderRoute: typeof SysadminPlatformDeploymentRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/builder-analytics': {
      id: '/sysadmin/platform/builder-analytics'
      path: '/builder-analytics'
      fullPath: '/sysadmin/platform/builder-analytics'
      preLoaderRoute: typeof SysadminPlatformBuilderAnalyticsRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/backups': {
      id: '/sysadmin/platform/backups'
      path: '/backups'
      fullPath: '/sysadmin/platform/backups'
      preLoaderRoute: typeof SysadminPlatformBackupsRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/platform/airgap': {
      id: '/sysadmin/platform/airgap'
      path: '/airgap'
      fullPath: '/sysadmin/platform/airgap'
      preLoaderRoute: typeof SysadminPlatformAirgapRouteImport
      parentRoute: typeof SysadminPlatformRoute
    }
    '/sysadmin/models/trust-toggles': {
      id: '/sysadmin/models/trust-toggles'
      path: '/trust-toggles'
      fullPath: '/sysadmin/models/trust-toggles'
      preLoaderRoute: typeof SysadminModelsTrustTogglesRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/runtime': {
      id: '/sysadmin/models/runtime'
      path: '/runtime'
      fullPath: '/sysadmin/models/runtime'
      preLoaderRoute: typeof SysadminModelsRuntimeRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/new': {
      id: '/sysadmin/models/new'
      path: '/new'
      fullPath: '/sysadmin/models/new'
      preLoaderRoute: typeof SysadminModelsNewRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/history': {
      id: '/sysadmin/models/history'
      path: '/history'
      fullPath: '/sysadmin/models/history'
      preLoaderRoute: typeof SysadminModelsHistoryRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/functions': {
      id: '/sysadmin/models/functions'
      path: '/functions'
      fullPath: '/sysadmin/models/functions'
      preLoaderRoute: typeof SysadminModelsFunctionsRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/assignments': {
      id: '/sysadmin/models/assignments'
      path: '/assignments'
      fullPath: '/sysadmin/models/assignments'
      preLoaderRoute: typeof SysadminModelsAssignmentsRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/models/$id': {
      id: '/sysadmin/models/$id'
      path: '/$id'
      fullPath: '/sysadmin/models/$id'
      preLoaderRoute: typeof SysadminModelsIdRouteImport
      parentRoute: typeof SysadminModelsRoute
    }
    '/sysadmin/library/tags': {
      id: '/sysadmin/library/tags'
      path: '/tags'
      fullPath: '/sysadmin/library/tags'
      preLoaderRoute: typeof SysadminLibraryTagsRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/library/sources': {
      id: '/sysadmin/library/sources'
      path: '/sources'
      fullPath: '/sysadmin/library/sources'
      preLoaderRoute: typeof SysadminLibrarySourcesRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/library/folders': {
      id: '/sysadmin/library/folders'
      path: '/folders'
      fullPath: '/sysadmin/library/folders'
      preLoaderRoute: typeof SysadminLibraryFoldersRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/library/documents': {
      id: '/sysadmin/library/documents'
      path: '/documents'
      fullPath: '/sysadmin/library/documents'
      preLoaderRoute: typeof SysadminLibraryDocumentsRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/library/document-folders': {
      id: '/sysadmin/library/document-folders'
      path: '/document-folders'
      fullPath: '/sysadmin/library/document-folders'
      preLoaderRoute: typeof SysadminLibraryDocumentFoldersRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/library/articles': {
      id: '/sysadmin/library/articles'
      path: '/articles'
      fullPath: '/sysadmin/library/articles'
      preLoaderRoute: typeof SysadminLibraryArticlesRouteImport
      parentRoute: typeof SysadminLibraryRoute
    }
    '/sysadmin/governance/pii': {
      id: '/sysadmin/governance/pii'
      path: '/pii'
      fullPath: '/sysadmin/governance/pii'
      preLoaderRoute: typeof SysadminGovernancePiiRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/governance/guardrails': {
      id: '/sysadmin/governance/guardrails'
      path: '/guardrails'
      fullPath: '/sysadmin/governance/guardrails'
      preLoaderRoute: typeof SysadminGovernanceGuardrailsRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/governance/compliance': {
      id: '/sysadmin/governance/compliance'
      path: '/compliance'
      fullPath: '/sysadmin/governance/compliance'
      preLoaderRoute: typeof SysadminGovernanceComplianceRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/governance/classification': {
      id: '/sysadmin/governance/classification'
      path: '/classification'
      fullPath: '/sysadmin/governance/classification'
      preLoaderRoute: typeof SysadminGovernanceClassificationRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/governance/approvals': {
      id: '/sysadmin/governance/approvals'
      path: '/approvals'
      fullPath: '/sysadmin/governance/approvals'
      preLoaderRoute: typeof SysadminGovernanceApprovalsRouteImport
      parentRoute: typeof SysadminGovernanceRoute
    }
    '/sysadmin/fine-tuning/training-data': {
      id: '/sysadmin/fine-tuning/training-data'
      path: '/training-data'
      fullPath: '/sysadmin/fine-tuning/training-data'
      preLoaderRoute: typeof SysadminFineTuningTrainingDataRouteImport
      parentRoute: typeof SysadminFineTuningRoute
    }
    '/sysadmin/fine-tuning/golden-set': {
      id: '/sysadmin/fine-tuning/golden-set'
      path: '/golden-set'
      fullPath: '/sysadmin/fine-tuning/golden-set'
      preLoaderRoute: typeof SysadminFineTuningGoldenSetRouteImport
      parentRoute: typeof SysadminFineTuningRoute
    }
    '/sysadmin/fine-tuning/evaluation': {
      id: '/sysadmin/fine-tuning/evaluation'
      path: '/evaluation'
      fullPath: '/sysadmin/fine-tuning/evaluation'
      preLoaderRoute: typeof SysadminFineTuningEvaluationRouteImport
      parentRoute: typeof SysadminFineTuningRoute
    }
    '/sysadmin/fine-tuning/adapters': {
      id: '/sysadmin/fine-tuning/adapters'
      path: '/adapters'
      fullPath: '/sysadmin/fine-tuning/adapters'
      preLoaderRoute: typeof SysadminFineTuningAdaptersRouteImport
      parentRoute: typeof SysadminFineTuningRoute
    }
    '/sysadmin/catalog/workflows': {
      id: '/sysadmin/catalog/workflows'
      path: '/workflows'
      fullPath: '/sysadmin/catalog/workflows'
      preLoaderRoute: typeof SysadminCatalogWorkflowsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/tools': {
      id: '/sysadmin/catalog/tools'
      path: '/tools'
      fullPath: '/sysadmin/catalog/tools'
      preLoaderRoute: typeof SysadminCatalogToolsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/skills': {
      id: '/sysadmin/catalog/skills'
      path: '/skills'
      fullPath: '/sysadmin/catalog/skills'
      preLoaderRoute: typeof SysadminCatalogSkillsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/prompts': {
      id: '/sysadmin/catalog/prompts'
      path: '/prompts'
      fullPath: '/sysadmin/catalog/prompts'
      preLoaderRoute: typeof SysadminCatalogPromptsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/models': {
      id: '/sysadmin/catalog/models'
      path: '/models'
      fullPath: '/sysadmin/catalog/models'
      preLoaderRoute: typeof SysadminCatalogModelsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/mcp': {
      id: '/sysadmin/catalog/mcp'
      path: '/mcp'
      fullPath: '/sysadmin/catalog/mcp'
      preLoaderRoute: typeof SysadminCatalogMcpRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/knowledge': {
      id: '/sysadmin/catalog/knowledge'
      path: '/knowledge'
      fullPath: '/sysadmin/catalog/knowledge'
      preLoaderRoute: typeof SysadminCatalogKnowledgeRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/functions': {
      id: '/sysadmin/catalog/functions'
      path: '/functions'
      fullPath: '/sysadmin/catalog/functions'
      preLoaderRoute: typeof SysadminCatalogFunctionsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/assignments': {
      id: '/sysadmin/catalog/assignments'
      path: '/assignments'
      fullPath: '/sysadmin/catalog/assignments'
      preLoaderRoute: typeof SysadminCatalogAssignmentsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/argus-live': {
      id: '/sysadmin/catalog/argus-live'
      path: '/argus-live'
      fullPath: '/sysadmin/catalog/argus-live'
      preLoaderRoute: typeof SysadminCatalogArgusLiveRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/catalog/agents': {
      id: '/sysadmin/catalog/agents'
      path: '/agents'
      fullPath: '/sysadmin/catalog/agents'
      preLoaderRoute: typeof SysadminCatalogAgentsRouteImport
      parentRoute: typeof SysadminCatalogRoute
    }
    '/sysadmin/audit/witness': {
      id: '/sysadmin/audit/witness'
      path: '/witness'
      fullPath: '/sysadmin/audit/witness'
      preLoaderRoute: typeof SysadminAuditWitnessRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/audit/sysadmin': {
      id: '/sysadmin/audit/sysadmin'
      path: '/sysadmin'
      fullPath: '/sysadmin/audit/sysadmin'
      preLoaderRoute: typeof SysadminAuditSysadminRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/audit/stream': {
      id: '/sysadmin/audit/stream'
      path: '/stream'
      fullPath: '/sysadmin/audit/stream'
      preLoaderRoute: typeof SysadminAuditStreamRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/audit/integrity': {
      id: '/sysadmin/audit/integrity'
      path: '/integrity'
      fullPath: '/sysadmin/audit/integrity'
      preLoaderRoute: typeof SysadminAuditIntegrityRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/audit/exports': {
      id: '/sysadmin/audit/exports'
      path: '/exports'
      fullPath: '/sysadmin/audit/exports'
      preLoaderRoute: typeof SysadminAuditExportsRouteImport
      parentRoute: typeof SysadminAuditRoute
    }
    '/sysadmin/administrators/sessions': {
      id: '/sysadmin/administrators/sessions'
      path: '/sessions'
      fullPath: '/sysadmin/administrators/sessions'
      preLoaderRoute: typeof SysadminAdministratorsSessionsRouteImport
      parentRoute: typeof SysadminAdministratorsRoute
    }
    '/sysadmin/administrators/activity': {
      id: '/sysadmin/administrators/activity'
      path: '/activity'
      fullPath: '/sysadmin/administrators/activity'
      preLoaderRoute: typeof SysadminAdministratorsActivityRouteImport
      parentRoute: typeof SysadminAdministratorsRoute
    }
    '/studio/tools/new': {
      id: '/studio/tools/new'
      path: '/new'
      fullPath: '/studio/tools/new'
      preLoaderRoute: typeof StudioToolsNewRouteImport
      parentRoute: typeof StudioToolsRoute
    }
    '/studio/tools/$toolId': {
      id: '/studio/tools/$toolId'
      path: '/$toolId'
      fullPath: '/studio/tools/$toolId'
      preLoaderRoute: typeof StudioToolsToolIdRouteImport
      parentRoute: typeof StudioToolsRoute
    }
    '/studio/skills/$skillId': {
      id: '/studio/skills/$skillId'
      path: '/$skillId'
      fullPath: '/studio/skills/$skillId'
      preLoaderRoute: typeof StudioSkillsSkillIdRouteImport
      parentRoute: typeof StudioSkillsRoute
    }
    '/studio/prompts/$promptId': {
      id: '/studio/prompts/$promptId'
      path: '/$promptId'
      fullPath: '/studio/prompts/$promptId'
      preLoaderRoute: typeof StudioPromptsPromptIdRouteImport
      parentRoute: typeof StudioPromptsRoute
    }
    '/studio/bundles/new': {
      id: '/studio/bundles/new'
      path: '/new'
      fullPath: '/studio/bundles/new'
      preLoaderRoute: typeof StudioBundlesNewRouteImport
      parentRoute: typeof StudioBundlesRoute
    }
    '/studio/bundles/$id': {
      id: '/studio/bundles/$id'
      path: '/$id'
      fullPath: '/studio/bundles/$id'
      preLoaderRoute: typeof StudioBundlesIdRouteImport
      parentRoute: typeof StudioBundlesRoute
    }
    '/library/wiki/new': {
      id: '/library/wiki/new'
      path: '/new'
      fullPath: '/library/wiki/new'
      preLoaderRoute: typeof LibraryWikiNewRouteImport
      parentRoute: typeof LibraryWikiRoute
    }
    '/library/wiki/$articleId': {
      id: '/library/wiki/$articleId'
      path: '/$articleId'
      fullPath: '/library/wiki/$articleId'
      preLoaderRoute: typeof LibraryWikiArticleIdRouteImport
      parentRoute: typeof LibraryWikiRoute
    }
    '/library/sources/connect': {
      id: '/library/sources/connect'
      path: '/sources/connect'
      fullPath: '/library/sources/connect'
      preLoaderRoute: typeof LibrarySourcesConnectRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/sources/$sourceId': {
      id: '/library/sources/$sourceId'
      path: '/sources/$sourceId'
      fullPath: '/library/sources/$sourceId'
      preLoaderRoute: typeof LibrarySourcesSourceIdRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/doc/$docId': {
      id: '/library/doc/$docId'
      path: '/doc/$docId'
      fullPath: '/library/doc/$docId'
      preLoaderRoute: typeof LibraryDocDocIdRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/library/article/$articleId': {
      id: '/library/article/$articleId'
      path: '/article/$articleId'
      fullPath: '/library/article/$articleId'
      preLoaderRoute: typeof LibraryArticleArticleIdRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/connections/mcp/marketplace': {
      id: '/connections/mcp/marketplace'
      path: '/marketplace'
      fullPath: '/connections/mcp/marketplace'
      preLoaderRoute: typeof ConnectionsMcpMarketplaceRouteImport
      parentRoute: typeof ConnectionsMcpRoute
    }
    '/connections/mcp/$connectionId': {
      id: '/connections/mcp/$connectionId'
      path: '/$connectionId'
      fullPath: '/connections/mcp/$connectionId'
      preLoaderRoute: typeof ConnectionsMcpConnectionIdRouteImport
      parentRoute: typeof ConnectionsMcpRoute
    }
    '/connections/functions/new': {
      id: '/connections/functions/new'
      path: '/new'
      fullPath: '/connections/functions/new'
      preLoaderRoute: typeof ConnectionsFunctionsNewRouteImport
      parentRoute: typeof ConnectionsFunctionsRoute
    }
    '/connections/functions/$functionId': {
      id: '/connections/functions/$functionId'
      path: '/$functionId'
      fullPath: '/connections/functions/$functionId'
      preLoaderRoute: typeof ConnectionsFunctionsFunctionIdRouteImport
      parentRoute: typeof ConnectionsFunctionsRoute
    }
    '/connections/api/new': {
      id: '/connections/api/new'
      path: '/new'
      fullPath: '/connections/api/new'
      preLoaderRoute: typeof ConnectionsApiNewRouteImport
      parentRoute: typeof ConnectionsApiRoute
    }
    '/connections/api/$connectionId': {
      id: '/connections/api/$connectionId'
      path: '/$connectionId'
      fullPath: '/connections/api/$connectionId'
      preLoaderRoute: typeof ConnectionsApiConnectionIdRouteImport
      parentRoute: typeof ConnectionsApiRoute
    }
    '/automate/workflows/$id': {
      id: '/automate/workflows/$id'
      path: '/workflows/$id'
      fullPath: '/automate/workflows/$id'
      preLoaderRoute: typeof AutomateWorkflowsIdRouteImport
      parentRoute: typeof AutomateRoute
    }
    '/automate/playbooks/$playbookId': {
      id: '/automate/playbooks/$playbookId'
      path: '/$playbookId'
      fullPath: '/automate/playbooks/$playbookId'
      preLoaderRoute: typeof AutomatePlaybooksPlaybookIdRouteImport
      parentRoute: typeof AutomatePlaybooksRoute
    }
    '/automate/history/$executionId': {
      id: '/automate/history/$executionId'
      path: '/$executionId'
      fullPath: '/automate/history/$executionId'
      preLoaderRoute: typeof AutomateHistoryExecutionIdRouteImport
      parentRoute: typeof AutomateHistoryRoute
    }
    '/ask-argus/project/$projectId': {
      id: '/ask-argus/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/ask-argus/project/$projectId'
      preLoaderRoute: typeof AskArgusProjectProjectIdRouteImport
      parentRoute: typeof AskArgusRoute
    }
    '/argus-live/dashboards/new': {
      id: '/argus-live/dashboards/new'
      path: '/argus-live/dashboards/new'
      fullPath: '/argus-live/dashboards/new'
      preLoaderRoute: typeof ArgusLiveDashboardsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/argus-live/dashboards/$id': {
      id: '/argus-live/dashboards/$id'
      path: '/argus-live/dashboards/$id'
      fullPath: '/argus-live/dashboards/$id'
      preLoaderRoute: typeof ArgusLiveDashboardsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId/edit': {
      id: '/agents/$agentId/edit'
      path: '/$agentId/edit'
      fullPath: '/agents/$agentId/edit'
      preLoaderRoute: typeof AgentsAgentIdEditRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/admin/settings/integrations': {
      id: '/admin/settings/integrations'
      path: '/integrations'
      fullPath: '/admin/settings/integrations'
      preLoaderRoute: typeof AdminSettingsIntegrationsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/data': {
      id: '/admin/settings/data'
      path: '/data'
      fullPath: '/admin/settings/data'
      preLoaderRoute: typeof AdminSettingsDataRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/compliance': {
      id: '/admin/settings/compliance'
      path: '/compliance'
      fullPath: '/admin/settings/compliance'
      preLoaderRoute: typeof AdminSettingsComplianceRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/settings/api': {
      id: '/admin/settings/api'
      path: '/api'
      fullPath: '/admin/settings/api'
      preLoaderRoute: typeof AdminSettingsApiRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin/security/threat': {
      id: '/admin/security/threat'
      path: '/threat'
      fullPath: '/admin/security/threat'
      preLoaderRoute: typeof AdminSecurityThreatRouteImport
      parentRoute: typeof AdminSecurityRoute
    }
    '/admin/security/session': {
      id: '/admin/security/session'
      path: '/session'
      fullPath: '/admin/security/session'
      preLoaderRoute: typeof AdminSecuritySessionRouteImport
      parentRoute: typeof AdminSecurityRoute
    }
    '/admin/security/privileged': {
      id: '/admin/security/privileged'
      path: '/privileged'
      fullPath: '/admin/security/privileged'
      preLoaderRoute: typeof AdminSecurityPrivilegedRouteImport
      parentRoute: typeof AdminSecurityRoute
    }
    '/admin/security/keys': {
      id: '/admin/security/keys'
      path: '/keys'
      fullPath: '/admin/security/keys'
      preLoaderRoute: typeof AdminSecurityKeysRouteImport
      parentRoute: typeof AdminSecurityRoute
    }
    '/admin/notifications/log': {
      id: '/admin/notifications/log'
      path: '/log'
      fullPath: '/admin/notifications/log'
      preLoaderRoute: typeof AdminNotificationsLogRouteImport
      parentRoute: typeof AdminNotificationsRoute
    }
    '/admin/notifications/escalation': {
      id: '/admin/notifications/escalation'
      path: '/escalation'
      fullPath: '/admin/notifications/escalation'
      preLoaderRoute: typeof AdminNotificationsEscalationRouteImport
      parentRoute: typeof AdminNotificationsRoute
    }
    '/admin/notifications/channels': {
      id: '/admin/notifications/channels'
      path: '/channels'
      fullPath: '/admin/notifications/channels'
      preLoaderRoute: typeof AdminNotificationsChannelsRouteImport
      parentRoute: typeof AdminNotificationsRoute
    }
    '/admin/health/services': {
      id: '/admin/health/services'
      path: '/services'
      fullPath: '/admin/health/services'
      preLoaderRoute: typeof AdminHealthServicesRouteImport
      parentRoute: typeof AdminHealthRoute
    }
    '/admin/health/pipeline': {
      id: '/admin/health/pipeline'
      path: '/pipeline'
      fullPath: '/admin/health/pipeline'
      preLoaderRoute: typeof AdminHealthPipelineRouteImport
      parentRoute: typeof AdminHealthRoute
    }
    '/admin/health/infra': {
      id: '/admin/health/infra'
      path: '/infra'
      fullPath: '/admin/health/infra'
      preLoaderRoute: typeof AdminHealthInfraRouteImport
      parentRoute: typeof AdminHealthRoute
    }
    '/admin/discover/tools': {
      id: '/admin/discover/tools'
      path: '/discover/tools'
      fullPath: '/admin/discover/tools'
      preLoaderRoute: typeof AdminDiscoverToolsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/discover/skills': {
      id: '/admin/discover/skills'
      path: '/discover/skills'
      fullPath: '/admin/discover/skills'
      preLoaderRoute: typeof AdminDiscoverSkillsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/discover/prompts': {
      id: '/admin/discover/prompts'
      path: '/discover/prompts'
      fullPath: '/admin/discover/prompts'
      preLoaderRoute: typeof AdminDiscoverPromptsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/discover/functions': {
      id: '/admin/discover/functions'
      path: '/discover/functions'
      fullPath: '/admin/discover/functions'
      preLoaderRoute: typeof AdminDiscoverFunctionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/discover/connections': {
      id: '/admin/discover/connections'
      path: '/discover/connections'
      fullPath: '/admin/discover/connections'
      preLoaderRoute: typeof AdminDiscoverConnectionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/discover/agents': {
      id: '/admin/discover/agents'
      path: '/discover/agents'
      fullPath: '/admin/discover/agents'
      preLoaderRoute: typeof AdminDiscoverAgentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit/integrity': {
      id: '/admin/audit/integrity'
      path: '/integrity'
      fullPath: '/admin/audit/integrity'
      preLoaderRoute: typeof AdminAuditIntegrityRouteImport
      parentRoute: typeof AdminAuditRoute
    }
    '/admin/audit/changes': {
      id: '/admin/audit/changes'
      path: '/changes'
      fullPath: '/admin/audit/changes'
      preLoaderRoute: typeof AdminAuditChangesRouteImport
      parentRoute: typeof AdminAuditRoute
    }
    '/sysadmin/tenants/$tenantId/': {
      id: '/sysadmin/tenants/$tenantId/'
      path: '/'
      fullPath: '/sysadmin/tenants/$tenantId/'
      preLoaderRoute: typeof SysadminTenantsTenantIdIndexRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/catalog/workflows/': {
      id: '/sysadmin/catalog/workflows/'
      path: '/'
      fullPath: '/sysadmin/catalog/workflows/'
      preLoaderRoute: typeof SysadminCatalogWorkflowsIndexRouteImport
      parentRoute: typeof SysadminCatalogWorkflowsRoute
    }
    '/sysadmin/catalog/tools/': {
      id: '/sysadmin/catalog/tools/'
      path: '/'
      fullPath: '/sysadmin/catalog/tools/'
      preLoaderRoute: typeof SysadminCatalogToolsIndexRouteImport
      parentRoute: typeof SysadminCatalogToolsRoute
    }
    '/sysadmin/catalog/skills/': {
      id: '/sysadmin/catalog/skills/'
      path: '/'
      fullPath: '/sysadmin/catalog/skills/'
      preLoaderRoute: typeof SysadminCatalogSkillsIndexRouteImport
      parentRoute: typeof SysadminCatalogSkillsRoute
    }
    '/sysadmin/catalog/mcp/': {
      id: '/sysadmin/catalog/mcp/'
      path: '/'
      fullPath: '/sysadmin/catalog/mcp/'
      preLoaderRoute: typeof SysadminCatalogMcpIndexRouteImport
      parentRoute: typeof SysadminCatalogMcpRoute
    }
    '/sysadmin/catalog/functions/': {
      id: '/sysadmin/catalog/functions/'
      path: '/'
      fullPath: '/sysadmin/catalog/functions/'
      preLoaderRoute: typeof SysadminCatalogFunctionsIndexRouteImport
      parentRoute: typeof SysadminCatalogFunctionsRoute
    }
    '/sysadmin/catalog/argus-live/': {
      id: '/sysadmin/catalog/argus-live/'
      path: '/'
      fullPath: '/sysadmin/catalog/argus-live/'
      preLoaderRoute: typeof SysadminCatalogArgusLiveIndexRouteImport
      parentRoute: typeof SysadminCatalogArgusLiveRoute
    }
    '/sysadmin/catalog/agents/': {
      id: '/sysadmin/catalog/agents/'
      path: '/'
      fullPath: '/sysadmin/catalog/agents/'
      preLoaderRoute: typeof SysadminCatalogAgentsIndexRouteImport
      parentRoute: typeof SysadminCatalogAgentsRoute
    }
    '/argus-live/dashboards/$id/': {
      id: '/argus-live/dashboards/$id/'
      path: '/'
      fullPath: '/argus-live/dashboards/$id/'
      preLoaderRoute: typeof ArgusLiveDashboardsIdIndexRouteImport
      parentRoute: typeof ArgusLiveDashboardsIdRoute
    }
    '/sysadmin/tenants/$tenantId/users': {
      id: '/sysadmin/tenants/$tenantId/users'
      path: '/users'
      fullPath: '/sysadmin/tenants/$tenantId/users'
      preLoaderRoute: typeof SysadminTenantsTenantIdUsersRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/settings': {
      id: '/sysadmin/tenants/$tenantId/settings'
      path: '/settings'
      fullPath: '/sysadmin/tenants/$tenantId/settings'
      preLoaderRoute: typeof SysadminTenantsTenantIdSettingsRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/memory': {
      id: '/sysadmin/tenants/$tenantId/memory'
      path: '/memory'
      fullPath: '/sysadmin/tenants/$tenantId/memory'
      preLoaderRoute: typeof SysadminTenantsTenantIdMemoryRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/limits': {
      id: '/sysadmin/tenants/$tenantId/limits'
      path: '/limits'
      fullPath: '/sysadmin/tenants/$tenantId/limits'
      preLoaderRoute: typeof SysadminTenantsTenantIdLimitsRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/hardware': {
      id: '/sysadmin/tenants/$tenantId/hardware'
      path: '/hardware'
      fullPath: '/sysadmin/tenants/$tenantId/hardware'
      preLoaderRoute: typeof SysadminTenantsTenantIdHardwareRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/compliance': {
      id: '/sysadmin/tenants/$tenantId/compliance'
      path: '/compliance'
      fullPath: '/sysadmin/tenants/$tenantId/compliance'
      preLoaderRoute: typeof SysadminTenantsTenantIdComplianceRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/branding': {
      id: '/sysadmin/tenants/$tenantId/branding'
      path: '/branding'
      fullPath: '/sysadmin/tenants/$tenantId/branding'
      preLoaderRoute: typeof SysadminTenantsTenantIdBrandingRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/audit': {
      id: '/sysadmin/tenants/$tenantId/audit'
      path: '/audit'
      fullPath: '/sysadmin/tenants/$tenantId/audit'
      preLoaderRoute: typeof SysadminTenantsTenantIdAuditRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/tenants/$tenantId/assignments': {
      id: '/sysadmin/tenants/$tenantId/assignments'
      path: '/assignments'
      fullPath: '/sysadmin/tenants/$tenantId/assignments'
      preLoaderRoute: typeof SysadminTenantsTenantIdAssignmentsRouteImport
      parentRoute: typeof SysadminTenantsTenantIdRoute
    }
    '/sysadmin/catalog/workflows/$id': {
      id: '/sysadmin/catalog/workflows/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/workflows/$id'
      preLoaderRoute: typeof SysadminCatalogWorkflowsIdRouteImport
      parentRoute: typeof SysadminCatalogWorkflowsRoute
    }
    '/sysadmin/catalog/tools/new': {
      id: '/sysadmin/catalog/tools/new'
      path: '/new'
      fullPath: '/sysadmin/catalog/tools/new'
      preLoaderRoute: typeof SysadminCatalogToolsNewRouteImport
      parentRoute: typeof SysadminCatalogToolsRoute
    }
    '/sysadmin/catalog/tools/$id': {
      id: '/sysadmin/catalog/tools/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/tools/$id'
      preLoaderRoute: typeof SysadminCatalogToolsIdRouteImport
      parentRoute: typeof SysadminCatalogToolsRoute
    }
    '/sysadmin/catalog/skills/$id': {
      id: '/sysadmin/catalog/skills/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/skills/$id'
      preLoaderRoute: typeof SysadminCatalogSkillsIdRouteImport
      parentRoute: typeof SysadminCatalogSkillsRoute
    }
    '/sysadmin/catalog/mcp/new': {
      id: '/sysadmin/catalog/mcp/new'
      path: '/new'
      fullPath: '/sysadmin/catalog/mcp/new'
      preLoaderRoute: typeof SysadminCatalogMcpNewRouteImport
      parentRoute: typeof SysadminCatalogMcpRoute
    }
    '/sysadmin/catalog/mcp/$id': {
      id: '/sysadmin/catalog/mcp/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/mcp/$id'
      preLoaderRoute: typeof SysadminCatalogMcpIdRouteImport
      parentRoute: typeof SysadminCatalogMcpRoute
    }
    '/sysadmin/catalog/functions/new': {
      id: '/sysadmin/catalog/functions/new'
      path: '/new'
      fullPath: '/sysadmin/catalog/functions/new'
      preLoaderRoute: typeof SysadminCatalogFunctionsNewRouteImport
      parentRoute: typeof SysadminCatalogFunctionsRoute
    }
    '/sysadmin/catalog/argus-live/$id': {
      id: '/sysadmin/catalog/argus-live/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/argus-live/$id'
      preLoaderRoute: typeof SysadminCatalogArgusLiveIdRouteImport
      parentRoute: typeof SysadminCatalogArgusLiveRoute
    }
    '/sysadmin/catalog/agents/new': {
      id: '/sysadmin/catalog/agents/new'
      path: '/new'
      fullPath: '/sysadmin/catalog/agents/new'
      preLoaderRoute: typeof SysadminCatalogAgentsNewRouteImport
      parentRoute: typeof SysadminCatalogAgentsRoute
    }
    '/sysadmin/catalog/agents/builder': {
      id: '/sysadmin/catalog/agents/builder'
      path: '/builder'
      fullPath: '/sysadmin/catalog/agents/builder'
      preLoaderRoute: typeof SysadminCatalogAgentsBuilderRouteImport
      parentRoute: typeof SysadminCatalogAgentsRoute
    }
    '/sysadmin/catalog/agents/$id': {
      id: '/sysadmin/catalog/agents/$id'
      path: '/$id'
      fullPath: '/sysadmin/catalog/agents/$id'
      preLoaderRoute: typeof SysadminCatalogAgentsIdRouteImport
      parentRoute: typeof SysadminCatalogAgentsRoute
    }
    '/library/wiki/$articleId/edit': {
      id: '/library/wiki/$articleId/edit'
      path: '/edit'
      fullPath: '/library/wiki/$articleId/edit'
      preLoaderRoute: typeof LibraryWikiArticleIdEditRouteImport
      parentRoute: typeof LibraryWikiArticleIdRoute
    }
    '/argus-live/dashboards/$id/edit': {
      id: '/argus-live/dashboards/$id/edit'
      path: '/edit'
      fullPath: '/argus-live/dashboards/$id/edit'
      preLoaderRoute: typeof ArgusLiveDashboardsIdEditRouteImport
      parentRoute: typeof ArgusLiveDashboardsIdRoute
    }
  }
}

interface AdminAuditRouteChildren {
  AdminAuditChangesRoute: typeof AdminAuditChangesRoute
  AdminAuditIntegrityRoute: typeof AdminAuditIntegrityRoute
  AdminAuditIndexRoute: typeof AdminAuditIndexRoute
}

const AdminAuditRouteChildren: AdminAuditRouteChildren = {
  AdminAuditChangesRoute: AdminAuditChangesRoute,
  AdminAuditIntegrityRoute: AdminAuditIntegrityRoute,
  AdminAuditIndexRoute: AdminAuditIndexRoute,
}

const AdminAuditRouteWithChildren = AdminAuditRoute._addFileChildren(
  AdminAuditRouteChildren,
)

interface AdminHealthRouteChildren {
  AdminHealthInfraRoute: typeof AdminHealthInfraRoute
  AdminHealthPipelineRoute: typeof AdminHealthPipelineRoute
  AdminHealthServicesRoute: typeof AdminHealthServicesRoute
  AdminHealthIndexRoute: typeof AdminHealthIndexRoute
}

const AdminHealthRouteChildren: AdminHealthRouteChildren = {
  AdminHealthInfraRoute: AdminHealthInfraRoute,
  AdminHealthPipelineRoute: AdminHealthPipelineRoute,
  AdminHealthServicesRoute: AdminHealthServicesRoute,
  AdminHealthIndexRoute: AdminHealthIndexRoute,
}

const AdminHealthRouteWithChildren = AdminHealthRoute._addFileChildren(
  AdminHealthRouteChildren,
)

interface AdminNotificationsRouteChildren {
  AdminNotificationsChannelsRoute: typeof AdminNotificationsChannelsRoute
  AdminNotificationsEscalationRoute: typeof AdminNotificationsEscalationRoute
  AdminNotificationsLogRoute: typeof AdminNotificationsLogRoute
  AdminNotificationsIndexRoute: typeof AdminNotificationsIndexRoute
}

const AdminNotificationsRouteChildren: AdminNotificationsRouteChildren = {
  AdminNotificationsChannelsRoute: AdminNotificationsChannelsRoute,
  AdminNotificationsEscalationRoute: AdminNotificationsEscalationRoute,
  AdminNotificationsLogRoute: AdminNotificationsLogRoute,
  AdminNotificationsIndexRoute: AdminNotificationsIndexRoute,
}

const AdminNotificationsRouteWithChildren =
  AdminNotificationsRoute._addFileChildren(AdminNotificationsRouteChildren)

interface AdminSecurityRouteChildren {
  AdminSecurityKeysRoute: typeof AdminSecurityKeysRoute
  AdminSecurityPrivilegedRoute: typeof AdminSecurityPrivilegedRoute
  AdminSecuritySessionRoute: typeof AdminSecuritySessionRoute
  AdminSecurityThreatRoute: typeof AdminSecurityThreatRoute
  AdminSecurityIndexRoute: typeof AdminSecurityIndexRoute
}

const AdminSecurityRouteChildren: AdminSecurityRouteChildren = {
  AdminSecurityKeysRoute: AdminSecurityKeysRoute,
  AdminSecurityPrivilegedRoute: AdminSecurityPrivilegedRoute,
  AdminSecuritySessionRoute: AdminSecuritySessionRoute,
  AdminSecurityThreatRoute: AdminSecurityThreatRoute,
  AdminSecurityIndexRoute: AdminSecurityIndexRoute,
}

const AdminSecurityRouteWithChildren = AdminSecurityRoute._addFileChildren(
  AdminSecurityRouteChildren,
)

interface AdminSettingsRouteChildren {
  AdminSettingsApiRoute: typeof AdminSettingsApiRoute
  AdminSettingsComplianceRoute: typeof AdminSettingsComplianceRoute
  AdminSettingsDataRoute: typeof AdminSettingsDataRoute
  AdminSettingsIntegrationsRoute: typeof AdminSettingsIntegrationsRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsApiRoute: AdminSettingsApiRoute,
  AdminSettingsComplianceRoute: AdminSettingsComplianceRoute,
  AdminSettingsDataRoute: AdminSettingsDataRoute,
  AdminSettingsIntegrationsRoute: AdminSettingsIntegrationsRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRouteWithChildren
  AdminBrandingRoute: typeof AdminBrandingRoute
  AdminHealthRoute: typeof AdminHealthRouteWithChildren
  AdminHelperBudgetsRoute: typeof AdminHelperBudgetsRoute
  AdminNotificationsRoute: typeof AdminNotificationsRouteWithChildren
  AdminPlaygroundRoute: typeof AdminPlaygroundRoute
  AdminSecurityRoute: typeof AdminSecurityRouteWithChildren
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRoute
  AdminDiscoverAgentsRoute: typeof AdminDiscoverAgentsRoute
  AdminDiscoverConnectionsRoute: typeof AdminDiscoverConnectionsRoute
  AdminDiscoverFunctionsRoute: typeof AdminDiscoverFunctionsRoute
  AdminDiscoverPromptsRoute: typeof AdminDiscoverPromptsRoute
  AdminDiscoverSkillsRoute: typeof AdminDiscoverSkillsRoute
  AdminDiscoverToolsRoute: typeof AdminDiscoverToolsRoute
  AdminDiscoverIndexRoute: typeof AdminDiscoverIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRouteWithChildren,
  AdminBrandingRoute: AdminBrandingRoute,
  AdminHealthRoute: AdminHealthRouteWithChildren,
  AdminHelperBudgetsRoute: AdminHelperBudgetsRoute,
  AdminNotificationsRoute: AdminNotificationsRouteWithChildren,
  AdminPlaygroundRoute: AdminPlaygroundRoute,
  AdminSecurityRoute: AdminSecurityRouteWithChildren,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminUsersRoute: AdminUsersRoute,
  AdminDiscoverAgentsRoute: AdminDiscoverAgentsRoute,
  AdminDiscoverConnectionsRoute: AdminDiscoverConnectionsRoute,
  AdminDiscoverFunctionsRoute: AdminDiscoverFunctionsRoute,
  AdminDiscoverPromptsRoute: AdminDiscoverPromptsRoute,
  AdminDiscoverSkillsRoute: AdminDiscoverSkillsRoute,
  AdminDiscoverToolsRoute: AdminDiscoverToolsRoute,
  AdminDiscoverIndexRoute: AdminDiscoverIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AgentsRouteChildren {
  AgentsBuilderRoute: typeof AgentsBuilderRoute
  AgentsGalleryRoute: typeof AgentsGalleryRoute
  AgentsNewRoute: typeof AgentsNewRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  AgentsAgentIdEditRoute: typeof AgentsAgentIdEditRoute
  AgentsAgentIdIndexRoute: typeof AgentsAgentIdIndexRoute
}

const AgentsRouteChildren: AgentsRouteChildren = {
  AgentsBuilderRoute: AgentsBuilderRoute,
  AgentsGalleryRoute: AgentsGalleryRoute,
  AgentsNewRoute: AgentsNewRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  AgentsAgentIdEditRoute: AgentsAgentIdEditRoute,
  AgentsAgentIdIndexRoute: AgentsAgentIdIndexRoute,
}

const AgentsRouteWithChildren =
  AgentsRoute._addFileChildren(AgentsRouteChildren)

interface ApprovalsRouteChildren {
  ApprovalsApprovalIdRoute: typeof ApprovalsApprovalIdRoute
  ApprovalsHistoryRoute: typeof ApprovalsHistoryRoute
  ApprovalsSettingsRoute: typeof ApprovalsSettingsRoute
  ApprovalsIndexRoute: typeof ApprovalsIndexRoute
}

const ApprovalsRouteChildren: ApprovalsRouteChildren = {
  ApprovalsApprovalIdRoute: ApprovalsApprovalIdRoute,
  ApprovalsHistoryRoute: ApprovalsHistoryRoute,
  ApprovalsSettingsRoute: ApprovalsSettingsRoute,
  ApprovalsIndexRoute: ApprovalsIndexRoute,
}

const ApprovalsRouteWithChildren = ApprovalsRoute._addFileChildren(
  ApprovalsRouteChildren,
)

interface AskArgusRouteChildren {
  AskArgusMemoriesRoute: typeof AskArgusMemoriesRoute
  AskArgusProjectsRoute: typeof AskArgusProjectsRoute
  AskArgusIndexRoute: typeof AskArgusIndexRoute
  AskArgusProjectProjectIdRoute: typeof AskArgusProjectProjectIdRoute
}

const AskArgusRouteChildren: AskArgusRouteChildren = {
  AskArgusMemoriesRoute: AskArgusMemoriesRoute,
  AskArgusProjectsRoute: AskArgusProjectsRoute,
  AskArgusIndexRoute: AskArgusIndexRoute,
  AskArgusProjectProjectIdRoute: AskArgusProjectProjectIdRoute,
}

const AskArgusRouteWithChildren = AskArgusRoute._addFileChildren(
  AskArgusRouteChildren,
)

interface AutomateHistoryRouteChildren {
  AutomateHistoryExecutionIdRoute: typeof AutomateHistoryExecutionIdRoute
}

const AutomateHistoryRouteChildren: AutomateHistoryRouteChildren = {
  AutomateHistoryExecutionIdRoute: AutomateHistoryExecutionIdRoute,
}

const AutomateHistoryRouteWithChildren = AutomateHistoryRoute._addFileChildren(
  AutomateHistoryRouteChildren,
)

interface AutomatePlaybooksRouteChildren {
  AutomatePlaybooksPlaybookIdRoute: typeof AutomatePlaybooksPlaybookIdRoute
}

const AutomatePlaybooksRouteChildren: AutomatePlaybooksRouteChildren = {
  AutomatePlaybooksPlaybookIdRoute: AutomatePlaybooksPlaybookIdRoute,
}

const AutomatePlaybooksRouteWithChildren =
  AutomatePlaybooksRoute._addFileChildren(AutomatePlaybooksRouteChildren)

interface AutomateRouteChildren {
  AutomateHistoryRoute: typeof AutomateHistoryRouteWithChildren
  AutomateNewRoute: typeof AutomateNewRoute
  AutomateNodesRoute: typeof AutomateNodesRoute
  AutomatePlaybooksRoute: typeof AutomatePlaybooksRouteWithChildren
  AutomateIndexRoute: typeof AutomateIndexRoute
  AutomateWorkflowsIdRoute: typeof AutomateWorkflowsIdRoute
}

const AutomateRouteChildren: AutomateRouteChildren = {
  AutomateHistoryRoute: AutomateHistoryRouteWithChildren,
  AutomateNewRoute: AutomateNewRoute,
  AutomateNodesRoute: AutomateNodesRoute,
  AutomatePlaybooksRoute: AutomatePlaybooksRouteWithChildren,
  AutomateIndexRoute: AutomateIndexRoute,
  AutomateWorkflowsIdRoute: AutomateWorkflowsIdRoute,
}

const AutomateRouteWithChildren = AutomateRoute._addFileChildren(
  AutomateRouteChildren,
)

interface ConnectionsApiRouteChildren {
  ConnectionsApiConnectionIdRoute: typeof ConnectionsApiConnectionIdRoute
  ConnectionsApiNewRoute: typeof ConnectionsApiNewRoute
}

const ConnectionsApiRouteChildren: ConnectionsApiRouteChildren = {
  ConnectionsApiConnectionIdRoute: ConnectionsApiConnectionIdRoute,
  ConnectionsApiNewRoute: ConnectionsApiNewRoute,
}

const ConnectionsApiRouteWithChildren = ConnectionsApiRoute._addFileChildren(
  ConnectionsApiRouteChildren,
)

interface ConnectionsFunctionsRouteChildren {
  ConnectionsFunctionsFunctionIdRoute: typeof ConnectionsFunctionsFunctionIdRoute
  ConnectionsFunctionsNewRoute: typeof ConnectionsFunctionsNewRoute
}

const ConnectionsFunctionsRouteChildren: ConnectionsFunctionsRouteChildren = {
  ConnectionsFunctionsFunctionIdRoute: ConnectionsFunctionsFunctionIdRoute,
  ConnectionsFunctionsNewRoute: ConnectionsFunctionsNewRoute,
}

const ConnectionsFunctionsRouteWithChildren =
  ConnectionsFunctionsRoute._addFileChildren(ConnectionsFunctionsRouteChildren)

interface ConnectionsMcpRouteChildren {
  ConnectionsMcpConnectionIdRoute: typeof ConnectionsMcpConnectionIdRoute
  ConnectionsMcpMarketplaceRoute: typeof ConnectionsMcpMarketplaceRoute
}

const ConnectionsMcpRouteChildren: ConnectionsMcpRouteChildren = {
  ConnectionsMcpConnectionIdRoute: ConnectionsMcpConnectionIdRoute,
  ConnectionsMcpMarketplaceRoute: ConnectionsMcpMarketplaceRoute,
}

const ConnectionsMcpRouteWithChildren = ConnectionsMcpRoute._addFileChildren(
  ConnectionsMcpRouteChildren,
)

interface ConnectionsRouteChildren {
  ConnectionsConnectionIdRoute: typeof ConnectionsConnectionIdRoute
  ConnectionsApiRoute: typeof ConnectionsApiRouteWithChildren
  ConnectionsFunctionsRoute: typeof ConnectionsFunctionsRouteWithChildren
  ConnectionsHealthRoute: typeof ConnectionsHealthRoute
  ConnectionsMarketplaceRoute: typeof ConnectionsMarketplaceRoute
  ConnectionsMcpRoute: typeof ConnectionsMcpRouteWithChildren
  ConnectionsNewApiRoute: typeof ConnectionsNewApiRoute
  ConnectionsNewFunctionRoute: typeof ConnectionsNewFunctionRoute
  ConnectionsNewMcpRoute: typeof ConnectionsNewMcpRoute
  ConnectionsIndexRoute: typeof ConnectionsIndexRoute
}

const ConnectionsRouteChildren: ConnectionsRouteChildren = {
  ConnectionsConnectionIdRoute: ConnectionsConnectionIdRoute,
  ConnectionsApiRoute: ConnectionsApiRouteWithChildren,
  ConnectionsFunctionsRoute: ConnectionsFunctionsRouteWithChildren,
  ConnectionsHealthRoute: ConnectionsHealthRoute,
  ConnectionsMarketplaceRoute: ConnectionsMarketplaceRoute,
  ConnectionsMcpRoute: ConnectionsMcpRouteWithChildren,
  ConnectionsNewApiRoute: ConnectionsNewApiRoute,
  ConnectionsNewFunctionRoute: ConnectionsNewFunctionRoute,
  ConnectionsNewMcpRoute: ConnectionsNewMcpRoute,
  ConnectionsIndexRoute: ConnectionsIndexRoute,
}

const ConnectionsRouteWithChildren = ConnectionsRoute._addFileChildren(
  ConnectionsRouteChildren,
)

interface InsightsRouteChildren {
  InsightsAdoptionRoute: typeof InsightsAdoptionRoute
  InsightsAgentsKnowledgeRoute: typeof InsightsAgentsKnowledgeRoute
  InsightsCostRoute: typeof InsightsCostRoute
  InsightsQualityRoute: typeof InsightsQualityRoute
  InsightsRiskRoute: typeof InsightsRiskRoute
  InsightsValueRoute: typeof InsightsValueRoute
  InsightsIndexRoute: typeof InsightsIndexRoute
}

const InsightsRouteChildren: InsightsRouteChildren = {
  InsightsAdoptionRoute: InsightsAdoptionRoute,
  InsightsAgentsKnowledgeRoute: InsightsAgentsKnowledgeRoute,
  InsightsCostRoute: InsightsCostRoute,
  InsightsQualityRoute: InsightsQualityRoute,
  InsightsRiskRoute: InsightsRiskRoute,
  InsightsValueRoute: InsightsValueRoute,
  InsightsIndexRoute: InsightsIndexRoute,
}

const InsightsRouteWithChildren = InsightsRoute._addFileChildren(
  InsightsRouteChildren,
)

interface LibraryWikiArticleIdRouteChildren {
  LibraryWikiArticleIdEditRoute: typeof LibraryWikiArticleIdEditRoute
}

const LibraryWikiArticleIdRouteChildren: LibraryWikiArticleIdRouteChildren = {
  LibraryWikiArticleIdEditRoute: LibraryWikiArticleIdEditRoute,
}

const LibraryWikiArticleIdRouteWithChildren =
  LibraryWikiArticleIdRoute._addFileChildren(LibraryWikiArticleIdRouteChildren)

interface LibraryWikiRouteChildren {
  LibraryWikiArticleIdRoute: typeof LibraryWikiArticleIdRouteWithChildren
  LibraryWikiNewRoute: typeof LibraryWikiNewRoute
}

const LibraryWikiRouteChildren: LibraryWikiRouteChildren = {
  LibraryWikiArticleIdRoute: LibraryWikiArticleIdRouteWithChildren,
  LibraryWikiNewRoute: LibraryWikiNewRoute,
}

const LibraryWikiRouteWithChildren = LibraryWikiRoute._addFileChildren(
  LibraryWikiRouteChildren,
)

interface LibraryRouteChildren {
  LibraryDocumentsRoute: typeof LibraryDocumentsRoute
  LibraryFoldersRoute: typeof LibraryFoldersRoute
  LibraryQualityRoute: typeof LibraryQualityRoute
  LibrarySearchRoute: typeof LibrarySearchRoute
  LibrarySharedRoute: typeof LibrarySharedRoute
  LibrarySystemRoute: typeof LibrarySystemRoute
  LibraryWikiRoute: typeof LibraryWikiRouteWithChildren
  LibraryIndexRoute: typeof LibraryIndexRoute
  LibraryArticleArticleIdRoute: typeof LibraryArticleArticleIdRoute
  LibraryDocDocIdRoute: typeof LibraryDocDocIdRoute
  LibrarySourcesSourceIdRoute: typeof LibrarySourcesSourceIdRoute
  LibrarySourcesConnectRoute: typeof LibrarySourcesConnectRoute
  LibrarySourcesIndexRoute: typeof LibrarySourcesIndexRoute
}

const LibraryRouteChildren: LibraryRouteChildren = {
  LibraryDocumentsRoute: LibraryDocumentsRoute,
  LibraryFoldersRoute: LibraryFoldersRoute,
  LibraryQualityRoute: LibraryQualityRoute,
  LibrarySearchRoute: LibrarySearchRoute,
  LibrarySharedRoute: LibrarySharedRoute,
  LibrarySystemRoute: LibrarySystemRoute,
  LibraryWikiRoute: LibraryWikiRouteWithChildren,
  LibraryIndexRoute: LibraryIndexRoute,
  LibraryArticleArticleIdRoute: LibraryArticleArticleIdRoute,
  LibraryDocDocIdRoute: LibraryDocDocIdRoute,
  LibrarySourcesSourceIdRoute: LibrarySourcesSourceIdRoute,
  LibrarySourcesConnectRoute: LibrarySourcesConnectRoute,
  LibrarySourcesIndexRoute: LibrarySourcesIndexRoute,
}

const LibraryRouteWithChildren =
  LibraryRoute._addFileChildren(LibraryRouteChildren)

interface OrganizationsRouteChildren {
  OrganizationsOrgIdRoute: typeof OrganizationsOrgIdRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
}

const OrganizationsRouteChildren: OrganizationsRouteChildren = {
  OrganizationsOrgIdRoute: OrganizationsOrgIdRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
}

const OrganizationsRouteWithChildren = OrganizationsRoute._addFileChildren(
  OrganizationsRouteChildren,
)

interface StudioBundlesRouteChildren {
  StudioBundlesIdRoute: typeof StudioBundlesIdRoute
  StudioBundlesNewRoute: typeof StudioBundlesNewRoute
  StudioBundlesIndexRoute: typeof StudioBundlesIndexRoute
}

const StudioBundlesRouteChildren: StudioBundlesRouteChildren = {
  StudioBundlesIdRoute: StudioBundlesIdRoute,
  StudioBundlesNewRoute: StudioBundlesNewRoute,
  StudioBundlesIndexRoute: StudioBundlesIndexRoute,
}

const StudioBundlesRouteWithChildren = StudioBundlesRoute._addFileChildren(
  StudioBundlesRouteChildren,
)

interface StudioPromptsRouteChildren {
  StudioPromptsPromptIdRoute: typeof StudioPromptsPromptIdRoute
  StudioPromptsIndexRoute: typeof StudioPromptsIndexRoute
}

const StudioPromptsRouteChildren: StudioPromptsRouteChildren = {
  StudioPromptsPromptIdRoute: StudioPromptsPromptIdRoute,
  StudioPromptsIndexRoute: StudioPromptsIndexRoute,
}

const StudioPromptsRouteWithChildren = StudioPromptsRoute._addFileChildren(
  StudioPromptsRouteChildren,
)

interface StudioSkillsRouteChildren {
  StudioSkillsSkillIdRoute: typeof StudioSkillsSkillIdRoute
  StudioSkillsIndexRoute: typeof StudioSkillsIndexRoute
}

const StudioSkillsRouteChildren: StudioSkillsRouteChildren = {
  StudioSkillsSkillIdRoute: StudioSkillsSkillIdRoute,
  StudioSkillsIndexRoute: StudioSkillsIndexRoute,
}

const StudioSkillsRouteWithChildren = StudioSkillsRoute._addFileChildren(
  StudioSkillsRouteChildren,
)

interface StudioToolsRouteChildren {
  StudioToolsToolIdRoute: typeof StudioToolsToolIdRoute
  StudioToolsNewRoute: typeof StudioToolsNewRoute
  StudioToolsIndexRoute: typeof StudioToolsIndexRoute
}

const StudioToolsRouteChildren: StudioToolsRouteChildren = {
  StudioToolsToolIdRoute: StudioToolsToolIdRoute,
  StudioToolsNewRoute: StudioToolsNewRoute,
  StudioToolsIndexRoute: StudioToolsIndexRoute,
}

const StudioToolsRouteWithChildren = StudioToolsRoute._addFileChildren(
  StudioToolsRouteChildren,
)

interface StudioRouteChildren {
  StudioBundlesRoute: typeof StudioBundlesRouteWithChildren
  StudioFunctionsRoute: typeof StudioFunctionsRoute
  StudioPromptsRoute: typeof StudioPromptsRouteWithChildren
  StudioSkillsRoute: typeof StudioSkillsRouteWithChildren
  StudioTemplatesRoute: typeof StudioTemplatesRoute
  StudioToolsRoute: typeof StudioToolsRouteWithChildren
  StudioIndexRoute: typeof StudioIndexRoute
}

const StudioRouteChildren: StudioRouteChildren = {
  StudioBundlesRoute: StudioBundlesRouteWithChildren,
  StudioFunctionsRoute: StudioFunctionsRoute,
  StudioPromptsRoute: StudioPromptsRouteWithChildren,
  StudioSkillsRoute: StudioSkillsRouteWithChildren,
  StudioTemplatesRoute: StudioTemplatesRoute,
  StudioToolsRoute: StudioToolsRouteWithChildren,
  StudioIndexRoute: StudioIndexRoute,
}

const StudioRouteWithChildren =
  StudioRoute._addFileChildren(StudioRouteChildren)

interface SysadminAdministratorsRouteChildren {
  SysadminAdministratorsActivityRoute: typeof SysadminAdministratorsActivityRoute
  SysadminAdministratorsSessionsRoute: typeof SysadminAdministratorsSessionsRoute
  SysadminAdministratorsIndexRoute: typeof SysadminAdministratorsIndexRoute
}

const SysadminAdministratorsRouteChildren: SysadminAdministratorsRouteChildren =
  {
    SysadminAdministratorsActivityRoute: SysadminAdministratorsActivityRoute,
    SysadminAdministratorsSessionsRoute: SysadminAdministratorsSessionsRoute,
    SysadminAdministratorsIndexRoute: SysadminAdministratorsIndexRoute,
  }

const SysadminAdministratorsRouteWithChildren =
  SysadminAdministratorsRoute._addFileChildren(
    SysadminAdministratorsRouteChildren,
  )

interface SysadminAuditRouteChildren {
  SysadminAuditExportsRoute: typeof SysadminAuditExportsRoute
  SysadminAuditIntegrityRoute: typeof SysadminAuditIntegrityRoute
  SysadminAuditStreamRoute: typeof SysadminAuditStreamRoute
  SysadminAuditSysadminRoute: typeof SysadminAuditSysadminRoute
  SysadminAuditWitnessRoute: typeof SysadminAuditWitnessRoute
  SysadminAuditIndexRoute: typeof SysadminAuditIndexRoute
}

const SysadminAuditRouteChildren: SysadminAuditRouteChildren = {
  SysadminAuditExportsRoute: SysadminAuditExportsRoute,
  SysadminAuditIntegrityRoute: SysadminAuditIntegrityRoute,
  SysadminAuditStreamRoute: SysadminAuditStreamRoute,
  SysadminAuditSysadminRoute: SysadminAuditSysadminRoute,
  SysadminAuditWitnessRoute: SysadminAuditWitnessRoute,
  SysadminAuditIndexRoute: SysadminAuditIndexRoute,
}

const SysadminAuditRouteWithChildren = SysadminAuditRoute._addFileChildren(
  SysadminAuditRouteChildren,
)

interface SysadminCatalogAgentsRouteChildren {
  SysadminCatalogAgentsIdRoute: typeof SysadminCatalogAgentsIdRoute
  SysadminCatalogAgentsBuilderRoute: typeof SysadminCatalogAgentsBuilderRoute
  SysadminCatalogAgentsNewRoute: typeof SysadminCatalogAgentsNewRoute
  SysadminCatalogAgentsIndexRoute: typeof SysadminCatalogAgentsIndexRoute
}

const SysadminCatalogAgentsRouteChildren: SysadminCatalogAgentsRouteChildren = {
  SysadminCatalogAgentsIdRoute: SysadminCatalogAgentsIdRoute,
  SysadminCatalogAgentsBuilderRoute: SysadminCatalogAgentsBuilderRoute,
  SysadminCatalogAgentsNewRoute: SysadminCatalogAgentsNewRoute,
  SysadminCatalogAgentsIndexRoute: SysadminCatalogAgentsIndexRoute,
}

const SysadminCatalogAgentsRouteWithChildren =
  SysadminCatalogAgentsRoute._addFileChildren(
    SysadminCatalogAgentsRouteChildren,
  )

interface SysadminCatalogArgusLiveRouteChildren {
  SysadminCatalogArgusLiveIdRoute: typeof SysadminCatalogArgusLiveIdRoute
  SysadminCatalogArgusLiveIndexRoute: typeof SysadminCatalogArgusLiveIndexRoute
}

const SysadminCatalogArgusLiveRouteChildren: SysadminCatalogArgusLiveRouteChildren =
  {
    SysadminCatalogArgusLiveIdRoute: SysadminCatalogArgusLiveIdRoute,
    SysadminCatalogArgusLiveIndexRoute: SysadminCatalogArgusLiveIndexRoute,
  }

const SysadminCatalogArgusLiveRouteWithChildren =
  SysadminCatalogArgusLiveRoute._addFileChildren(
    SysadminCatalogArgusLiveRouteChildren,
  )

interface SysadminCatalogFunctionsRouteChildren {
  SysadminCatalogFunctionsNewRoute: typeof SysadminCatalogFunctionsNewRoute
  SysadminCatalogFunctionsIndexRoute: typeof SysadminCatalogFunctionsIndexRoute
}

const SysadminCatalogFunctionsRouteChildren: SysadminCatalogFunctionsRouteChildren =
  {
    SysadminCatalogFunctionsNewRoute: SysadminCatalogFunctionsNewRoute,
    SysadminCatalogFunctionsIndexRoute: SysadminCatalogFunctionsIndexRoute,
  }

const SysadminCatalogFunctionsRouteWithChildren =
  SysadminCatalogFunctionsRoute._addFileChildren(
    SysadminCatalogFunctionsRouteChildren,
  )

interface SysadminCatalogMcpRouteChildren {
  SysadminCatalogMcpIdRoute: typeof SysadminCatalogMcpIdRoute
  SysadminCatalogMcpNewRoute: typeof SysadminCatalogMcpNewRoute
  SysadminCatalogMcpIndexRoute: typeof SysadminCatalogMcpIndexRoute
}

const SysadminCatalogMcpRouteChildren: SysadminCatalogMcpRouteChildren = {
  SysadminCatalogMcpIdRoute: SysadminCatalogMcpIdRoute,
  SysadminCatalogMcpNewRoute: SysadminCatalogMcpNewRoute,
  SysadminCatalogMcpIndexRoute: SysadminCatalogMcpIndexRoute,
}

const SysadminCatalogMcpRouteWithChildren =
  SysadminCatalogMcpRoute._addFileChildren(SysadminCatalogMcpRouteChildren)

interface SysadminCatalogSkillsRouteChildren {
  SysadminCatalogSkillsIdRoute: typeof SysadminCatalogSkillsIdRoute
  SysadminCatalogSkillsIndexRoute: typeof SysadminCatalogSkillsIndexRoute
}

const SysadminCatalogSkillsRouteChildren: SysadminCatalogSkillsRouteChildren = {
  SysadminCatalogSkillsIdRoute: SysadminCatalogSkillsIdRoute,
  SysadminCatalogSkillsIndexRoute: SysadminCatalogSkillsIndexRoute,
}

const SysadminCatalogSkillsRouteWithChildren =
  SysadminCatalogSkillsRoute._addFileChildren(
    SysadminCatalogSkillsRouteChildren,
  )

interface SysadminCatalogToolsRouteChildren {
  SysadminCatalogToolsIdRoute: typeof SysadminCatalogToolsIdRoute
  SysadminCatalogToolsNewRoute: typeof SysadminCatalogToolsNewRoute
  SysadminCatalogToolsIndexRoute: typeof SysadminCatalogToolsIndexRoute
}

const SysadminCatalogToolsRouteChildren: SysadminCatalogToolsRouteChildren = {
  SysadminCatalogToolsIdRoute: SysadminCatalogToolsIdRoute,
  SysadminCatalogToolsNewRoute: SysadminCatalogToolsNewRoute,
  SysadminCatalogToolsIndexRoute: SysadminCatalogToolsIndexRoute,
}

const SysadminCatalogToolsRouteWithChildren =
  SysadminCatalogToolsRoute._addFileChildren(SysadminCatalogToolsRouteChildren)

interface SysadminCatalogWorkflowsRouteChildren {
  SysadminCatalogWorkflowsIdRoute: typeof SysadminCatalogWorkflowsIdRoute
  SysadminCatalogWorkflowsIndexRoute: typeof SysadminCatalogWorkflowsIndexRoute
}

const SysadminCatalogWorkflowsRouteChildren: SysadminCatalogWorkflowsRouteChildren =
  {
    SysadminCatalogWorkflowsIdRoute: SysadminCatalogWorkflowsIdRoute,
    SysadminCatalogWorkflowsIndexRoute: SysadminCatalogWorkflowsIndexRoute,
  }

const SysadminCatalogWorkflowsRouteWithChildren =
  SysadminCatalogWorkflowsRoute._addFileChildren(
    SysadminCatalogWorkflowsRouteChildren,
  )

interface SysadminCatalogRouteChildren {
  SysadminCatalogAgentsRoute: typeof SysadminCatalogAgentsRouteWithChildren
  SysadminCatalogArgusLiveRoute: typeof SysadminCatalogArgusLiveRouteWithChildren
  SysadminCatalogAssignmentsRoute: typeof SysadminCatalogAssignmentsRoute
  SysadminCatalogFunctionsRoute: typeof SysadminCatalogFunctionsRouteWithChildren
  SysadminCatalogKnowledgeRoute: typeof SysadminCatalogKnowledgeRoute
  SysadminCatalogMcpRoute: typeof SysadminCatalogMcpRouteWithChildren
  SysadminCatalogModelsRoute: typeof SysadminCatalogModelsRoute
  SysadminCatalogPromptsRoute: typeof SysadminCatalogPromptsRoute
  SysadminCatalogSkillsRoute: typeof SysadminCatalogSkillsRouteWithChildren
  SysadminCatalogToolsRoute: typeof SysadminCatalogToolsRouteWithChildren
  SysadminCatalogWorkflowsRoute: typeof SysadminCatalogWorkflowsRouteWithChildren
  SysadminCatalogIndexRoute: typeof SysadminCatalogIndexRoute
}

const SysadminCatalogRouteChildren: SysadminCatalogRouteChildren = {
  SysadminCatalogAgentsRoute: SysadminCatalogAgentsRouteWithChildren,
  SysadminCatalogArgusLiveRoute: SysadminCatalogArgusLiveRouteWithChildren,
  SysadminCatalogAssignmentsRoute: SysadminCatalogAssignmentsRoute,
  SysadminCatalogFunctionsRoute: SysadminCatalogFunctionsRouteWithChildren,
  SysadminCatalogKnowledgeRoute: SysadminCatalogKnowledgeRoute,
  SysadminCatalogMcpRoute: SysadminCatalogMcpRouteWithChildren,
  SysadminCatalogModelsRoute: SysadminCatalogModelsRoute,
  SysadminCatalogPromptsRoute: SysadminCatalogPromptsRoute,
  SysadminCatalogSkillsRoute: SysadminCatalogSkillsRouteWithChildren,
  SysadminCatalogToolsRoute: SysadminCatalogToolsRouteWithChildren,
  SysadminCatalogWorkflowsRoute: SysadminCatalogWorkflowsRouteWithChildren,
  SysadminCatalogIndexRoute: SysadminCatalogIndexRoute,
}

const SysadminCatalogRouteWithChildren = SysadminCatalogRoute._addFileChildren(
  SysadminCatalogRouteChildren,
)

interface SysadminFineTuningRouteChildren {
  SysadminFineTuningAdaptersRoute: typeof SysadminFineTuningAdaptersRoute
  SysadminFineTuningEvaluationRoute: typeof SysadminFineTuningEvaluationRoute
  SysadminFineTuningGoldenSetRoute: typeof SysadminFineTuningGoldenSetRoute
  SysadminFineTuningTrainingDataRoute: typeof SysadminFineTuningTrainingDataRoute
  SysadminFineTuningIndexRoute: typeof SysadminFineTuningIndexRoute
}

const SysadminFineTuningRouteChildren: SysadminFineTuningRouteChildren = {
  SysadminFineTuningAdaptersRoute: SysadminFineTuningAdaptersRoute,
  SysadminFineTuningEvaluationRoute: SysadminFineTuningEvaluationRoute,
  SysadminFineTuningGoldenSetRoute: SysadminFineTuningGoldenSetRoute,
  SysadminFineTuningTrainingDataRoute: SysadminFineTuningTrainingDataRoute,
  SysadminFineTuningIndexRoute: SysadminFineTuningIndexRoute,
}

const SysadminFineTuningRouteWithChildren =
  SysadminFineTuningRoute._addFileChildren(SysadminFineTuningRouteChildren)

interface SysadminGovernanceRouteChildren {
  SysadminGovernanceApprovalsRoute: typeof SysadminGovernanceApprovalsRoute
  SysadminGovernanceClassificationRoute: typeof SysadminGovernanceClassificationRoute
  SysadminGovernanceComplianceRoute: typeof SysadminGovernanceComplianceRoute
  SysadminGovernanceGuardrailsRoute: typeof SysadminGovernanceGuardrailsRoute
  SysadminGovernancePiiRoute: typeof SysadminGovernancePiiRoute
  SysadminGovernanceIndexRoute: typeof SysadminGovernanceIndexRoute
}

const SysadminGovernanceRouteChildren: SysadminGovernanceRouteChildren = {
  SysadminGovernanceApprovalsRoute: SysadminGovernanceApprovalsRoute,
  SysadminGovernanceClassificationRoute: SysadminGovernanceClassificationRoute,
  SysadminGovernanceComplianceRoute: SysadminGovernanceComplianceRoute,
  SysadminGovernanceGuardrailsRoute: SysadminGovernanceGuardrailsRoute,
  SysadminGovernancePiiRoute: SysadminGovernancePiiRoute,
  SysadminGovernanceIndexRoute: SysadminGovernanceIndexRoute,
}

const SysadminGovernanceRouteWithChildren =
  SysadminGovernanceRoute._addFileChildren(SysadminGovernanceRouteChildren)

interface SysadminLibraryRouteChildren {
  SysadminLibraryArticlesRoute: typeof SysadminLibraryArticlesRoute
  SysadminLibraryDocumentFoldersRoute: typeof SysadminLibraryDocumentFoldersRoute
  SysadminLibraryDocumentsRoute: typeof SysadminLibraryDocumentsRoute
  SysadminLibraryFoldersRoute: typeof SysadminLibraryFoldersRoute
  SysadminLibrarySourcesRoute: typeof SysadminLibrarySourcesRoute
  SysadminLibraryTagsRoute: typeof SysadminLibraryTagsRoute
  SysadminLibraryIndexRoute: typeof SysadminLibraryIndexRoute
}

const SysadminLibraryRouteChildren: SysadminLibraryRouteChildren = {
  SysadminLibraryArticlesRoute: SysadminLibraryArticlesRoute,
  SysadminLibraryDocumentFoldersRoute: SysadminLibraryDocumentFoldersRoute,
  SysadminLibraryDocumentsRoute: SysadminLibraryDocumentsRoute,
  SysadminLibraryFoldersRoute: SysadminLibraryFoldersRoute,
  SysadminLibrarySourcesRoute: SysadminLibrarySourcesRoute,
  SysadminLibraryTagsRoute: SysadminLibraryTagsRoute,
  SysadminLibraryIndexRoute: SysadminLibraryIndexRoute,
}

const SysadminLibraryRouteWithChildren = SysadminLibraryRoute._addFileChildren(
  SysadminLibraryRouteChildren,
)

interface SysadminModelsRouteChildren {
  SysadminModelsIdRoute: typeof SysadminModelsIdRoute
  SysadminModelsAssignmentsRoute: typeof SysadminModelsAssignmentsRoute
  SysadminModelsFunctionsRoute: typeof SysadminModelsFunctionsRoute
  SysadminModelsHistoryRoute: typeof SysadminModelsHistoryRoute
  SysadminModelsNewRoute: typeof SysadminModelsNewRoute
  SysadminModelsRuntimeRoute: typeof SysadminModelsRuntimeRoute
  SysadminModelsTrustTogglesRoute: typeof SysadminModelsTrustTogglesRoute
  SysadminModelsIndexRoute: typeof SysadminModelsIndexRoute
}

const SysadminModelsRouteChildren: SysadminModelsRouteChildren = {
  SysadminModelsIdRoute: SysadminModelsIdRoute,
  SysadminModelsAssignmentsRoute: SysadminModelsAssignmentsRoute,
  SysadminModelsFunctionsRoute: SysadminModelsFunctionsRoute,
  SysadminModelsHistoryRoute: SysadminModelsHistoryRoute,
  SysadminModelsNewRoute: SysadminModelsNewRoute,
  SysadminModelsRuntimeRoute: SysadminModelsRuntimeRoute,
  SysadminModelsTrustTogglesRoute: SysadminModelsTrustTogglesRoute,
  SysadminModelsIndexRoute: SysadminModelsIndexRoute,
}

const SysadminModelsRouteWithChildren = SysadminModelsRoute._addFileChildren(
  SysadminModelsRouteChildren,
)

interface SysadminPlatformRouteChildren {
  SysadminPlatformAirgapRoute: typeof SysadminPlatformAirgapRoute
  SysadminPlatformBackupsRoute: typeof SysadminPlatformBackupsRoute
  SysadminPlatformBuilderAnalyticsRoute: typeof SysadminPlatformBuilderAnalyticsRoute
  SysadminPlatformDeploymentRoute: typeof SysadminPlatformDeploymentRoute
  SysadminPlatformHardwareProfilesRoute: typeof SysadminPlatformHardwareProfilesRoute
  SysadminPlatformHelperBudgetsRoute: typeof SysadminPlatformHelperBudgetsRoute
  SysadminPlatformKeysRoute: typeof SysadminPlatformKeysRoute
  SysadminPlatformLicenseRoute: typeof SysadminPlatformLicenseRoute
  SysadminPlatformUpdatesRoute: typeof SysadminPlatformUpdatesRoute
  SysadminPlatformIndexRoute: typeof SysadminPlatformIndexRoute
}

const SysadminPlatformRouteChildren: SysadminPlatformRouteChildren = {
  SysadminPlatformAirgapRoute: SysadminPlatformAirgapRoute,
  SysadminPlatformBackupsRoute: SysadminPlatformBackupsRoute,
  SysadminPlatformBuilderAnalyticsRoute: SysadminPlatformBuilderAnalyticsRoute,
  SysadminPlatformDeploymentRoute: SysadminPlatformDeploymentRoute,
  SysadminPlatformHardwareProfilesRoute: SysadminPlatformHardwareProfilesRoute,
  SysadminPlatformHelperBudgetsRoute: SysadminPlatformHelperBudgetsRoute,
  SysadminPlatformKeysRoute: SysadminPlatformKeysRoute,
  SysadminPlatformLicenseRoute: SysadminPlatformLicenseRoute,
  SysadminPlatformUpdatesRoute: SysadminPlatformUpdatesRoute,
  SysadminPlatformIndexRoute: SysadminPlatformIndexRoute,
}

const SysadminPlatformRouteWithChildren =
  SysadminPlatformRoute._addFileChildren(SysadminPlatformRouteChildren)

interface SysadminRuntimeRouteChildren {
  SysadminRuntimeHardwareRoute: typeof SysadminRuntimeHardwareRoute
  SysadminRuntimeHealthRoute: typeof SysadminRuntimeHealthRoute
  SysadminRuntimeInferenceRoute: typeof SysadminRuntimeInferenceRoute
  SysadminRuntimeMcpRoute: typeof SysadminRuntimeMcpRoute
  SysadminRuntimeQueuesRoute: typeof SysadminRuntimeQueuesRoute
  SysadminRuntimeStorageRoute: typeof SysadminRuntimeStorageRoute
  SysadminRuntimeIndexRoute: typeof SysadminRuntimeIndexRoute
}

const SysadminRuntimeRouteChildren: SysadminRuntimeRouteChildren = {
  SysadminRuntimeHardwareRoute: SysadminRuntimeHardwareRoute,
  SysadminRuntimeHealthRoute: SysadminRuntimeHealthRoute,
  SysadminRuntimeInferenceRoute: SysadminRuntimeInferenceRoute,
  SysadminRuntimeMcpRoute: SysadminRuntimeMcpRoute,
  SysadminRuntimeQueuesRoute: SysadminRuntimeQueuesRoute,
  SysadminRuntimeStorageRoute: SysadminRuntimeStorageRoute,
  SysadminRuntimeIndexRoute: SysadminRuntimeIndexRoute,
}

const SysadminRuntimeRouteWithChildren = SysadminRuntimeRoute._addFileChildren(
  SysadminRuntimeRouteChildren,
)

interface SysadminSettingsRouteChildren {
  SysadminSettingsApiRoute: typeof SysadminSettingsApiRoute
  SysadminSettingsEmailRoute: typeof SysadminSettingsEmailRoute
  SysadminSettingsIdpRoute: typeof SysadminSettingsIdpRoute
  SysadminSettingsNotificationsRoute: typeof SysadminSettingsNotificationsRoute
  SysadminSettingsIndexRoute: typeof SysadminSettingsIndexRoute
}

const SysadminSettingsRouteChildren: SysadminSettingsRouteChildren = {
  SysadminSettingsApiRoute: SysadminSettingsApiRoute,
  SysadminSettingsEmailRoute: SysadminSettingsEmailRoute,
  SysadminSettingsIdpRoute: SysadminSettingsIdpRoute,
  SysadminSettingsNotificationsRoute: SysadminSettingsNotificationsRoute,
  SysadminSettingsIndexRoute: SysadminSettingsIndexRoute,
}

const SysadminSettingsRouteWithChildren =
  SysadminSettingsRoute._addFileChildren(SysadminSettingsRouteChildren)

interface SysadminStudioRouteChildren {
  SysadminStudioAgentsRoute: typeof SysadminStudioAgentsRoute
  SysadminStudioCategoriesRoute: typeof SysadminStudioCategoriesRoute
  SysadminStudioPromptsRoute: typeof SysadminStudioPromptsRoute
  SysadminStudioSkillsRoute: typeof SysadminStudioSkillsRoute
  SysadminStudioToolsRoute: typeof SysadminStudioToolsRoute
  SysadminStudioIndexRoute: typeof SysadminStudioIndexRoute
}

const SysadminStudioRouteChildren: SysadminStudioRouteChildren = {
  SysadminStudioAgentsRoute: SysadminStudioAgentsRoute,
  SysadminStudioCategoriesRoute: SysadminStudioCategoriesRoute,
  SysadminStudioPromptsRoute: SysadminStudioPromptsRoute,
  SysadminStudioSkillsRoute: SysadminStudioSkillsRoute,
  SysadminStudioToolsRoute: SysadminStudioToolsRoute,
  SysadminStudioIndexRoute: SysadminStudioIndexRoute,
}

const SysadminStudioRouteWithChildren = SysadminStudioRoute._addFileChildren(
  SysadminStudioRouteChildren,
)

interface SysadminTenantsTenantIdRouteChildren {
  SysadminTenantsTenantIdAssignmentsRoute: typeof SysadminTenantsTenantIdAssignmentsRoute
  SysadminTenantsTenantIdAuditRoute: typeof SysadminTenantsTenantIdAuditRoute
  SysadminTenantsTenantIdBrandingRoute: typeof SysadminTenantsTenantIdBrandingRoute
  SysadminTenantsTenantIdComplianceRoute: typeof SysadminTenantsTenantIdComplianceRoute
  SysadminTenantsTenantIdHardwareRoute: typeof SysadminTenantsTenantIdHardwareRoute
  SysadminTenantsTenantIdLimitsRoute: typeof SysadminTenantsTenantIdLimitsRoute
  SysadminTenantsTenantIdMemoryRoute: typeof SysadminTenantsTenantIdMemoryRoute
  SysadminTenantsTenantIdSettingsRoute: typeof SysadminTenantsTenantIdSettingsRoute
  SysadminTenantsTenantIdUsersRoute: typeof SysadminTenantsTenantIdUsersRoute
  SysadminTenantsTenantIdIndexRoute: typeof SysadminTenantsTenantIdIndexRoute
}

const SysadminTenantsTenantIdRouteChildren: SysadminTenantsTenantIdRouteChildren =
  {
    SysadminTenantsTenantIdAssignmentsRoute:
      SysadminTenantsTenantIdAssignmentsRoute,
    SysadminTenantsTenantIdAuditRoute: SysadminTenantsTenantIdAuditRoute,
    SysadminTenantsTenantIdBrandingRoute: SysadminTenantsTenantIdBrandingRoute,
    SysadminTenantsTenantIdComplianceRoute:
      SysadminTenantsTenantIdComplianceRoute,
    SysadminTenantsTenantIdHardwareRoute: SysadminTenantsTenantIdHardwareRoute,
    SysadminTenantsTenantIdLimitsRoute: SysadminTenantsTenantIdLimitsRoute,
    SysadminTenantsTenantIdMemoryRoute: SysadminTenantsTenantIdMemoryRoute,
    SysadminTenantsTenantIdSettingsRoute: SysadminTenantsTenantIdSettingsRoute,
    SysadminTenantsTenantIdUsersRoute: SysadminTenantsTenantIdUsersRoute,
    SysadminTenantsTenantIdIndexRoute: SysadminTenantsTenantIdIndexRoute,
  }

const SysadminTenantsTenantIdRouteWithChildren =
  SysadminTenantsTenantIdRoute._addFileChildren(
    SysadminTenantsTenantIdRouteChildren,
  )

interface SysadminTenantsRouteChildren {
  SysadminTenantsTenantIdRoute: typeof SysadminTenantsTenantIdRouteWithChildren
  SysadminTenantsIndexRoute: typeof SysadminTenantsIndexRoute
}

const SysadminTenantsRouteChildren: SysadminTenantsRouteChildren = {
  SysadminTenantsTenantIdRoute: SysadminTenantsTenantIdRouteWithChildren,
  SysadminTenantsIndexRoute: SysadminTenantsIndexRoute,
}

const SysadminTenantsRouteWithChildren = SysadminTenantsRoute._addFileChildren(
  SysadminTenantsRouteChildren,
)

interface SysadminRouteChildren {
  SysadminAdministratorsRoute: typeof SysadminAdministratorsRouteWithChildren
  SysadminAdminsRoute: typeof SysadminAdminsRoute
  SysadminAuditRoute: typeof SysadminAuditRouteWithChildren
  SysadminAuditChainRoute: typeof SysadminAuditChainRoute
  SysadminBrandingRoute: typeof SysadminBrandingRoute
  SysadminCatalogRoute: typeof SysadminCatalogRouteWithChildren
  SysadminFineTuningRoute: typeof SysadminFineTuningRouteWithChildren
  SysadminGovernanceRoute: typeof SysadminGovernanceRouteWithChildren
  SysadminLibraryRoute: typeof SysadminLibraryRouteWithChildren
  SysadminModelsRoute: typeof SysadminModelsRouteWithChildren
  SysadminPlatformRoute: typeof SysadminPlatformRouteWithChildren
  SysadminRuntimeRoute: typeof SysadminRuntimeRouteWithChildren
  SysadminSettingsRoute: typeof SysadminSettingsRouteWithChildren
  SysadminStudioRoute: typeof SysadminStudioRouteWithChildren
  SysadminTenantsRoute: typeof SysadminTenantsRouteWithChildren
  SysadminIndexRoute: typeof SysadminIndexRoute
}

const SysadminRouteChildren: SysadminRouteChildren = {
  SysadminAdministratorsRoute: SysadminAdministratorsRouteWithChildren,
  SysadminAdminsRoute: SysadminAdminsRoute,
  SysadminAuditRoute: SysadminAuditRouteWithChildren,
  SysadminAuditChainRoute: SysadminAuditChainRoute,
  SysadminBrandingRoute: SysadminBrandingRoute,
  SysadminCatalogRoute: SysadminCatalogRouteWithChildren,
  SysadminFineTuningRoute: SysadminFineTuningRouteWithChildren,
  SysadminGovernanceRoute: SysadminGovernanceRouteWithChildren,
  SysadminLibraryRoute: SysadminLibraryRouteWithChildren,
  SysadminModelsRoute: SysadminModelsRouteWithChildren,
  SysadminPlatformRoute: SysadminPlatformRouteWithChildren,
  SysadminRuntimeRoute: SysadminRuntimeRouteWithChildren,
  SysadminSettingsRoute: SysadminSettingsRouteWithChildren,
  SysadminStudioRoute: SysadminStudioRouteWithChildren,
  SysadminTenantsRoute: SysadminTenantsRouteWithChildren,
  SysadminIndexRoute: SysadminIndexRoute,
}

const SysadminRouteWithChildren = SysadminRoute._addFileChildren(
  SysadminRouteChildren,
)

interface TrustRouteChildren {
  TrustActivityRoute: typeof TrustActivityRoute
  TrustAiSystemsRoute: typeof TrustAiSystemsRoute
  TrustAuditRoute: typeof TrustAuditRoute
  TrustDataFlowsRoute: typeof TrustDataFlowsRoute
  TrustEvidenceRoute: typeof TrustEvidenceRoute
  TrustViolationsRoute: typeof TrustViolationsRoute
  TrustIndexRoute: typeof TrustIndexRoute
  TrustFrameworksFrameworkIdRoute: typeof TrustFrameworksFrameworkIdRoute
  TrustFrameworksIndexRoute: typeof TrustFrameworksIndexRoute
}

const TrustRouteChildren: TrustRouteChildren = {
  TrustActivityRoute: TrustActivityRoute,
  TrustAiSystemsRoute: TrustAiSystemsRoute,
  TrustAuditRoute: TrustAuditRoute,
  TrustDataFlowsRoute: TrustDataFlowsRoute,
  TrustEvidenceRoute: TrustEvidenceRoute,
  TrustViolationsRoute: TrustViolationsRoute,
  TrustIndexRoute: TrustIndexRoute,
  TrustFrameworksFrameworkIdRoute: TrustFrameworksFrameworkIdRoute,
  TrustFrameworksIndexRoute: TrustFrameworksIndexRoute,
}

const TrustRouteWithChildren = TrustRoute._addFileChildren(TrustRouteChildren)

interface UsersGroupsRouteChildren {
  UsersGroupsGroupIdRoute: typeof UsersGroupsGroupIdRoute
}

const UsersGroupsRouteChildren: UsersGroupsRouteChildren = {
  UsersGroupsGroupIdRoute: UsersGroupsGroupIdRoute,
}

const UsersGroupsRouteWithChildren = UsersGroupsRoute._addFileChildren(
  UsersGroupsRouteChildren,
)

interface UsersRouteChildren {
  UsersUserIdRoute: typeof UsersUserIdRoute
  UsersActivityRoute: typeof UsersActivityRoute
  UsersDepartmentsRoute: typeof UsersDepartmentsRoute
  UsersGroupsRoute: typeof UsersGroupsRouteWithChildren
  UsersInvitationsRoute: typeof UsersInvitationsRoute
  UsersRolesRoute: typeof UsersRolesRoute
  UsersSsoRoute: typeof UsersSsoRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

const UsersRouteChildren: UsersRouteChildren = {
  UsersUserIdRoute: UsersUserIdRoute,
  UsersActivityRoute: UsersActivityRoute,
  UsersDepartmentsRoute: UsersDepartmentsRoute,
  UsersGroupsRoute: UsersGroupsRouteWithChildren,
  UsersInvitationsRoute: UsersInvitationsRoute,
  UsersRolesRoute: UsersRolesRoute,
  UsersSsoRoute: UsersSsoRoute,
  UsersIndexRoute: UsersIndexRoute,
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

interface ArgusLiveDashboardsIdRouteChildren {
  ArgusLiveDashboardsIdEditRoute: typeof ArgusLiveDashboardsIdEditRoute
  ArgusLiveDashboardsIdIndexRoute: typeof ArgusLiveDashboardsIdIndexRoute
}

const ArgusLiveDashboardsIdRouteChildren: ArgusLiveDashboardsIdRouteChildren = {
  ArgusLiveDashboardsIdEditRoute: ArgusLiveDashboardsIdEditRoute,
  ArgusLiveDashboardsIdIndexRoute: ArgusLiveDashboardsIdIndexRoute,
}

const ArgusLiveDashboardsIdRouteWithChildren =
  ArgusLiveDashboardsIdRoute._addFileChildren(
    ArgusLiveDashboardsIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRouteWithChildren,
  AgentsRoute: AgentsRouteWithChildren,
  AnalyticsRoute: AnalyticsRoute,
  ApprovalsRoute: ApprovalsRouteWithChildren,
  AskArgusRoute: AskArgusRouteWithChildren,
  AutomateRoute: AutomateRouteWithChildren,
  BrandingRoute: BrandingRoute,
  ConnectionsRoute: ConnectionsRouteWithChildren,
  EvaluationRoute: EvaluationRoute,
  HelpRoute: HelpRoute,
  InsightsRoute: InsightsRouteWithChildren,
  LibraryRoute: LibraryRouteWithChildren,
  LoginRoute: LoginRoute,
  McpRoute: McpRoute,
  ModelsRoute: ModelsRoute,
  OrganizationProfilesRoute: OrganizationProfilesRoute,
  OrganizationsRoute: OrganizationsRouteWithChildren,
  PlaygroundRoute: PlaygroundRoute,
  RolesRoute: RolesRoute,
  SecurityRoute: SecurityRoute,
  SettingsRoute: SettingsRoute,
  StudioRoute: StudioRouteWithChildren,
  SysadminRoute: SysadminRouteWithChildren,
  TrustRoute: TrustRouteWithChildren,
  UsersRoute: UsersRouteWithChildren,
  WorkspaceRoute: WorkspaceRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InviteTokenRoute: InviteTokenRoute,
  SetupTokenRoute: SetupTokenRoute,
  SharedTokenRoute: SharedTokenRoute,
  ArgusLiveIndexRoute: ArgusLiveIndexRoute,
  SetupIndexRoute: SetupIndexRoute,
  ArgusLiveDashboardsIdRoute: ArgusLiveDashboardsIdRouteWithChildren,
  ArgusLiveDashboardsNewRoute: ArgusLiveDashboardsNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
